import React from "react";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import request from "superagent";

import env from "../constants/env";

import { Checkbox, Button } from "react-bootstrap";

import { uploadAiFile } from "../actions/portalActions";
import { getJwtToken } from "../actions/user";
import {
	assistantsFilesCreate,
	assistantsFilesDelete,
	filesDelete,
	getAudioTranscriptionsLambda,
	getChatCompletionsLambda,
	getImageDescriptionsLambda,
	getPdfResponsesLambda,
	getResponsesCreateLambda,
	getContentStreamed
} from "../ai/aiAssistant";
import { copyToClipboard, createMarkupForLabel } from "../utils/utils";
import { refreshCredentials } from "../utils/securityUtil";
import {
	buildDraftAssistantPrompt,
	buildScriptAssistantPrompt,
	DRAFT_ASSISTANT_MODE_FIELD_TEXT,
	DRAFT_RESPONSE_FORMAT_CANDIDATES,
	DRAFT_RESPONSE_FORMAT_MARKDOWN_BULLETS,
	DEFAULT_ASSISTANT_CHAT_MODEL,
	extractCodeFromAssistantResponse,
	SCRIPT_ASSISTANT_MODE_FUNCTIONS,
	SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER
} from "../ai/assistantPromptBuilder";
import { buildAuthoringGuideSections, loadAuthoringGuideDocuments, parseAuthoringReference } from "../ai/authoringGuideContext";
import { getMediaType } from "../utils/mediaUtils";
import { transformFromChecklistEntities, transformToChecklistEntities } from "../utils/transformUtils.js";
import {
	applySubtreeSpecV1,
	checklistPathToTreePath,
	coerceSubtreeSpecV1,
	getStructureNodeAtPath,
	inferStructureStudioIntent,
	normalizeGeneratedSubtreeSpecV1,
	projectChecklistToStructureV1,
	resolveStructureStudioApplyChoices,
	treePathToChecklistPath
} from "../utils/structureStudioUtils.js";
import { applyAiBulkEditInstructions, generateAiBulkEditInstructions, handleSelectNodeAtPath, resetTree, saveUndoState } from "../actions/actions.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as smd from "../../node_modules/streaming-markdown/smd.js";

import state from "../state/state.js";
import { getOrgId } from "../actions/orgsActions.js";

let parser;
const AUTHORING_CONTEXT_INDEX_URL = "/assistant-context/assistant-context.index.json";
const AUTHORING_CONTEXT_SUMMARY_URL = "/assistant-context/assistant-context.summary.md";
const MAX_AUTHORING_CONTEXT_CHARS = 24000;
const MAX_AUTHORING_MATCHED_PROPERTIES = 28;
const MAX_AUTHORING_METHODS = 70;
const MAX_SCRIPT_CONTEXT_CHARS = 7000;
const MAX_SCRIPT_FUNCTIONS_CHARS = 2200;
const MAX_SCRIPT_VALUE_TRIGGER_CHARS = 420;
const MAX_SCRIPT_VALUE_TRIGGER_ENTRIES = 24;
// Quick UX fix: keep spinner visible longer during slow/uneven streaming responses.
const STREAM_SETTLE_DELAY_MS = 5000;
const MAX_WAIT_FOR_RESPONSE_MS = 180000;
const MAX_RESPONSE_SNIPPET_PREVIEW_CHARS = 1400;
const MAX_TRANSCRIPT_CONTEXT_CHARS = 120000;
const MAX_DRIVE_TRANSCRIPT_FOLLOWUP_CONTEXT_CHARS = 40000;
const MAX_DRIVE_TITLE_CHARS = 120;
const MAX_DRIVE_DESCRIPTION_CHARS = 600;
const MAX_DRIVE_METADATA_TRANSCRIPT_CHARS = 20000;
const MAX_IMAGE_DATA_URL_BYTES = 10 * 1024 * 1024;
const MAX_IMAGE_ANALYSIS_CONTEXT_CHARS = 24000;
const MAX_STRUCTURE_OUTLINE_SUMMARY_CHARS = 12000;
const MAX_STRUCTURE_OUTLINE_SUMMARY_NODES = 220;
const MAX_STRUCTURE_SELECTED_SUBTREE_CHARS = 8000;
const MAX_ACTIVITY_ANALYSIS_JSON_CHARS = 48000;
const MAX_ACTIVITY_ANALYSIS_VALUE_TRIGGER_CHARS = 9000;
const MAX_ACTIVITY_ANALYSIS_VALUE_TRIGGER_ENTRIES = 80;
const DRIVE_ASSET_ASSISTANT_MODE = "drive_asset";
const STRUCTURE_ASSISTANT_MODE = "structure";
const BULK_EDIT_ASSISTANT_MODE = "bulk_edit";
const ACTIVITY_ANALYSIS_ASSISTANT_MODE = "activity_analysis";
const DRIVE_TRANSCRIPT_RENDER_MODE_DECORATED = "decorated";
const DRIVE_TRANSCRIPT_RENDER_MODE_RAW = "raw";

class AiAssistant extends React.PureComponent {
	constructor(props, context) {
		super(props, context);

			this.state = {
				inputAiMessage: "",
				threadId: "",
				selectedActivityOrFiles: "org",
			authoringContextStatus: "idle",
			authoringContextError: "",
			isWaitingForResponse: false,
			hasReceivedResponseChunk: false,
			scriptContext: null,
			draftContext: null,
			structureContext: null,
			bulkEditContext: null,
			activeStructureContext: null,
			activeBulkEditContext: null,
			latestStructureSubtreeSpec: null,
			latestBulkEditInstructions: null,
			lastStructureGenerationMode: "",
				lastResponseMode: "",
				responseViewTab: "response",
				modePanelCollapsed: false,
				driveTranscriptRenderMode: DRIVE_TRANSCRIPT_RENDER_MODE_DECORATED,
				promptAttachmentFileIds: [],
				promptAttachmentLocalAssetsById: {},
				showPromptAttachmentPicker: false,
				isUploadingPromptAttachment: false,
				pendingModeCarryOverPrompt: null,
				queuedModeCarryOverByKey: {}
			};

		this.authoringContextIndex = null;
		this.authoringContextSummary = "";
		this.authoringContextLoadPromise = null;
		this.responseSettleTimeoutId = null;
		this.responseMaxWaitTimeoutId = null;
		this.lastHandledLaunchRequestId = "";
		this.lastFocusedExternalEditableElement = null;
		this.preferFocusedInputForDraftApply = false;
		this.conversationStateByKey = {};
		this.driveImageDataUrlCache = {};
		this.driveTranscriptCacheByConversationKey = {};
		this.lastAutoDriveModeSelectionKey = "";
		this.promptAttachmentUploadInputRef = null;

		this.handleDocumentFocusIn = this.handleDocumentFocusIn.bind(this);
	}

	getCurrentActivityId() {
		return this.props.activityId || state.get(["tree", "root", "id"]) || "";
	}

	isWritableExternalInputElement(target) {
		if (typeof document === "undefined") {
			return false;
		}
		if (!target || !document.body || !document.body.contains(target)) {
			return false;
		}
		if (this.assistantRootEl && this.assistantRootEl.contains(target)) {
			return false;
		}

		const tag = target.tagName ? target.tagName.toUpperCase() : "";
		if (tag !== "INPUT" && tag !== "TEXTAREA") {
			return false;
		}
		if (target.readOnly || target.disabled) {
			return false;
		}

		if (tag === "INPUT") {
			const inputType = (target.type || "").toLowerCase();
			const allowedTypes = ["", "text", "search", "url", "tel", "email", "password", "number"];
			if (allowedTypes.indexOf(inputType) === -1) {
				return false;
			}
		}

		return true;
	}

	getExternalContentEditableElement(target) {
		if (typeof document === "undefined") {
			return null;
		}
		if (!target || !document.body || !document.body.contains(target)) {
			return null;
		}

		let current = target;
		while (current && current !== document.body) {
			if (this.assistantRootEl && this.assistantRootEl.contains(current)) {
				return null;
			}
			if (current.isContentEditable) {
				return current;
			}
			current = current.parentElement;
		}

		return null;
	}

	getFocusedExternalEditableSource() {
		const inputTarget = this.getWritableFocusedInputTarget();
		if (inputTarget) {
			return {
				type: "input",
				element: inputTarget,
				value: typeof inputTarget.value === "string" ? inputTarget.value : ""
			};
		}

		if (typeof document === "undefined") {
			return null;
		}

		const candidates = [
			this.lastFocusedExternalEditableElement,
			document.activeElement
		];

		for (const candidate of candidates) {
			const editableTarget = this.getExternalContentEditableElement(candidate);
			if (!editableTarget || (this.assistantRootEl && this.assistantRootEl.contains(editableTarget))) {
				continue;
			}
			const value = typeof editableTarget.innerText === "string"
				? editableTarget.innerText
				: (typeof editableTarget.textContent === "string" ? editableTarget.textContent : "");
			return {
				type: "contentEditable",
				element: editableTarget,
				value: value || ""
			};
		}

		return null;
	}

	handleDocumentFocusIn(event) {
		const target = event && event.target ? event.target : null;
		if (!target) {
			return;
		}

		if (this.assistantRootEl && this.assistantRootEl.contains(target)) {
			return;
		}

		const isEditableInput = this.isWritableExternalInputElement(target);
		const contentEditableTarget = this.getExternalContentEditableElement(target);
		const isContentEditable = !!contentEditableTarget;
		if (!isEditableInput && !isContentEditable) {
			return;
		}

		const nextFocusedElement = isEditableInput ? target : contentEditableTarget;
		if (this.lastFocusedExternalEditableElement === nextFocusedElement) {
			return;
		}
		this.lastFocusedExternalEditableElement = nextFocusedElement;
	}

	isActivityModeEnabled() {
		if (typeof this.props.allowActivityMode === "boolean") {
			return this.props.allowActivityMode;
		}
		if (typeof window === "undefined" || !window.location) {
			return false;
		}
		return window.location.pathname.indexOf("/editor/") > -1;
	}

	isFilesModeEnabled() {
		if (typeof this.props.allowFilesMode === "boolean") {
			return this.props.allowFilesMode;
		}
		return this.isActivityModeEnabled();
	}

	isAuthoringModeEnabled() {
		if (typeof this.props.allowAuthoringMode === "boolean") {
			return this.props.allowAuthoringMode;
		}
		return this.isActivityModeEnabled();
	}

	isScriptFunctionsModeEnabled() {
		return this.isActivityModeEnabled() && this.getCurrentActivityId() !== "";
	}

	isScriptValueTriggerModeEnabled() {
		if (!this.isActivityModeEnabled() || this.getCurrentActivityId() === "") {
			return false;
		}
		if (this.state.scriptContext &&
			this.state.scriptContext.mode === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER &&
			Array.isArray(this.state.scriptContext.targetPath)) {
			return true;
		}
		const selectedNodePath = state.get(["selectedNodePath"]);
		if (!Array.isArray(selectedNodePath) || selectedNodePath.length === 0) {
			return false;
		}
		const selectedNode = state.get(selectedNodePath);
		return !!(selectedNode && selectedNode.entity && selectedNode.entity.type === "item");
	}

	isFieldDraftModeEnabled() {
		return this.isAuthoringModeEnabled();
	}

	getSelectedDriveAssetCursor() {
		const cursor = this.props.driveActiveCursor;
		if (!cursor) {
			return null;
		}
		const cursorType = typeof cursor.type === "string" ? cursor.type.toLowerCase() : "";
		if (cursorType === "folder") {
			return null;
		}
		const hasPath = (
			(typeof cursor.path === "string" && cursor.path.trim() !== "") ||
			(Array.isArray(cursor.path) && cursor.path.length > 0) ||
			(typeof cursor.fullPath === "string" && cursor.fullPath.trim() !== "")
		);
		const looksLikeFile = (
			cursorType === "file" ||
			cursor.isFile === true ||
			hasPath ||
			(typeof cursor.guid === "string" && cursor.guid.trim() !== "") ||
			(typeof cursor.name === "string" && cursor.name.trim() !== "")
		);
		if (!looksLikeFile) {
			return null;
		}
		return cursor;
	}

	getDriveSelectionKeyFromCursor(cursor = null) {
		const targetCursor = cursor || this.getSelectedDriveAssetCursor();
		if (!targetCursor) {
			return "";
		}
		return targetCursor.guid || targetCursor.path || targetCursor.fullPath || targetCursor.name || "";
	}

	shouldAutoSelectDriveAssetMode(selectionKey = "") {
		if (!selectionKey) {
			return false;
		}
		if (this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE) {
			this.lastAutoDriveModeSelectionKey = selectionKey;
			return false;
		}
		if (this.lastAutoDriveModeSelectionKey === selectionKey) {
			return false;
		}
		const availableModes = this.getAvailableModes();
		return availableModes.includes(DRIVE_ASSET_ASSISTANT_MODE);
	}

	getSelectedDriveAssetResource() {
		const cursor = this.getSelectedDriveAssetCursor();
		if (!cursor) {
			return null;
		}
		const guidToResource = this.props.driveGuidToResource && typeof this.props.driveGuidToResource === "object"
			? this.props.driveGuidToResource
			: {};
		const resource = (cursor.guid && guidToResource[cursor.guid]) ? guidToResource[cursor.guid] : {};
		const merged = {
			...resource,
			...cursor
		};

		if (!merged.name) {
			merged.name = cursor.name || resource.name || resource.fileName || "";
		}
		if (!merged.path) {
			merged.path = resource.path || cursor.path || resource.fullPath || cursor.fullPath || "";
		}
		if (!merged.fullPath) {
			merged.fullPath = resource.fullPath || cursor.fullPath || (typeof resource.path === "string" ? resource.path : "");
		}

		return merged;
	}

	getDriveAssetExtension(asset = null) {
		if (!asset) {
			return "";
		}
		if (typeof asset.ext === "string" && asset.ext.trim() !== "") {
			return asset.ext.trim().toLowerCase();
		}

		const candidates = [
			asset.name,
			asset.fileName,
			this.getDriveAssetPath(asset),
			asset.fullPath
		];
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			if (typeof candidate !== "string" || candidate.indexOf(".") === -1) {
				continue;
			}
			const sanitized = candidate.split("?")[0].split("#")[0];
			if (sanitized.indexOf(".") === -1) {
				continue;
			}
			const ext = sanitized.split(".").pop().trim().toLowerCase();
			if (ext) {
				return ext;
			}
		}
		return "";
	}

	getDriveAssetMediaType(asset = null) {
		const targetAsset = asset || this.getSelectedDriveAssetResource();
		const ext = this.getDriveAssetExtension(targetAsset);
		if (!ext) {
			return "file";
		}
		return getMediaType(ext) || "file";
	}

	getDriveAssetPath(asset = null) {
		const targetAsset = asset || this.getSelectedDriveAssetResource();
		if (!targetAsset) {
			return "";
		}
		if (Array.isArray(targetAsset.path)) {
			return targetAsset.path.join("/");
		}
		if (typeof targetAsset.path === "string") {
			return targetAsset.path;
		}
		if (Array.isArray(targetAsset._path)) {
			return targetAsset._path.join("/");
		}
		if (typeof targetAsset.fullPath === "string" && targetAsset.fullPath.trim() !== "") {
			return targetAsset.fullPath;
		}
		return "";
	}

	getDriveAssetUrl(asset = null) {
		const targetAsset = asset || this.getSelectedDriveAssetResource();
		const path = this.getDriveAssetPath(targetAsset);
		if (!path) {
			return "";
		}

		const isPrivate = path.indexOf("private/") === 0;
		const isPublic = path.indexOf("public/") === 0;
		if (!isPrivate && !isPublic) {
			return "";
		}

		const baseUrl = isPrivate ? env.cloudFront.assetUrls.private : env.cloudFront.assetUrls.public;
		let normalizedPath = path.replace(/^private\//, "").replace(/^public\//, "");
		const firstSegment = normalizedPath.split("/")[0] || "";
		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(firstSegment);
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				normalizedPath = `${orgId}/${normalizedPath}`;
			}
		}
		const revision = targetAsset && (targetAsset.revision || targetAsset.revisionTs || "");
		return `${baseUrl}/${normalizedPath}${revision ? `?v=${revision}` : ""}`;
	}

	getDriveAssetS3Key(asset = null) {
		const targetAsset = asset || this.getSelectedDriveAssetResource();
		let path = this.getDriveAssetPath(targetAsset);
		if (!path || typeof path !== "string") {
			return "";
		}

		path = path.trim().replace(/^\/+/, "");
		if (path === "") {
			return "";
		}

		const pathParts = path.split("/").filter(Boolean);
		if (pathParts.length < 2) {
			return path;
		}

		const rootSegment = pathParts[0];
		if (rootSegment !== "private" && rootSegment !== "public") {
			return path;
		}

		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[1] || "");
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				pathParts.splice(1, 0, orgId);
			}
		}

		return pathParts.join("/");
	}

	cleanDriveTagCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}

		let cleaned = value
			.replace(/^[-*•]\s+/, "")
			.replace(/^\d+\.\s+/, "")
			.replace(/^tags?\s*:\s*/i, "")
			.replace(/^["'`]+|["'`]+$/g, "")
			.replace(/\s+/g, " ")
			.trim();

		cleaned = cleaned.replace(/[;,.\-:]+$/g, "").trim();
		if (!cleaned) {
			return "";
		}
		if (cleaned.length > 80) {
			return "";
		}
		return cleaned;
	}

	getTagsFromAssistantResponse(responseText = "") {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return [];
		}

		const tags = [];
		const addTags = (entries = []) => {
			entries.forEach((entry) => {
				const cleaned = this.cleanDriveTagCandidate(entry);
				if (cleaned) {
					tags.push(cleaned);
				}
			});
		};

		const normalizedText = responseText
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.trim();
		const lines = normalizedText
			.split("\n")
			.map((line) => line.trim())
			.filter(Boolean);

		for (let i = 0; i < Math.min(lines.length, 12); i++) {
			const line = lines[i]
				.replace(/^assistant:\s*/i, "")
				.replace(/^tags?\s*:\s*/i, "");
			if (line.indexOf(",") > -1) {
				addTags(line.split(","));
				if (tags.length >= 2) {
					break;
				}
			}
		}

		if (tags.length === 0) {
			const bulletLines = lines.filter((line) => /^([-*•]|\d+\.)\s+/.test(line));
			if (bulletLines.length > 0) {
				addTags(bulletLines);
			}
		}

		if (tags.length === 0) {
			const bracketMatch = normalizedText.match(/\[([^\]]+)\]/);
			if (bracketMatch && bracketMatch[1]) {
				addTags(bracketMatch[1].split(","));
			}
		}

		if (tags.length === 0 && lines.length > 0) {
			addTags(lines[0].split(","));
		}

		const uniqueTags = [];
		const seen = new Set();
		tags.forEach((tag) => {
			const key = tag.toLowerCase();
			if (!seen.has(key)) {
				seen.add(key);
				uniqueTags.push(tag);
			}
		});
		return uniqueTags.slice(0, 30);
	}

	isLikelyDriveTagList(tags = []) {
		if (!Array.isArray(tags) || tags.length < 2) {
			return false;
		}
		return tags.every((tag) => {
			if (typeof tag !== "string") {
				return false;
			}
			if (tag.length > 40) {
				return false;
			}
			const wordCount = tag.split(/\s+/).filter(Boolean).length;
			return wordCount > 0 && wordCount <= 5;
		});
	}

	cleanDriveTitleCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, " ")
			.replace(/```[\s\S]*?```/g, " ")
			.replace(/^#+\s*/, "")
			.replace(/^[-*•]\s+/, "")
			.replace(/\[[0-9]+:[0-9]+†source\]/gi, " ")
			.replace(/\[(?:source|sources?)\]/gi, " ")
			.replace(/\s+/g, " ")
			.trim();
		if (!cleaned) {
			return "";
		}
		if (cleaned.length > MAX_DRIVE_TITLE_CHARS) {
			cleaned = cleaned.slice(0, MAX_DRIVE_TITLE_CHARS).trim();
		}
		return cleaned;
	}

	cleanDriveDescriptionCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.replace(/```[\s\S]*?```/g, " ")
			.replace(/\[[0-9]+:[0-9]+†source\]/gi, " ")
			.replace(/\[(?:source|sources?)\]/gi, " ")
			.replace(/\s+/g, " ")
			.trim();
		if (!cleaned) {
			return "";
		}
		if (cleaned.length > MAX_DRIVE_DESCRIPTION_CHARS) {
			cleaned = `${cleaned.slice(0, MAX_DRIVE_DESCRIPTION_CHARS - 3).trim()}...`;
		}
		return cleaned;
	}

	cleanDriveTranscriptCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}

		let cleaned = value
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.replace(/\[[0-9]+:[0-9]+†source\]/gi, " ")
			.replace(/\[(?:source|sources?)\]/gi, " ")
			.replace(/\n{3,}/g, "\n\n")
			.trim();

		if (!cleaned) {
			return "";
		}

		if (cleaned.length > MAX_DRIVE_METADATA_TRANSCRIPT_CHARS) {
			cleaned = cleaned.slice(0, MAX_DRIVE_METADATA_TRANSCRIPT_CHARS).trim();
		}

		return cleaned;
	}

	getDriveTitleAndDescriptionFromAssistantResponse(responseText = "") {
		const emptyResult = { title: "", description: "" };
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return emptyResult;
		}

		const normalized = responseText.trim();
		if (normalized[0] === "{") {
			try {
				const parsed = JSON.parse(normalized);
				if (parsed && typeof parsed === "object") {
					const titleCandidates = [
						parsed.title,
						parsed.name,
						parsed.headline,
						parsed.metaData && parsed.metaData.title,
						parsed.metadata && parsed.metadata.title
					];
					const descriptionCandidates = [
						parsed.description,
						parsed.summary,
						parsed.output_text,
						parsed.text,
						parsed.body,
						parsed.response && parsed.response.output_text
					];
					const title = this.cleanDriveTitleCandidate(titleCandidates.find((item) => typeof item === "string" && item.trim() !== "") || "");
					const description = this.cleanDriveDescriptionCandidate(descriptionCandidates.find((item) => typeof item === "string" && item.trim() !== "") || "");
					if (title || description) {
						return { title, description };
					}
				}
			} catch (_err) {
				// fall through to plain-text parsing
			}
		}

		const normalizedPlain = normalized
			.replace(/```[\s\S]*?```/g, " ")
			.replace(/\r\n/g, "\n")
			.trim();
		const titleLabelMatch = normalizedPlain.match(/(?:^|\n)\s*(?:#+\s*)?(?:title|name|headline)\s*:\s*(.+)/i);
		let title = this.cleanDriveTitleCandidate(titleLabelMatch && titleLabelMatch[1] ? titleLabelMatch[1] : "");
		const descriptionLabelMatch = normalizedPlain.match(/(?:^|\n)\s*(?:#+\s*)?(?:description|summary)\s*:\s*([\s\S]*?)(?=\n\s*(?:#+\s*)?(?:tags?|sources?|notes?|title|name|headline)\s*:|$)/i);
		let description = this.cleanDriveDescriptionCandidate(descriptionLabelMatch && descriptionLabelMatch[1] ? descriptionLabelMatch[1] : "");

		const lines = normalizedPlain.split("\n").map((line) => line.trim()).filter(Boolean);

		const textLines = [];
		lines.forEach((line) => {
			let cleanedLine = line
				.replace(/^assistant:\s*/i, "")
				.replace(/^you:\s*/i, "")
				.replace(/^#{1,6}\s*/, "")
				.replace(/^[-*•]\s+/, "")
				.replace(/^\d+\.\s+/, "")
				.trim();
			if (!cleanedLine) {
				return;
			}
			if (/^(title|name|headline)\s*:/i.test(cleanedLine)) {
				if (!title) {
					title = this.cleanDriveTitleCandidate(cleanedLine.replace(/^(title|name|headline)\s*:\s*/i, ""));
				}
				return;
			}
			if (/^(description|summary)\s*:/i.test(cleanedLine)) {
				cleanedLine = cleanedLine.replace(/^(description|summary)\s*:\s*/i, "").trim();
				if (!cleanedLine) {
					return;
				}
			}
			if (/^(source|sources)\s*:/i.test(cleanedLine)) {
				return;
			}
			if (/^(tags?)\s*:/i.test(cleanedLine)) {
				return;
			}
			if (/^(error report|error type|message|trace details?|type of error)\s*:?/i.test(cleanedLine)) {
				return;
			}
			textLines.push(cleanedLine);
		});

		if (!description) {
			description = this.cleanDriveDescriptionCandidate(textLines.join(" "));
		}
		if (!title && lines.length > 0) {
			title = this.cleanDriveTitleCandidate(lines[0]);
		}

		return { title, description };
	}

	getTitleFromAssistantResponse(responseText = "") {
		const structured = this.getDriveTitleAndDescriptionFromAssistantResponse(responseText);
		return structured.title || "";
	}

	getDescriptionFromAssistantResponse(responseText = "") {
		const structured = this.getDriveTitleAndDescriptionFromAssistantResponse(responseText);
		return structured.description || "";
	}

	getTranscriptFromAssistantResponse(responseText = "") {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return "";
		}

		const normalized = responseText.trim();
		if (normalized[0] === "{") {
			try {
				const parsed = JSON.parse(normalized);
				if (parsed && typeof parsed === "object") {
					const transcriptCandidates = [
						parsed.transcript,
						parsed.output_text,
						parsed.text,
						parsed.description,
						parsed.summary,
						parsed.body,
						parsed.response && parsed.response.output_text
					];
					const transcript = this.cleanDriveTranscriptCandidate(
						transcriptCandidates.find((item) => typeof item === "string" && item.trim() !== "") || ""
					);
					if (transcript) {
						return transcript;
					}
				}
			} catch (_err) {
				// fall through to plain-text parsing
			}
		}

		const structured = this.getDriveTitleAndDescriptionFromAssistantResponse(normalized);
		if (structured.description) {
			return this.cleanDriveTranscriptCandidate(structured.description);
		}

		return this.cleanDriveTranscriptCandidate(
			normalized
				.replace(/^assistant:\s*/i, "")
				.replace(/^you:\s*/i, "")
		);
	}

	isLikelyDriveTitle(title = "") {
		if (typeof title !== "string") {
			return false;
		}
		const text = title.trim();
		if (!text || text.length < 4 || text.length > MAX_DRIVE_TITLE_CHARS) {
			return false;
		}
		if (text.indexOf("\n") > -1 || text.indexOf("\r") > -1) {
			return false;
		}
		if (/^(title|name|headline|description)\s*:/i.test(text)) {
			return false;
		}
		if (/^(i\s+(cannot|can't|do not|don't|am unable to)\b)/i.test(text)) {
			return false;
		}
		if (/(https?:\/\/|www\.)/i.test(text)) {
			return false;
		}
		const words = text.split(/\s+/).filter(Boolean);
		return words.length > 0 && words.length <= 14;
	}

	isLikelyDriveDescription(description = "") {
		if (typeof description !== "string") {
			return false;
		}
		const text = description.trim();
		if (!text || text.length < 24 || text.length > MAX_DRIVE_DESCRIPTION_CHARS + 3) {
			return false;
		}
		if (/^(i\s+(cannot|can't|do not|don't|am unable to)\b)/i.test(text)) {
			return false;
		}
		if (/(cannot directly access|unable to (summarize|analyze|process)|audio file might be corrupted)/i.test(text)) {
			return false;
		}

		const commaParts = text.split(",").map((part) => part.trim()).filter(Boolean);
		if (commaParts.length >= 4 && commaParts.every((part) => part.length <= 30 && part.split(/\s+/).length <= 4)) {
			return false;
		}

		const wordCount = text.split(/\s+/).filter(Boolean).length;
		return wordCount >= 6;
	}

	isLikelyDriveTranscript(transcript = "") {
		if (typeof transcript !== "string") {
			return false;
		}
		const text = transcript.trim();
		if (!text || text.length < 24) {
			return false;
		}
		if (/^(i\s+(cannot|can't|do not|don't|am unable to)\b)/i.test(text)) {
			return false;
		}
		if (/^(error report|error type|message|trace details?|type of error)\s*:?/i.test(text)) {
			return false;
		}
		if (/(cannot directly access|unable to (summarize|analyze|process)|audio file might be corrupted)/i.test(text)) {
			return false;
		}
		const wordCount = text.split(/\s+/).filter(Boolean).length;
		return wordCount >= 6;
	}

	appendAssistantInfoMessage(message) {
		if (!message || typeof message !== "string") {
			return;
		}
		let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
		newData = newData + `\n\n<i style='color: #9fd3a9'>${message}</i>\n\n`;
		this.context.tree.set(["appState", "aiAssistantResponse"], newData);
	}

	async applyDriveTagsFromLatestResponse() {
		const asset = this.getSelectedDriveAssetResource();
		if (!asset) {
			this.appendAssistantErrorMessage("Select a Drive file before applying tags.");
			return;
		}

		if (this.state.isWaitingForResponse) {
			return;
		}

		const responseText = this.props.aiAssistantResponseLast || "";
		const tags = this.getTagsFromAssistantResponse(responseText);
		if (!Array.isArray(tags) || tags.length === 0 || !this.isLikelyDriveTagList(tags)) {
			this.appendAssistantErrorMessage("No tags were found in the latest response. Ask for tag generation first.");
			return;
		}

		const path = this.getDriveAssetPath(asset);
		const orgId = getOrgId();
		if (!path || !orgId) {
			this.appendAssistantErrorMessage("Unable to resolve Drive asset path or organization for tag update.");
			return;
		}

		const existingMetaData = (asset && asset.metaData && typeof asset.metaData === "object")
			? asset.metaData
			: {};
		const nextMetaData = {
			...existingMetaData,
			tags
		};

		this.startWaitingForResponse();
		try {
			await refreshCredentials();
			await request.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId,
					path,
					metaData: nextMetaData
				}));

			if (asset.guid) {
				const existingResource = this.context.tree.get(["drive", "guidToResource", asset.guid]) || {};
				this.context.tree.set(["drive", "guidToResource", asset.guid], {
					...existingResource,
					metaData: nextMetaData
				});
				const activeCursor = this.context.tree.get(["drive", "hierarchyActiveCursor"]);
				if (activeCursor && activeCursor.guid === asset.guid) {
					this.context.tree.set(["drive", "hierarchyActiveCursor"], {
						...activeCursor,
						metaData: nextMetaData
					});
				}
			}

			this.appendAssistantInfoMessage(`Saved ${tags.length} tag${tags.length === 1 ? "" : "s"} to Drive metadata.`);
		} catch (_err) {
			this.appendAssistantErrorMessage("Failed to save tags to the Drive file metadata.");
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async applyDriveDescriptionFromLatestResponse() {
		const asset = this.getSelectedDriveAssetResource();
		if (!asset) {
			this.appendAssistantErrorMessage("Select a Drive file before applying description.");
			return;
		}

		if (this.state.isWaitingForResponse) {
			return;
		}

		const responseText = this.props.aiAssistantResponseLast || "";
		const description = this.getDescriptionFromAssistantResponse(responseText);
		if (!this.isLikelyDriveDescription(description)) {
			this.appendAssistantErrorMessage("No usable description was found in the latest response. Ask for a concise description first.");
			return;
		}

		const path = this.getDriveAssetPath(asset);
		const orgId = getOrgId();
		if (!path || !orgId) {
			this.appendAssistantErrorMessage("Unable to resolve Drive asset path or organization for description update.");
			return;
		}

		const existingMetaData = (asset && asset.metaData && typeof asset.metaData === "object")
			? asset.metaData
			: {};
		const nextMetaData = {
			...existingMetaData,
			description
		};

		this.startWaitingForResponse();
		try {
			await refreshCredentials();
			await request.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId,
					path,
					metaData: nextMetaData
				}));

			if (asset.guid) {
				const existingResource = this.context.tree.get(["drive", "guidToResource", asset.guid]) || {};
				this.context.tree.set(["drive", "guidToResource", asset.guid], {
					...existingResource,
					metaData: nextMetaData
				});
				const activeCursor = this.context.tree.get(["drive", "hierarchyActiveCursor"]);
				if (activeCursor && activeCursor.guid === asset.guid) {
					this.context.tree.set(["drive", "hierarchyActiveCursor"], {
						...activeCursor,
						metaData: nextMetaData
					});
				}
			}

			this.appendAssistantInfoMessage("Saved description to Drive metadata.");
		} catch (_err) {
			this.appendAssistantErrorMessage("Failed to save description to the Drive file metadata.");
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async applyDriveTranscriptFromLatestResponse() {
		const asset = this.getSelectedDriveAssetResource();
		if (!asset) {
			this.appendAssistantErrorMessage("Select a Drive file before applying transcript.");
			return;
		}

		if (this.state.isWaitingForResponse) {
			return;
		}

		const responseText = this.props.aiAssistantResponseLast || "";
		const transcript = this.getTranscriptFromAssistantResponse(responseText);
		if (!this.isLikelyDriveTranscript(transcript)) {
			this.appendAssistantErrorMessage("No usable transcript text was found in the latest response.");
			return;
		}

		const path = this.getDriveAssetPath(asset);
		const orgId = getOrgId();
		if (!path || !orgId) {
			this.appendAssistantErrorMessage("Unable to resolve Drive asset path or organization for transcript update.");
			return;
		}

		const existingMetaData = (asset && asset.metaData && typeof asset.metaData === "object")
			? asset.metaData
			: {};
		const nextMetaData = {
			...existingMetaData,
			transcript
		};

		this.startWaitingForResponse();
		try {
			await refreshCredentials();
			await request.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId,
					path,
					metaData: nextMetaData
				}));

			if (asset.guid) {
				const existingResource = this.context.tree.get(["drive", "guidToResource", asset.guid]) || {};
				this.context.tree.set(["drive", "guidToResource", asset.guid], {
					...existingResource,
					metaData: nextMetaData
				});
				const activeCursor = this.context.tree.get(["drive", "hierarchyActiveCursor"]);
				if (activeCursor && activeCursor.guid === asset.guid) {
					this.context.tree.set(["drive", "hierarchyActiveCursor"], {
						...activeCursor,
						metaData: nextMetaData
					});
				}
			}

			this.cacheDriveTranscript(asset, transcript);
			this.appendAssistantInfoMessage("Saved transcript to Drive metadata.");
		} catch (_err) {
			this.appendAssistantErrorMessage("Failed to save transcript to the Drive file metadata.");
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async applyDriveTitleFromLatestResponse() {
		const asset = this.getSelectedDriveAssetResource();
		if (!asset) {
			this.appendAssistantErrorMessage("Select a Drive file before applying title.");
			return;
		}

		if (this.state.isWaitingForResponse) {
			return;
		}

		const responseText = this.props.aiAssistantResponseLast || "";
		const title = this.getTitleFromAssistantResponse(responseText);
		if (!this.isLikelyDriveTitle(title)) {
			this.appendAssistantErrorMessage("No usable title was found in the latest response. Ask for a concise title first.");
			return;
		}

		const path = this.getDriveAssetPath(asset);
		const orgId = getOrgId();
		if (!path || !orgId) {
			this.appendAssistantErrorMessage("Unable to resolve Drive asset path or organization for title update.");
			return;
		}

		const existingMetaData = (asset && asset.metaData && typeof asset.metaData === "object")
			? asset.metaData
			: {};
		const nextMetaData = {
			...existingMetaData,
			title
		};

		this.startWaitingForResponse();
		try {
			await refreshCredentials();
			await request.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId,
					path,
					metaData: nextMetaData
				}));

			if (asset.guid) {
				const existingResource = this.context.tree.get(["drive", "guidToResource", asset.guid]) || {};
				this.context.tree.set(["drive", "guidToResource", asset.guid], {
					...existingResource,
					metaData: nextMetaData
				});
				const activeCursor = this.context.tree.get(["drive", "hierarchyActiveCursor"]);
				if (activeCursor && activeCursor.guid === asset.guid) {
					this.context.tree.set(["drive", "hierarchyActiveCursor"], {
						...activeCursor,
						metaData: nextMetaData
					});
				}
			}

			this.appendAssistantInfoMessage("Saved title to Drive metadata.");
		} catch (_err) {
			this.appendAssistantErrorMessage("Failed to save title to the Drive file metadata.");
		} finally {
			this.stopWaitingForResponse();
		}
	}

	isDriveAssetTranscriptionRequest(userMessage = "", asset = null) {
		const mediaType = this.getDriveAssetMediaType(asset);
		if (mediaType !== "audio" && mediaType !== "video") {
			return false;
		}
		return /\btranscrib(?:e|ed|ing|tion)\b/i.test(userMessage || "");
	}

	isLikelyDriveTranscriptFollowUpRequest(userMessage = "") {
		const text = (userMessage || "").toLowerCase();
		if (!text) {
			return false;
		}
		const transcriptFollowUpTerms = [
			"transcript",
			"format",
			"section",
			"sections",
			"summarize",
			"summary",
			"bullet",
			"bullets",
			"key points",
			"outline",
			"rewrite",
			"condense",
			"shorten",
			"clean up"
		];
		return transcriptFollowUpTerms.some((term) => text.indexOf(term) > -1);
	}

	isDriveAssetContentAnalysisRequest(userMessage = "", asset = null) {
		const mediaType = this.getDriveAssetMediaType(asset);
		if (mediaType !== "audio" && mediaType !== "video") {
			return false;
		}
		const text = (userMessage || "").toLowerCase();
		if (!text) {
			return false;
		}
		return (
			/\bsummar(?:y|ize|ized|izing)\b/.test(text) ||
			/\bhighlights?\b/.test(text) ||
			/\bkey points?\b/.test(text) ||
			/\bbullets?\b/.test(text) ||
			/\boutline\b/.test(text) ||
			/\baction items?\b/.test(text) ||
			/\bsections?\b/.test(text) ||
			/\bformat\b/.test(text) ||
			/\btag(s| suggestions?)\b/.test(text)
		);
	}

	isDriveAssetModeEnabled() {
		if (this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE) {
			return true;
		}
		// Keep Drive Asset mode visible in authoring/editor so users can switch into it,
		// then pick a Drive file via "Use in AI Assistant" from media controls.
		if (this.isActivityModeEnabled()) {
			return true;
		}
		if (!this.getSelectedDriveAssetCursor()) {
			return false;
		}
		if (typeof window === "undefined" || !window.location) {
			return false;
		}
		const pathname = window.location.pathname || "";
		if (pathname.indexOf("/drive") > -1) {
			return true;
		}
		return this.isActivityModeEnabled();
	}

	getDriveAssetQuickPrompts() {
		const mediaType = this.getDriveAssetMediaType();
		if (mediaType === "image") {
			return [
				{ label: "Describe Image", prompt: "Describe this selected image in detail for an author." },
				{ label: "Summarize", prompt: "Give a concise summary of what this selected image shows." },
				{ label: "Generate Title", prompt: "Write a concise searchable title (under 10 words) for this selected image." },
				{ label: "Generate Description", prompt: "Write a concise searchable description for this selected image in 1-3 sentences." },
				{ label: "Generate Tags", prompt: "Generate 15 searchable tags for this selected image. Return a single comma-separated list." }
			];
		}
		if (mediaType === "video") {
			return [
				{ label: "Transcribe Video", prompt: "Transcribe this selected video to plain text with useful section breaks." },
				{ label: "Summarize", prompt: "Summarize the selected video into key points and action items." },
				{ label: "Generate Title", prompt: "Write a concise searchable title (under 10 words) for this selected video." },
				{ label: "Generate Description", prompt: "Write a concise searchable description for this selected video in 1-3 sentences." },
				{ label: "Generate Tags", prompt: "Generate 15 searchable tags for this selected video. Return a single comma-separated list." }
			];
		}
		if (mediaType === "audio") {
			return [
				{ label: "Transcribe Audio", prompt: "Transcribe this selected audio file to plain text with useful section breaks." },
				{ label: "Summarize", prompt: "Summarize the selected audio content into key points." },
				{ label: "Generate Title", prompt: "Write a concise searchable title (under 10 words) for this selected audio file." },
				{ label: "Generate Description", prompt: "Write a concise searchable description for this selected audio in 1-3 sentences." },
				{ label: "Generate Tags", prompt: "Generate 15 searchable tags for this selected audio file. Return a single comma-separated list." }
			];
		}
		if (mediaType === "pdf") {
			return [
				{ label: "Summarize PDF", prompt: "Summarize this selected PDF in concise, practical terms." },
				{ label: "Extract Highlights", prompt: "Extract the most important highlights from this selected PDF." },
				{ label: "Create Outline", prompt: "Create a clean section outline for this selected PDF." },
				{ label: "Generate Title", prompt: "Write a concise searchable title (under 10 words) for this selected PDF." },
				{ label: "Generate Description", prompt: "Write a concise searchable description for this selected PDF in 1-3 sentences." },
				{ label: "Generate Tags", prompt: "Generate 15 searchable tags for this selected PDF. Return a single comma-separated list." }
			];
		}

		return [
			{ label: "Summarize File", prompt: "Summarize the selected file in concise, practical terms." },
			{ label: "Extract Highlights", prompt: "Extract the most important highlights from the selected file." },
			{ label: "Generate Title", prompt: "Write a concise searchable title (under 10 words) for the selected file." },
			{ label: "Generate Description", prompt: "Write a concise searchable description for the selected file in 1-3 sentences." },
			{ label: "Generate Tags", prompt: "Generate 15 searchable tags for the selected file. Return a single comma-separated list." }
		];
	}

	getAvailableModes() {
		const modes = [];
		if (this.isActivityModeEnabled() && this.getCurrentActivityId() !== "") {
			modes.push(STRUCTURE_ASSISTANT_MODE);
			modes.push(BULK_EDIT_ASSISTANT_MODE);
			modes.push(ACTIVITY_ANALYSIS_ASSISTANT_MODE);
		}
		if (this.isAuthoringModeEnabled()) {
			modes.push("authoring");
		}
		if (this.isFieldDraftModeEnabled()) {
			modes.push(DRAFT_ASSISTANT_MODE_FIELD_TEXT);
		}
		if (this.isScriptFunctionsModeEnabled()) {
			modes.push(SCRIPT_ASSISTANT_MODE_FUNCTIONS);
		}
		if (this.isScriptValueTriggerModeEnabled()) {
			modes.push(SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER);
		}
		if (this.isDriveAssetModeEnabled()) {
			modes.push(DRIVE_ASSET_ASSISTANT_MODE);
		}
		modes.push("org");
		return modes;
	}

	getConversationScopeKey(mode, options = {}) {
		const activityId = this.getCurrentActivityId() || "global";
		const orgId = getOrgId() || "org";

		if (mode === DRIVE_ASSET_ASSISTANT_MODE) {
			const asset = options.asset || this.getSelectedDriveAssetResource();
			const assetKey = (asset && (asset.guid || this.getDriveAssetPath(asset) || asset.name)) || "selected";
			return `drive:${orgId}:${assetKey}`;
		}
		if (mode === "authoring") {
			return `authoring:${orgId}:${activityId}`;
		}
		if (mode === STRUCTURE_ASSISTANT_MODE) {
			const targetPath = Array.isArray(options.targetPath) ? options.targetPath : [];
			const pathKey = targetPath.length > 0 ? targetPath.join(".") : "root";
			return `structure:${orgId}:${activityId}:${pathKey}`;
		}
		if (mode === BULK_EDIT_ASSISTANT_MODE) {
			const targetPath = Array.isArray(options.targetPath) ? options.targetPath : [];
			const pathKey = targetPath.length > 0 ? targetPath.join(".") : "root";
			return `bulk_edit:${orgId}:${activityId}:${pathKey}`;
		}
		if (mode === ACTIVITY_ANALYSIS_ASSISTANT_MODE) {
			return `activity_analysis:${orgId}:${activityId}`;
		}
		if (mode === DRAFT_ASSISTANT_MODE_FIELD_TEXT) {
			const targetPath = Array.isArray(options.targetPath) ? options.targetPath : [];
			const pathKey = targetPath.length > 0 ? targetPath.join(".") : "focused";
			return `draft:${orgId}:${activityId}:${pathKey}`;
		}
		if (mode === SCRIPT_ASSISTANT_MODE_FUNCTIONS || mode === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER) {
			const targetPath = Array.isArray(options.targetPath) ? options.targetPath : [];
			const pathKey = targetPath.length > 0 ? targetPath.join(".") : "script";
			return `${mode}:${orgId}:${activityId}:${pathKey}`;
		}
		if (mode === "org") {
			return `org:${orgId}`;
		}
		return `${mode}:${orgId}:${activityId}`;
	}

	getDriveTranscriptConversationKey(asset = null) {
		const targetAsset = asset || this.getSelectedDriveAssetResource();
		return this.getConversationScopeKey(DRIVE_ASSET_ASSISTANT_MODE, { asset: targetAsset });
	}

	getCachedDriveTranscript(asset = null) {
		const conversationKey = this.getDriveTranscriptConversationKey(asset);
		const transcript = this.driveTranscriptCacheByConversationKey[conversationKey];
		return typeof transcript === "string" ? transcript : "";
	}

	cacheDriveTranscript(asset = null, transcriptText = "") {
		if (typeof transcriptText !== "string" || transcriptText.trim() === "") {
			return;
		}
		const conversationKey = this.getDriveTranscriptConversationKey(asset);
		this.driveTranscriptCacheByConversationKey[conversationKey] = transcriptText.length > MAX_TRANSCRIPT_CONTEXT_CHARS
			? transcriptText.slice(0, MAX_TRANSCRIPT_CONTEXT_CHARS)
			: transcriptText;
	}

	extractResponsesText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		if (typeof payload.output_text === "string" && payload.output_text.trim() !== "") {
			return payload.output_text;
		}
		if (payload.response && typeof payload.response.output_text === "string" && payload.response.output_text.trim() !== "") {
			return payload.response.output_text;
		}
		if (typeof payload.text === "string" && payload.text.trim() !== "") {
			return payload.text;
		}

		const readOutputArray = (arr) => {
			if (!Array.isArray(arr)) {
				return "";
			}
			const parts = [];
			arr.forEach((entry) => {
				if (!entry) {
					return;
				}
				if (entry.type === "message" && Array.isArray(entry.content)) {
					entry.content.forEach((contentPart) => {
						if (!contentPart) {
							return;
						}
						if (typeof contentPart.text === "string" && contentPart.text.trim() !== "") {
							parts.push(contentPart.text);
							return;
						}
						if (typeof contentPart.value === "string" && contentPart.value.trim() !== "") {
							parts.push(contentPart.value);
						}
					});
					return;
				}
				if (typeof entry.text === "string" && entry.text.trim() !== "") {
					parts.push(entry.text);
				}
			});
			return parts.join("").trim();
		};

		const responseArrayText = readOutputArray(payload.output || payload.response?.output);
		if (responseArrayText) {
			return responseArrayText;
		}

		return "";
	}

	extractResponsesId(payload) {
		if (!payload || typeof payload !== "object") {
			return "";
		}
		if (typeof payload.id === "string" && payload.id.trim() !== "") {
			return payload.id;
		}
		if (payload.response && typeof payload.response.id === "string" && payload.response.id.trim() !== "") {
			return payload.response.id;
		}
		return "";
	}

	buildResponsesInputFromChatMessages(messages = []) {
		if (!Array.isArray(messages)) {
			return [];
		}

		const normalizeText = (value) => (typeof value === "string" ? value : (value === null || value === undefined) ? "" : `${value}`);
		const normalizeFileId = (value) => (typeof value === "string" ? value.trim() : "");

		return messages.map((message) => {
			const role = message && typeof message.role === "string" ? message.role : "user";
			const content = message ? message.content : "";

			if (Array.isArray(content)) {
				const convertedContent = content.map((part) => {
					if (!part || typeof part !== "object") {
						return null;
					}
					if (part.type === "text") {
						return { type: "input_text", text: normalizeText(part.text) };
					}
					if (part.type === "image_url") {
						const imageUrl = typeof part.image_url === "string"
							? part.image_url
							: part.image_url && typeof part.image_url.url === "string"
								? part.image_url.url
								: "";
						if (!imageUrl) {
							return null;
						}
						return { type: "input_image", image_url: imageUrl };
					}
					if (part.type === "input_text" || part.type === "input_image") {
						return part;
					}
					if (part.type === "input_file" || part.type === "file") {
						const fileId = normalizeFileId(part.file_id || part.id);
						if (!fileId) {
							return null;
						}
						return { type: "input_file", file_id: fileId };
					}
					return null;
				}).filter(Boolean);

				return {
					role,
					content: convertedContent.length > 0 ? convertedContent : [{ type: "input_text", text: normalizeText(content) }]
				};
			}

			return {
				role,
				content: [{ type: "input_text", text: normalizeText(content) }]
			};
		});
	}

	buildChatCompletionsMessagesFromChatMessages(messages = []) {
		if (!Array.isArray(messages)) {
			return [];
		}

		const normalizeText = (value) => (typeof value === "string" ? value : (value === null || value === undefined) ? "" : `${value}`);

		return messages.map((message) => {
			const role = message && typeof message.role === "string" ? message.role : "user";
			const content = message ? message.content : "";

			if (!Array.isArray(content)) {
				return {
					role,
					content: normalizeText(content)
				};
			}

			const convertedContent = content.map((part) => {
				if (!part || typeof part !== "object") {
					return null;
				}
				if (part.type === "text") {
					return { type: "text", text: normalizeText(part.text) };
				}
				if (part.type === "image_url") {
					const imageUrl = typeof part.image_url === "string"
						? part.image_url
						: part.image_url && typeof part.image_url.url === "string"
							? part.image_url.url
							: "";
					if (!imageUrl) {
						return null;
					}
					return {
						type: "image_url",
						image_url: { url: imageUrl }
					};
				}
				if (part.type === "input_image") {
					const imageUrl = typeof part.image_url === "string"
						? part.image_url
						: "";
					if (!imageUrl) {
						return null;
					}
					return {
						type: "image_url",
						image_url: { url: imageUrl }
					};
				}
				if (part.type === "input_text") {
					return { type: "text", text: normalizeText(part.text) };
				}
				return null;
			}).filter(Boolean);

			if (convertedContent.length === 0) {
				return {
					role,
					content: normalizeText(content)
				};
			}

			return {
				role,
				content: convertedContent
			};
		});
	}

	hasNonTextResponsesInputParts(input = []) {
		if (!Array.isArray(input)) {
			return false;
		}

		return input.some((message) => (
			message &&
			Array.isArray(message.content) &&
			message.content.some((part) => part && typeof part === "object" && part.type !== "input_text")
		));
	}

	getAssistantErrorMessage(prefix = "Request failed.", err = null) {
		const detail = err && typeof err.message === "string" ? err.message.trim() : "";
		if (!detail) {
			return prefix;
		}
		return `${prefix} ${detail}`;
	}

	getAssistantFiles() {
		const files = Array.isArray(this.props.files)
			? this.props.files
			: (Array.isArray(this.props.rootAssistantFiles) ? this.props.rootAssistantFiles : []);
		return files
			.filter((item) => item && item.id)
			.slice()
			.sort((a, b) => `${(a && a.filename) || ""}`.localeCompare(`${(b && b.filename) || ""}`));
	}

	getAssistantFileDisplayName(file = null) {
		if (!file || typeof file !== "object") {
			return "";
		}
		const fileName = typeof file.filename === "string" ? file.filename : "";
		const identityPrefix = this.props.user && this.props.user.identityId
			? `${this.props.user.identityId}/`
			: "";
		if (identityPrefix && fileName.startsWith(identityPrefix)) {
			return fileName.slice(identityPrefix.length);
		}
		return fileName || file.id || "Attached file";
	}

	isPromptAttachmentModeEnabled(mode = this.state.selectedActivityOrFiles) {
		return mode === "authoring" ||
			this.isDraftMode(mode) ||
			this.isScriptMode(mode) ||
			this.isStructureMode(mode);
	}

	getSelectedPromptAttachmentFileIds() {
		return Array.isArray(this.state.promptAttachmentFileIds)
			? this.state.promptAttachmentFileIds.filter(Boolean)
			: [];
	}

	getPromptAttachmentLocalAssetsById() {
		const assetsById = this.state && this.state.promptAttachmentLocalAssetsById && typeof this.state.promptAttachmentLocalAssetsById === "object"
			? this.state.promptAttachmentLocalAssetsById
			: {};
		return assetsById;
	}

	getSelectedPromptAttachmentFiles(fileIds = null) {
		const selectedIds = Array.isArray(fileIds) ? fileIds : this.getSelectedPromptAttachmentFileIds();
		const idSet = new Set(selectedIds);
		return this.getAssistantFiles().filter((file) => idSet.has(file.id));
	}

	getSelectedPromptAttachmentLocalAssetMap(fileIds = null) {
		const selectedIds = Array.isArray(fileIds) ? fileIds : this.getSelectedPromptAttachmentFileIds();
		const assetsById = this.getPromptAttachmentLocalAssetsById();
		return selectedIds.reduce((acc, fileId) => {
			if (assetsById[fileId]) {
				acc[fileId] = assetsById[fileId];
			}
			return acc;
		}, {});
	}

	isLikelyImageAttachmentFile(file = null) {
		if (!file || typeof file !== "object") {
			return false;
		}
		const mimeType = typeof file.type === "string" ? file.type.toLowerCase() : "";
		if (mimeType.startsWith("image/")) {
			return true;
		}
		const fileName = typeof file.name === "string"
			? file.name.toLowerCase()
			: (typeof file.filename === "string" ? file.filename.toLowerCase() : "");
		return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fileName);
	}

	readFileAsDataUrl(file) {
		return new Promise((resolve, reject) => {
			if (typeof FileReader === "undefined") {
				reject(new Error("FileReader is not available in this browser."));
				return;
			}
			const reader = new FileReader();
			reader.onload = () => {
				resolve(typeof reader.result === "string" ? reader.result : "");
			};
			reader.onerror = () => {
				reject(reader.error || new Error("Failed to read file as data URL."));
			};
			reader.readAsDataURL(file);
		});
	}

	async buildPromptAttachmentLocalAsset(file = null) {
		if (!this.isLikelyImageAttachmentFile(file)) {
			return null;
		}
		if (typeof file.size === "number" && file.size > MAX_IMAGE_DATA_URL_BYTES) {
			return null;
		}

		const imageUrl = await this.readFileAsDataUrl(file);
		if (!imageUrl) {
			return null;
		}

		return {
			kind: "image",
			imageUrl,
			fileName: typeof file.name === "string" ? file.name : "",
			mimeType: typeof file.type === "string" ? file.type : ""
		};
	}

	togglePromptAttachmentFile(fileId = "") {
		if (!fileId) {
			return;
		}

		this.setState((prevState) => {
			const currentIds = Array.isArray(prevState.promptAttachmentFileIds) ? prevState.promptAttachmentFileIds : [];
			const nextIds = currentIds.includes(fileId)
				? currentIds.filter((id) => id !== fileId)
				: currentIds.concat(fileId);
			return {
				promptAttachmentFileIds: nextIds
			};
		});
	}

	removePromptAttachmentFile(fileId = "") {
		if (!fileId) {
			return;
		}
		this.setState((prevState) => {
			const nextLocalAssets = {
				...(prevState.promptAttachmentLocalAssetsById && typeof prevState.promptAttachmentLocalAssetsById === "object"
					? prevState.promptAttachmentLocalAssetsById
					: {})
			};
			delete nextLocalAssets[fileId];
			return {
				promptAttachmentFileIds: (Array.isArray(prevState.promptAttachmentFileIds) ? prevState.promptAttachmentFileIds : []).filter((id) => id !== fileId),
				promptAttachmentLocalAssetsById: nextLocalAssets
			};
		});
	}

	injectPromptAttachmentsIntoMessages(messages = [], attachmentFileIds = null) {
		const selectedFiles = this.getSelectedPromptAttachmentFiles(attachmentFileIds);
		const selectedLocalAssetsById = this.getSelectedPromptAttachmentLocalAssetMap(attachmentFileIds);
		if (!Array.isArray(messages) || selectedFiles.length === 0) {
			return Array.isArray(messages) ? messages : [];
		}

		const nextMessages = messages.map((message) => {
			if (!message || typeof message !== "object") {
				return message;
			}
			const nextMessage = { ...message };
			if (Array.isArray(message.content)) {
				nextMessage.content = message.content.map((part) => (part && typeof part === "object" ? { ...part } : part));
			}
			return nextMessage;
		});

		let targetMessageIndex = -1;
		for (let index = nextMessages.length - 1; index >= 0; index--) {
			if (nextMessages[index] && nextMessages[index].role === "user") {
				targetMessageIndex = index;
				break;
			}
		}

		if (targetMessageIndex === -1) {
			nextMessages.push({
				role: "user",
				content: []
			});
			targetMessageIndex = nextMessages.length - 1;
		}

		const targetMessage = nextMessages[targetMessageIndex] || { role: "user", content: [] };
		const currentContent = Array.isArray(targetMessage.content)
			? targetMessage.content.slice()
			: [{
				type: "text",
				text: typeof targetMessage.content === "string" ? targetMessage.content : `${targetMessage.content || ""}`
			}];
		selectedFiles.forEach((file) => {
			const localAsset = selectedLocalAssetsById[file.id];
			if (localAsset && localAsset.kind === "image" && typeof localAsset.imageUrl === "string" && localAsset.imageUrl !== "") {
				currentContent.push({
					type: "input_image",
					image_url: localAsset.imageUrl
				});
				return;
			}
			currentContent.push({
				type: "input_file",
				file_id: file.id
			});
		});
		nextMessages[targetMessageIndex] = {
			...targetMessage,
			content: currentContent
		};

		return nextMessages;
	}

	async runResponsesConversationTurn({ mode, messages, model = DEFAULT_ASSISTANT_CHAT_MODEL, conversationOptions = {} }) {
		const conversationKey = this.getConversationScopeKey(mode, conversationOptions);
		const previousResponseId = this.conversationStateByKey[conversationKey]
			? this.conversationStateByKey[conversationKey].responseId
			: "";
		const carryOverText = this.consumeModeCarryOverText(mode, conversationOptions);
		const messagesWithCarryOver = this.prependCarryOverContextToMessages(messages, carryOverText);
		const attachmentFileIds = this.isPromptAttachmentModeEnabled(mode)
			? this.getSelectedPromptAttachmentFileIds()
			: [];
		const messagesWithAttachments = attachmentFileIds.length > 0
			? this.injectPromptAttachmentsIntoMessages(messagesWithCarryOver, attachmentFileIds)
			: messagesWithCarryOver;
		const responsesInput = this.buildResponsesInputFromChatMessages(messagesWithAttachments);
		const requestBody = {
			model,
			input: responsesInput
		};
		if (previousResponseId) {
			requestBody.previous_response_id = previousResponseId;
		}

		try {
			const responsePayload = await getResponsesCreateLambda(JSON.stringify(requestBody), { showAlert: false });
			const responseText = this.extractResponsesText(responsePayload);
			const responseId = this.extractResponsesId(responsePayload);
			if (responseId) {
				this.conversationStateByKey[conversationKey] = {
					...(this.conversationStateByKey[conversationKey] || {}),
					responseId,
					updatedAt: Date.now()
				};
			}

			if (responseText) {
				return responseText;
			}
			if (typeof responsePayload === "string") {
				return responsePayload;
			}
			if (responsePayload) {
				return JSON.stringify(responsePayload, null, 2);
			}

			throw new Error("Empty response payload");
		} catch (_responsesErr) {
			// If responses fails and we fall back, do not keep stale response chain IDs.
			// Otherwise a later successful responses call can attach to unrelated context.
			delete this.conversationStateByKey[conversationKey];

			if (this.hasNonTextResponsesInputParts(responsesInput)) {
				throw _responsesErr;
			}

			// Fallback path: preserve existing behavior if responses route is unavailable.
			const fallbackPayload = {
				messages: this.buildChatCompletionsMessagesFromChatMessages(messagesWithAttachments),
				model
			};
			return await getChatCompletionsLambda(JSON.stringify(fallbackPayload));
		}
	}

	async runPdfDriveAssetConversationTurn({ mode, asset, userMessage }) {
		const s3Key = this.getDriveAssetS3Key(asset);
		if (!s3Key) {
			throw new Error("Missing S3 key for selected Drive PDF asset.");
		}

		const conversationKey = this.getConversationScopeKey(mode, { asset });
		const previousResponseId = this.conversationStateByKey[conversationKey]
			? this.conversationStateByKey[conversationKey].responseId
			: "";
		const carryOverText = this.consumeModeCarryOverText(mode, { asset });

		const requestBody = {
			model: DEFAULT_ASSISTANT_CHAT_MODEL,
			bucket: env.s3.assetsBucket,
			key: s3Key,
			fileName: asset?.name || "",
			prompt: this.applyCarryOverToPrompt(userMessage, carryOverText)
		};
		if (previousResponseId) {
			requestBody.previous_response_id = previousResponseId;
		}

		try {
			const responsePayload = await getPdfResponsesLambda(JSON.stringify(requestBody), { showAlert: false });
			const responseText = this.extractResponsesText(responsePayload);
			const responseId = this.extractResponsesId(responsePayload);

			if (responseId) {
				this.conversationStateByKey[conversationKey] = {
					...(this.conversationStateByKey[conversationKey] || {}),
					responseId,
					updatedAt: Date.now()
				};
			}

			if (responseText) {
				return responseText;
			}
			if (typeof responsePayload === "string") {
				return responsePayload;
			}
			if (responsePayload) {
				return JSON.stringify(responsePayload, null, 2);
			}
			throw new Error("Empty PDF response payload");
		} catch (err) {
			// If the lambda event is not deployed yet, fall back to existing chat behavior.
			const errMsg = `${err?.message || err || ""}`.toLowerCase();
			const looksLikeUnsupportedEvent = (
				errMsg.indexOf("pdfresponsescreate") > -1 ||
				errMsg.indexOf("unknown event") > -1 ||
				errMsg.indexOf("not available") > -1
			);

			if (!looksLikeUnsupportedEvent) {
				throw err;
			}

			delete this.conversationStateByKey[conversationKey];
			return await this.runResponsesConversationTurn({
				mode,
				messages: await this.buildDriveAssetMessages(userMessage),
				model: DEFAULT_ASSISTANT_CHAT_MODEL,
				conversationOptions: { asset }
			});
		}
	}

	ensureSelectedMode() {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(this.state.selectedActivityOrFiles)) {
			this.setState({
				selectedActivityOrFiles: availableModes[0] || "org"
			});
			return false;
		}
		return true;
	}

	isScriptMode(mode) {
		return mode === SCRIPT_ASSISTANT_MODE_FUNCTIONS || mode === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER;
	}

	isDraftMode(mode) {
		return mode === DRAFT_ASSISTANT_MODE_FIELD_TEXT;
	}

	isStructureMode(mode) {
		return mode === STRUCTURE_ASSISTANT_MODE;
	}

	isBulkEditMode(mode) {
		return mode === BULK_EDIT_ASSISTANT_MODE;
	}

	isActivityAnalysisMode(mode) {
		return mode === ACTIVITY_ANALYSIS_ASSISTANT_MODE;
	}

	getConversationOptionsForMode(mode) {
		if (mode === STRUCTURE_ASSISTANT_MODE) {
			const structureContext = this.getStructureContext();
			return {
				targetPath: structureContext && Array.isArray(structureContext.targetPath) ? structureContext.targetPath : null
			};
		}
		if (mode === BULK_EDIT_ASSISTANT_MODE) {
			const bulkEditContext = this.getBulkEditContext();
			return {
				targetPath: bulkEditContext && Array.isArray(bulkEditContext.targetPath) ? bulkEditContext.targetPath : null
			};
		}
		if (mode === DRAFT_ASSISTANT_MODE_FIELD_TEXT) {
			const draftContext = this.getDraftContextForMode(mode);
			return {
				targetPath: draftContext && Array.isArray(draftContext.targetPath) ? draftContext.targetPath : null
			};
		}
		if (this.isScriptMode(mode)) {
			const scriptContext = this.getScriptContextForMode(mode);
			return {
				targetPath: scriptContext && Array.isArray(scriptContext.targetPath) ? scriptContext.targetPath : null
			};
		}
		if (mode === DRIVE_ASSET_ASSISTANT_MODE) {
			return {
				asset: this.getSelectedDriveAssetResource()
			};
		}
		return {};
	}

	getConversationEntryForMode(mode) {
		if (!mode) {
			return null;
		}
		const conversationOptions = this.getConversationOptionsForMode(mode);
		const conversationKey = this.getConversationScopeKey(mode, conversationOptions);
		return this.conversationStateByKey[conversationKey] || null;
	}

	updateConversationSummaryForMode(mode, { userMessage, assistantText, conversationOptions = null } = {}) {
		if (!mode) {
			return "";
		}

		const resolvedConversationOptions = conversationOptions || this.getConversationOptionsForMode(mode);
		const conversationKey = this.getConversationScopeKey(mode, resolvedConversationOptions);
		const previousEntry = this.conversationStateByKey[conversationKey] || {};

		const nextEntry = {
			...previousEntry,
			updatedAt: Date.now()
		};

		if (typeof userMessage === "string" && userMessage.trim() !== "") {
			nextEntry.latestUserMessage = this.cleanContextText(userMessage.trim(), 400);
		}
		if (typeof assistantText === "string" && assistantText.trim() !== "") {
			nextEntry.latestAssistantResponse = this.cleanContextText(assistantText.trim(), 2200);
		}

		this.conversationStateByKey[conversationKey] = nextEntry;
		return conversationKey;
	}

	modeHasConversationHistory(mode) {
		const entry = this.getConversationEntryForMode(mode);
		if (!entry) {
			return false;
		}
		return !!(
			(entry.responseId && `${entry.responseId}`.trim() !== "") ||
			(entry.latestAssistantResponse && `${entry.latestAssistantResponse}`.trim() !== "")
		);
	}

	buildModeCarryOverSummaryText(sourceMode, entry = null) {
		if (!sourceMode || !entry) {
			return "";
		}

		const sourceLabel = this.getModeOptionLabel(sourceMode);
		const lastUserMessage = typeof entry.latestUserMessage === "string" ? entry.latestUserMessage.trim() : "";
		const lastAssistantResponse = typeof entry.latestAssistantResponse === "string" ? entry.latestAssistantResponse.trim() : "";
		const sections = [
			`Context carried from prior assistant mode: ${sourceLabel}`
		];

		if (lastUserMessage) {
			sections.push(`Previous user request:\n${lastUserMessage}`);
		}
		if (lastAssistantResponse) {
			sections.push(`Latest assistant response summary:\n${lastAssistantResponse}`);
		}

		return sections.join("\n\n");
	}

	buildPendingModeCarryOverPrompt(sourceMode, targetMode) {
		if (!sourceMode || !targetMode || sourceMode === targetMode) {
			return null;
		}

		const sourceEntry = this.getConversationEntryForMode(sourceMode);
		if (!sourceEntry || !this.modeHasConversationHistory(sourceMode)) {
			return null;
		}

		const targetConversationKey = this.getConversationScopeKey(targetMode, this.getConversationOptionsForMode(targetMode));
		const targetEntry = this.conversationStateByKey[targetConversationKey] || null;
		const targetHasHistory = !!(
			targetEntry &&
			(
				(targetEntry.responseId && `${targetEntry.responseId}`.trim() !== "") ||
				(targetEntry.latestAssistantResponse && `${targetEntry.latestAssistantResponse}`.trim() !== "")
			)
		);
		if (targetHasHistory) {
			return null;
		}

		const queuedCarryOverByKey = this.state && this.state.queuedModeCarryOverByKey && typeof this.state.queuedModeCarryOverByKey === "object"
			? this.state.queuedModeCarryOverByKey
			: {};
		if (queuedCarryOverByKey[targetConversationKey]) {
			return null;
		}

		const summaryText = this.buildModeCarryOverSummaryText(sourceMode, sourceEntry);
		if (!summaryText) {
			return null;
		}

		return {
			sourceMode,
			targetMode,
			sourceLabel: this.getModeOptionLabel(sourceMode),
			targetLabel: this.getModeOptionLabel(targetMode),
			targetConversationKey,
			summaryText,
			sourceUpdatedAt: sourceEntry.updatedAt || Date.now()
		};
	}

	consumeModeCarryOverText(mode, conversationOptions = {}) {
		const conversationKey = this.getConversationScopeKey(mode, conversationOptions);
		const queuedCarryOverByKey = this.state && this.state.queuedModeCarryOverByKey && typeof this.state.queuedModeCarryOverByKey === "object"
			? this.state.queuedModeCarryOverByKey
			: {};
		const queuedEntry = queuedCarryOverByKey[conversationKey];
		if (!queuedEntry || typeof queuedEntry.summaryText !== "string" || queuedEntry.summaryText.trim() === "") {
			return "";
		}

		const nextQueuedCarryOverByKey = { ...queuedCarryOverByKey };
		delete nextQueuedCarryOverByKey[conversationKey];
		this.setState({
			queuedModeCarryOverByKey: nextQueuedCarryOverByKey
		});

		return queuedEntry.summaryText.trim();
	}

	prependCarryOverContextToMessages(messages = [], carryOverText = "") {
		const normalizedCarryOverText = typeof carryOverText === "string" ? carryOverText.trim() : "";
		if (!normalizedCarryOverText) {
			return messages;
		}

		return [
			{
				role: "system",
				content: [
					{
						type: "input_text",
						text: [
							"Supplemental handoff context from a different assistant mode is included below.",
							"Use it only as supporting context for the current request and follow the current mode's contract first.",
							normalizedCarryOverText
						].join("\n\n")
					}
				]
			},
			...messages
		];
	}

	applyCarryOverToPrompt(prompt = "", carryOverText = "") {
		const normalizedCarryOverText = typeof carryOverText === "string" ? carryOverText.trim() : "";
		if (!normalizedCarryOverText) {
			return prompt;
		}

		return [
			"Supplemental handoff context from a different assistant mode:",
			normalizedCarryOverText,
			"",
			"Use the above only as supporting context for the current request. Follow the current mode's contract first.",
			"",
			prompt
		].join("\n\n");
	}

	getSelectedNodeEntity() {
		const selectedNodePath = state.get(["selectedNodePath"]);
		if (!Array.isArray(selectedNodePath) || selectedNodePath.length === 0) {
			return { nodePath: [], entity: null };
		}
		const selectedNode = state.get(selectedNodePath);
		return {
			nodePath: selectedNodePath,
			entity: selectedNode && selectedNode.entity ? selectedNode.entity : null
		};
	}

	buildStructureContextFromTargetPath(targetPath = null, overrides = null) {
		const fallbackPath = ["tree", "root"];
		const preferredPath = Array.isArray(targetPath) && targetPath.length > 0 ? targetPath : fallbackPath;
		const preferredNode = state.get(preferredPath);
		const resolvedPath = preferredNode && typeof preferredNode === "object"
			? preferredPath
			: fallbackPath;
		const resolvedNode = state.get(resolvedPath) || state.get(["tree", "root"]) || {};
		const selectedEntity = resolvedNode && resolvedNode.entity ? resolvedNode.entity : (state.get(["tree", "root", "entity"]) || {});
		const selectedTypeRaw = typeof selectedEntity.type === "string" ? selectedEntity.type : "checklist";
		const selectedType = selectedTypeRaw.toLowerCase() === "itemcontainer" ? "itemContainer" : selectedTypeRaw;
		const selectedLabel = selectedEntity.label || selectedEntity.name || selectedEntity.label1 || (overrides && overrides.targetLabel) || "Selected Node";
		const checklistPath = treePathToChecklistPath(resolvedPath);
		const parentChecklistPath = checklistPath.length > 0 ? checklistPath.slice(0, -1) : [];
		const overrideLines = overrides && Array.isArray(overrides.additionalContextLines)
			? overrides.additionalContextLines
			: [];
		const additionalContextLines = [...overrideLines];
		let projectedChecklist = null;
		let selectedStructureNode = null;
		let parentStructureNode = null;

		try {
			const publishedChecklist = transformFromChecklistEntities(state.get(["tree", "root"]), false, false, false);
			projectedChecklist = projectChecklistToStructureV1(publishedChecklist);
			selectedStructureNode = getStructureNodeAtPath(projectedChecklist, checklistPath) || projectedChecklist;
			parentStructureNode = checklistPath.length > 0
				? (getStructureNodeAtPath(projectedChecklist, parentChecklistPath) || projectedChecklist)
				: null;
		} catch (err) {
			const message = err && err.message ? err.message : "Unable to project current outline structure.";
			console.error("Failed to build AI assistant structure context", err);
			additionalContextLines.unshift(`Structure context warning: ${message}`);
		}

		return {
			mode: STRUCTURE_ASSISTANT_MODE,
			targetPath: resolvedPath,
			checklistPath,
			targetLabel: selectedLabel,
			targetType: selectedType,
			parentType: parentStructureNode && parentStructureNode.type ? parentStructureNode.type : "",
			projectedChecklist,
			selectedStructureNode,
			parentStructureNode,
			targetReadOnly: overrides && overrides.targetReadOnly === true,
			featureName: overrides && overrides.featureName ? overrides.featureName : "",
			featureDescription: overrides && overrides.featureDescription ? overrides.featureDescription : "",
			additionalContextLines
		};
	}

	getDefaultStructureContext() {
		const selected = this.getSelectedNodeEntity();
		return this.buildStructureContextFromTargetPath(selected.nodePath, null);
	}

	getBaseStructureContext() {
		const stateContext = this.state.structureContext;
		if (stateContext &&
			Array.isArray(stateContext.targetPath) &&
			stateContext.targetPath.length > 0) {
			return this.buildStructureContextFromTargetPath(stateContext.targetPath, stateContext);
		}
		return this.getDefaultStructureContext();
	}

	getStructureContext() {
		const activeContext = this.state.activeStructureContext;
		if (activeContext &&
			Array.isArray(activeContext.targetPath) &&
			activeContext.targetPath.length > 0) {
			return this.buildStructureContextFromTargetPath(activeContext.targetPath, activeContext);
		}
		return this.getBaseStructureContext();
	}

	buildBulkEditContextFromTargetPath(targetPath = null, overrides = null) {
		const structureContext = this.buildStructureContextFromTargetPath(targetPath, overrides);
		return {
			...structureContext,
			mode: BULK_EDIT_ASSISTANT_MODE
		};
	}

	getDefaultBulkEditContext() {
		const selected = this.getSelectedNodeEntity();
		return this.buildBulkEditContextFromTargetPath(selected.nodePath, null);
	}

	getBaseBulkEditContext() {
		const stateContext = this.state.bulkEditContext;
		if (stateContext &&
			Array.isArray(stateContext.targetPath) &&
			stateContext.targetPath.length > 0) {
			return this.buildBulkEditContextFromTargetPath(stateContext.targetPath, stateContext);
		}
		return this.getDefaultBulkEditContext();
	}

	getBulkEditContext() {
		const activeContext = this.state.activeBulkEditContext;
		if (activeContext &&
			Array.isArray(activeContext.targetPath) &&
			activeContext.targetPath.length > 0) {
			return this.buildBulkEditContextFromTargetPath(activeContext.targetPath, activeContext);
		}
		return this.getBaseBulkEditContext();
	}

	getBulkEditRawPayload(instructionResult = null, bulkEditContextOverride = null) {
		const bulkEditContext = bulkEditContextOverride || this.getBulkEditContext();
		const instructions = instructionResult && Array.isArray(instructionResult.instructions)
			? instructionResult.instructions
			: Array.isArray(this.state.latestBulkEditInstructions)
				? this.state.latestBulkEditInstructions
				: [];
		const targetLabel = bulkEditContext && bulkEditContext.targetLabel ? bulkEditContext.targetLabel : "Selected Node";
		const targetType = bulkEditContext && bulkEditContext.targetType ? bulkEditContext.targetType : "node";
		const targetPathLabel = bulkEditContext
			? (bulkEditContext.projectedChecklist
				? this.buildStructurePathLabel(bulkEditContext.projectedChecklist, bulkEditContext.checklistPath)
				: targetLabel)
			: "";

		return {
			targetLabel,
			targetType,
			targetPath: targetPathLabel || "",
			instructionCount: instructions.length,
			instructions
		};
	}

	formatBulkEditInstructionsForDisplay(instructionResult = null, bulkEditContextOverride = null) {
		const payload = this.getBulkEditRawPayload(instructionResult, bulkEditContextOverride);
		const filterSummary = this.describeBulkEditFilterSummary(payload.instructions);

		return [
			`Bulk edit plan ready for "${payload.targetLabel}" (${payload.targetType}).`,
			`Resolved target path: ${payload.targetPath || "(root)"}.`,
			`Additional label filter: ${filterSummary}.`,
			"Review the structured plan below before applying."
		].join("\n");
	}

	shouldUseChecklistRootForStructureRequest(userMessage = "") {
		const lower = (userMessage || "").toLowerCase();
		return (
			/\b(modify|update|change|reorganize|restructure|revise|convert|transform)\b[\s\S]{0,40}\b(checklist|activity)\b/.test(lower) ||
			/\b(entire|whole)\s+(checklist|activity)\b/.test(lower) ||
			/\btop[-\s]?level\b/.test(lower) ||
			/\broot\b/.test(lower)
		);
	}

	resolveStructureContextForRequest(userMessage = "") {
		const baseContext = this.getBaseStructureContext();
		if (this.shouldUseChecklistRootForStructureRequest(userMessage)) {
			return this.buildStructureContextFromTargetPath(["tree", "root"], {
				targetReadOnly: baseContext && baseContext.targetReadOnly === true,
				featureName: baseContext && baseContext.featureName ? baseContext.featureName : "",
				featureDescription: baseContext && baseContext.featureDescription ? baseContext.featureDescription : "",
				additionalContextLines: baseContext && Array.isArray(baseContext.additionalContextLines) ? baseContext.additionalContextLines : []
			});
		}
		return baseContext;
	}

	formatStructureSubtreeForDisplay(subtreeSpec = null) {
		if (!subtreeSpec || typeof subtreeSpec !== "object") {
			return "";
		}

		let payload = null;
		if (subtreeSpec.checklist && typeof subtreeSpec.checklist === "object") {
			payload = subtreeSpec.checklist;
		} else if (Array.isArray(subtreeSpec.nodes)) {
			payload = subtreeSpec.nodes.length === 1 ? subtreeSpec.nodes[0] : subtreeSpec.nodes;
		}

		if (!payload) {
			return "";
		}

		return `\`\`\`json\n${JSON.stringify(payload, null, 2)}\n\`\`\``;
	}

	getStructureNodeDisplayLabel(node = null) {
		if (!node || typeof node !== "object") {
			return "(unnamed node)";
		}
		return node.name || node.label1 || node.label || node.id || node.guid || "(unnamed node)";
	}

	buildStructurePathLabel(structureNode = null, checklistPath = []) {
		const normalizedPath = Array.isArray(checklistPath) ? checklistPath : [];
		const segments = [];
		let currentNode = structureNode;

		segments.push(this.getStructureNodeDisplayLabel(currentNode));

		normalizedPath.forEach((index) => {
			if (!currentNode || !Array.isArray(currentNode.children) || !currentNode.children[index]) {
				return;
			}
			currentNode = currentNode.children[index];
			segments.push(this.getStructureNodeDisplayLabel(currentNode));
		});

		return segments.join(" > ");
	}

	buildStructureNodeCounts(structureNode = null) {
		const counts = {
			total: 0,
			checklist: 0,
			list: 0,
			section: 0,
			itemContainer: 0,
			items: 0
		};

		const visitNode = (node) => {
			if (!node || typeof node !== "object") {
				return;
			}

			counts.total += 1;
			if (node.type === "checklist") {
				counts.checklist += 1;
			} else if (node.type === "list") {
				counts.list += 1;
			} else if (node.type === "section") {
				counts.section += 1;
			} else if (node.type === "itemContainer") {
				counts.itemContainer += 1;
			} else {
				counts.items += 1;
			}

			if (Array.isArray(node.children)) {
				node.children.forEach((childNode) => visitNode(childNode));
			}
		};

		visitNode(structureNode);
		return counts;
	}

	buildStructureNodeCountsForList(nodes = []) {
		const combined = {
			total: 0,
			checklist: 0,
			list: 0,
			section: 0,
			itemContainer: 0,
			items: 0
		};

		(Array.isArray(nodes) ? nodes : []).forEach((node) => {
			const counts = this.buildStructureNodeCounts(node);
			Object.keys(combined).forEach((key) => {
				combined[key] += counts[key] || 0;
			});
		});

		return combined;
	}

	buildStructureOutlineSummary(structureNode = null, options = {}) {
		if (!structureNode || typeof structureNode !== "object") {
			return "";
		}

		const selectedPath = Array.isArray(options.selectedPath) ? options.selectedPath : [];
		const maxNodes = Number.isFinite(options.maxNodes) ? options.maxNodes : MAX_STRUCTURE_OUTLINE_SUMMARY_NODES;
		const lines = [];
		let visitedCount = 0;
		let truncatedByNodes = false;

		const visitNode = (node, path = []) => {
			if (!node || typeof node !== "object") {
				return;
			}
			if (visitedCount >= maxNodes) {
				truncatedByNodes = true;
				return;
			}

			const depth = Array.isArray(path) ? path.length : 0;
			const isSelected = JSON.stringify(path) === JSON.stringify(selectedPath);
			const childCount = Array.isArray(node.children) ? node.children.length : 0;
			const nodeType = node.type || "node";
			const label = this.getStructureNodeDisplayLabel(node);
			const metadataParts = [];
			if (childCount > 0) {
				metadataParts.push(`${childCount} child${childCount === 1 ? "" : "ren"}`);
			}
			if (node.label2) {
				metadataParts.push(node.label2);
			}

			const linePrefix = `${"  ".repeat(depth)}${isSelected ? "> " : "- "}`;
			const lineSuffix = metadataParts.length > 0 ? ` (${metadataParts.join(" | ")})` : "";
			lines.push(`${linePrefix}[${nodeType}] ${label}${lineSuffix}`);
			visitedCount += 1;

			if (Array.isArray(node.children)) {
				node.children.forEach((childNode, childIndex) => visitNode(childNode, [...path, childIndex]));
			}
		};

		visitNode(structureNode, []);

		let outlineSummary = lines.join("\n");
		if (outlineSummary.length > MAX_STRUCTURE_OUTLINE_SUMMARY_CHARS) {
			outlineSummary = `${outlineSummary.slice(0, MAX_STRUCTURE_OUTLINE_SUMMARY_CHARS)}\n... [outline truncated]`;
		} else if (truncatedByNodes) {
			outlineSummary = `${outlineSummary}\n... [outline truncated]`;
		}

		return outlineSummary;
	}

	normalizeStructureMatchText(value = "") {
		return `${value || ""}`
			.toLowerCase()
			.replace(/&/g, " and ")
			.replace(/[^a-z0-9]+/g, " ")
			.replace(/\s+/g, " ")
			.trim();
	}

	labelMatchesStructureSegment(node = null, segment = "") {
		if (!node || !segment) {
			return false;
		}
		return this.normalizeStructureMatchText(this.getStructureNodeDisplayLabel(node)) === this.normalizeStructureMatchText(segment);
	}

	extractBulkEditPathSegments(userMessage = "") {
		const message = `${userMessage || ""}`;
		if (message.indexOf("->") === -1 && message.indexOf("→") === -1 && message.indexOf("›") === -1) {
			return [];
		}

		const rawSegments = message.split(/(?:->|→|›)/g);
		if (!Array.isArray(rawSegments) || rawSegments.length < 2) {
			return [];
		}

		const sanitizeSegment = (segment, position = "middle") => {
			let value = `${segment || ""}`.trim();
			if (position === "first") {
				const lower = value.toLowerCase();
				const markerMatches = [" under ", " inside ", " within ", " in ", " at ", " for "];
				let cutIndex = -1;
				markerMatches.forEach((marker) => {
					const idx = lower.lastIndexOf(marker);
					if (idx > cutIndex) {
						cutIndex = idx + marker.length;
					}
				});
				if (cutIndex > -1) {
					value = value.slice(cutIndex);
				}
			}
			if (position === "last") {
				value = value.replace(/\b(?:by|with|to|and|while|where)\b[\s\S]*$/i, "");
			}
			return value.replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, "").trim();
		};

		const segments = rawSegments.map((segment, index) => {
			if (index === 0) {
				return sanitizeSegment(segment, "first");
			}
			if (index === rawSegments.length - 1) {
				return sanitizeSegment(segment, "last");
			}
			return sanitizeSegment(segment, "middle");
		}).filter((segment) => segment !== "");

		return segments;
	}

	extractBulkEditTargetScope(userMessage = "") {
		const message = `${userMessage || ""}`;
		if (message.trim() === "") {
			return "";
		}

		const scopeMatch = message.match(/\b(?:under|inside|within|in)\s+(.+?)(?=\s+\b(?:by|to|and|while|where|that|which|with|setting|changing|making|updating)\b|[,.!?]|$)/i);
		if (!scopeMatch || !scopeMatch[1]) {
			return "";
		}

		return `${scopeMatch[1]}`
			.replace(/^[^a-z0-9]+|[^a-z0-9]+$/gi, "")
			.trim();
	}

	findStructureDescendantPathBySegments(structureNode = null, pathSegments = []) {
		if (!structureNode || !Array.isArray(pathSegments) || pathSegments.length === 0) {
			return null;
		}

		const normalizedSegments = pathSegments
			.map((segment) => this.normalizeStructureMatchText(segment))
			.filter((segment) => segment !== "");
		if (normalizedSegments.length === 0) {
			return null;
		}

		const matches = [];
		const labelMatches = (node, segment) => {
			return this.normalizeStructureMatchText(this.getStructureNodeDisplayLabel(node)) === segment;
		};

		const followChain = (node, currentPath = [], segmentIndex = 0) => {
			if (!node || !labelMatches(node, normalizedSegments[segmentIndex])) {
				return;
			}
			if (segmentIndex >= normalizedSegments.length - 1) {
				matches.push({
					path: currentPath,
					node
				});
				return;
			}
			if (!Array.isArray(node.children)) {
				return;
			}
			node.children.forEach((childNode, childIndex) => {
				followChain(childNode, [...currentPath, childIndex], segmentIndex + 1);
			});
		};

		const search = (node, currentPath = []) => {
			if (!node) {
				return;
			}
			followChain(node, currentPath, 0);
			if (Array.isArray(node.children)) {
				node.children.forEach((childNode, childIndex) => {
					search(childNode, [...currentPath, childIndex]);
				});
			}
		};

		search(structureNode, []);

		const seenMatchPaths = new Set();
		const uniqueMatches = matches.filter((match) => {
			const key = JSON.stringify(match.path || []);
			if (seenMatchPaths.has(key)) {
				return false;
			}
			seenMatchPaths.add(key);
			return true;
		});
		if (uniqueMatches.length !== 1) {
			return null;
		}

		return uniqueMatches[0];
	}

	findStructureAncestorPathBySegment(projectedChecklist = null, checklistPath = [], segment = "") {
		if (!projectedChecklist || !Array.isArray(checklistPath) || !segment) {
			return null;
		}

		let currentNode = projectedChecklist;
		let currentPath = [];
		let matchedPath = this.labelMatchesStructureSegment(currentNode, segment) ? [] : null;

		checklistPath.forEach((index) => {
			if (!currentNode || !Array.isArray(currentNode.children) || !currentNode.children[index]) {
				return;
			}
			currentNode = currentNode.children[index];
			currentPath = [...currentPath, index];
			if (this.labelMatchesStructureSegment(currentNode, segment)) {
				matchedPath = [...currentPath];
			}
		});

		return matchedPath;
	}

	buildBulkEditContextForChecklistPath(baseContext = null, checklistPath = [], contextLine = "") {
		if (!baseContext || !Array.isArray(checklistPath)) {
			return baseContext;
		}

		const resolvedTreePath = checklistPathToTreePath(checklistPath);
		const additionalContextLines = Array.isArray(baseContext.additionalContextLines)
			? [...baseContext.additionalContextLines]
			: [];
		if (contextLine) {
			additionalContextLines.push(contextLine);
		}

		return this.buildBulkEditContextFromTargetPath(resolvedTreePath, {
			targetReadOnly: baseContext.targetReadOnly === true,
			featureName: baseContext.featureName || "",
			featureDescription: baseContext.featureDescription || "",
			additionalContextLines
		});
	}

	describeBulkEditFilterSummary(instructions = []) {
		const filters = Array.isArray(instructions)
			? instructions
				.map((inst) => (inst && typeof inst.textContains === "string" ? inst.textContains.trim() : ""))
				.filter((value) => value !== "")
			: [];
		const uniqueFilters = Array.from(new Set(filters));
		if (uniqueFilters.length === 0) {
			return "none";
		}
		return uniqueFilters.join(", ");
	}

	formatBulkEditValueForDisplay(value) {
		if (typeof value === "string") {
			return value;
		}
		if (typeof value === "boolean") {
			return value ? "true" : "false";
		}
		if (typeof value === "number") {
			return `${value}`;
		}
		if (Array.isArray(value)) {
			return value.map((entry) => this.formatBulkEditValueForDisplay(entry)).join(", ");
		}
		if (value && typeof value === "object") {
			try {
				return JSON.stringify(value);
			} catch (_err) {
				return "[object]";
			}
		}
		return `${value}`;
	}

	describeBulkEditTargetTypes(targetTypes = []) {
		const normalized = Array.isArray(targetTypes) ? targetTypes.filter(Boolean) : [];
		if (normalized.length === 0) {
			return "matching nodes";
		}
		if (normalized.length === 1) {
			return `all descendant ${normalized[0]} nodes`;
		}
		return `all descendant ${normalized.join(", ")} nodes`;
	}

	describeBulkEditInstruction(inst = null) {
		if (!inst || typeof inst !== "object") {
			return null;
		}

		const actions = [];
		if (inst.delete === true) {
			actions.push("Delete matching nodes");
		}
		if (inst.setItemType) {
			actions.push(`Change item type to ${this.formatBulkEditValueForDisplay(inst.setItemType)}`);
		}
		if (inst.setLabel !== undefined) {
			actions.push(`Set label to ${this.formatBulkEditValueForDisplay(inst.setLabel)}`);
		}
		if (inst.setVisible !== undefined) {
			actions.push(`Set visible = ${this.formatBulkEditValueForDisplay(inst.setVisible)}`);
		}
		if (inst.setEnabled !== undefined) {
			actions.push(`Set enabled = ${this.formatBulkEditValueForDisplay(inst.setEnabled)}`);
		}
		if (inst.setProps && typeof inst.setProps === "object") {
			Object.keys(inst.setProps).forEach((key) => {
				actions.push(`Set ${key} = ${this.formatBulkEditValueForDisplay(inst.setProps[key])}`);
			});
		}
		if (Array.isArray(inst.appendNodes) && inst.appendNodes.length > 0) {
			actions.push(`Append ${inst.appendNodes.length} node${inst.appendNodes.length === 1 ? "" : "s"}`);
		}

		return {
			targetSummary: this.describeBulkEditTargetTypes(inst.targetTypes),
			filterSummary: inst.textContains ? `label/name contains "${inst.textContains}"` : "none",
			actions
		};
	}

	renderBulkEditPlanPreview() {
		if (!this.isBulkEditMode(this.state.selectedActivityOrFiles)) {
			return null;
		}

		const instructions = Array.isArray(this.state.latestBulkEditInstructions)
			? this.state.latestBulkEditInstructions
			: [];
		if (instructions.length === 0) {
			return null;
		}

		const bulkEditContext = this.getBulkEditContext();
		const rawPayload = this.getBulkEditRawPayload({ instructions }, bulkEditContext);

		return <div style={{
			marginTop: "12px",
			padding: "12px",
			borderRadius: "10px",
			border: "1px solid #2d3f57",
			backgroundColor: "#0f1827"
		}}>
			<div style={{ fontWeight: 700, color: "#f4f9ff", marginBottom: "4px" }}>Bulk Edit Plan</div>
			<div style={{ color: "#a8b8cd", marginBottom: "10px" }}>
				<div><strong>Target:</strong> {rawPayload.targetLabel} ({rawPayload.targetType})</div>
				<div><strong>Path:</strong> {rawPayload.targetPath || "(root)"}</div>
				<div><strong>Instructions:</strong> {rawPayload.instructionCount}</div>
			</div>
			<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
				{instructions.map((inst, index) => {
					const summary = this.describeBulkEditInstruction(inst);
					if (!summary) {
						return null;
					}
					return <div
						key={`bulk-edit-plan-${index}`}
						style={{
							padding: "10px 12px",
							borderRadius: "8px",
							border: "1px solid #314763",
							backgroundColor: "#122033"
						}}
					>
						<div style={{ fontWeight: 600, color: "#eaf2ff", marginBottom: "6px" }}>Instruction {index + 1}</div>
						<div style={{ color: "#c9d7ea", fontSize: "13px", lineHeight: 1.5 }}>
							<div><strong>Apply to:</strong> {summary.targetSummary}</div>
							<div><strong>Additional label filter:</strong> {summary.filterSummary}</div>
							<div style={{ marginTop: "6px" }}><strong>Actions:</strong></div>
							<ul style={{ margin: "6px 0 0 18px", padding: 0 }}>
								{summary.actions.map((action, actionIndex) => <li key={`bulk-edit-plan-${index}-action-${actionIndex}`}>{action}</li>)}
							</ul>
						</div>
					</div>;
				})}
			</div>
			<details style={{ marginTop: "12px" }}>
				<summary style={{ cursor: "pointer", color: "#9ec0e8", fontWeight: 600 }}>View Raw JSON</summary>
				<pre style={{
					marginTop: "10px",
					padding: "12px",
					borderRadius: "8px",
					backgroundColor: "#09111d",
					border: "1px solid #24364d",
					color: "#dce8f8",
					whiteSpace: "pre-wrap",
					wordBreak: "break-word"
				}}>{JSON.stringify(rawPayload, null, 2)}</pre>
			</details>
		</div>;
	}

	resolveBulkEditContextForRequest(userMessage = "") {
		const baseContext = this.getBaseBulkEditContext();
		const selectedStructureNode = baseContext && baseContext.selectedStructureNode ? baseContext.selectedStructureNode : null;
		const projectedChecklist = baseContext && baseContext.projectedChecklist ? baseContext.projectedChecklist : null;
		if (!selectedStructureNode || !projectedChecklist) {
			return baseContext;
		}

		const baseChecklistPath = Array.isArray(baseContext.checklistPath) ? baseContext.checklistPath : [];
		const pathSegments = this.extractBulkEditPathSegments(userMessage);
		if (Array.isArray(pathSegments) && pathSegments.length > 0) {
			const absoluteMatch = this.findStructureDescendantPathBySegments(projectedChecklist, pathSegments);
			if (absoluteMatch && Array.isArray(absoluteMatch.path)) {
				const resolvedPathLabel = this.buildStructurePathLabel(projectedChecklist, absoluteMatch.path);
				return this.buildBulkEditContextForChecklistPath(baseContext, absoluteMatch.path, `Resolved prompt path target: ${resolvedPathLabel}`);
			}

			const relativeMatch = this.findStructureDescendantPathBySegments(selectedStructureNode, pathSegments);
			if (relativeMatch && Array.isArray(relativeMatch.path)) {
				const resolvedChecklistPath = baseChecklistPath.concat(relativeMatch.path);
				const resolvedPathLabel = this.buildStructurePathLabel(projectedChecklist, resolvedChecklistPath);
				return this.buildBulkEditContextForChecklistPath(baseContext, resolvedChecklistPath, `Resolved prompt path target: ${resolvedPathLabel}`);
			}
		}

		const scopedTarget = this.extractBulkEditTargetScope(userMessage);
		if (!scopedTarget) {
			return baseContext;
		}

		const ancestorPath = this.findStructureAncestorPathBySegment(projectedChecklist, baseChecklistPath, scopedTarget);
		if (Array.isArray(ancestorPath)) {
			const resolvedPathLabel = this.buildStructurePathLabel(projectedChecklist, ancestorPath);
			return this.buildBulkEditContextForChecklistPath(baseContext, ancestorPath, `Resolved prompt scope target: ${resolvedPathLabel}`);
		}

		const selectedSubtreeMatch = this.findStructureDescendantPathBySegments(selectedStructureNode, [scopedTarget]);
		if (selectedSubtreeMatch && Array.isArray(selectedSubtreeMatch.path)) {
			const resolvedChecklistPath = baseChecklistPath.concat(selectedSubtreeMatch.path);
			const resolvedPathLabel = this.buildStructurePathLabel(projectedChecklist, resolvedChecklistPath);
			return this.buildBulkEditContextForChecklistPath(baseContext, resolvedChecklistPath, `Resolved prompt scope target: ${resolvedPathLabel}`);
		}

		const absoluteMatch = this.findStructureDescendantPathBySegments(projectedChecklist, [scopedTarget]);
		if (absoluteMatch && Array.isArray(absoluteMatch.path)) {
			const resolvedPathLabel = this.buildStructurePathLabel(projectedChecklist, absoluteMatch.path);
			return this.buildBulkEditContextForChecklistPath(baseContext, absoluteMatch.path, `Resolved prompt scope target: ${resolvedPathLabel}`);
		}

		return baseContext;
	}

	buildBulkEditPrompt(userMessage = "", bulkEditContextOverride = null) {
		const bulkEditContext = bulkEditContextOverride || this.getBulkEditContext();
		const targetNode = bulkEditContext && bulkEditContext.selectedStructureNode
			? bulkEditContext.selectedStructureNode
			: null;
		const targetPathLabel = bulkEditContext
			? this.buildStructurePathLabel(bulkEditContext.projectedChecklist, bulkEditContext.checklistPath)
			: "";
		const nodeCounts = this.buildStructureNodeCounts(targetNode);
		const outlineSummary = this.buildStructureOutlineSummary(targetNode, {
			selectedPath: [],
			maxNodes: 120
		});
		const contextLines = bulkEditContext && Array.isArray(bulkEditContext.additionalContextLines)
			? bulkEditContext.additionalContextLines
			: [];

		return [
			"You are generating AmbiFi bulk edit instructions for an existing outline subtree.",
			"Understand the existing structure and schema before proposing mutations.",
			"Treat path-like references such as `List 1 -> Section 1` as structural paths, not as label substring filters.",
			"References such as `under List 1` or `within Section 1` mean the bulk edit target should be retargeted to that structural node before generating instructions.",
			"Lists and sections are recursive containers. Requests like `all items under List 1` should apply to every descendant item under that list, including items nested through sections or item containers, not just direct children.",
			"When the user asks to add, append, insert, or create new nodes under the target, return `appendNodes` on a single instruction. Do not rename existing nodes when the request is to add new ones.",
			"`appendNodes` should describe the new child nodes to create under the resolved target, using valid types such as list, section, or item.",
			"Only use `textContains` when the user explicitly asks to filter by label/name text or contains/matching rules.",
			"Do not invent item types. Only use valid AmbiFi item types.",
			"Label-only checklist rows must use `setItemType: \"item\"` with `setProps: { \"labelOnly\": true }`. Never use an item type like `itemLabelOnly`.",
			`Selected target path: ${targetPathLabel || "(root)"}`,
			`Selected target node: ${bulkEditContext.targetLabel || "(none)"} (${bulkEditContext.targetType || "node"})`,
			`Selected target subtree counts: total=${nodeCounts.total}, lists=${nodeCounts.list}, sections=${nodeCounts.section}, itemContainers=${nodeCounts.itemContainer}, leafItems=${nodeCounts.items}`,
			contextLines.length > 0 ? `Additional context:\n- ${contextLines.join("\n- ")}` : "",
			outlineSummary ? `Selected target subtree outline:\n${outlineSummary}` : "",
			`User request:\n${userMessage}`
		].filter(Boolean).join("\n\n");
	}

	isStructureAnalysisRequest(userMessage = "", structureIntent = null) {
		const message = typeof userMessage === "string" ? userMessage.trim() : "";
		if (message === "") {
			return false;
		}

		const generationMode = structureIntent && typeof structureIntent.generationMode === "string"
			? structureIntent.generationMode
			: "";
		if (generationMode === "structuredInput" || generationMode === "structurePatch" || generationMode === "subtreeRevision") {
			return false;
		}

		const lower = message.toLowerCase();
		const hasQuestionTone = (
			message.indexOf("?") > -1 ||
			/^(can|could|would|will|what|which|who|when|where|why|how|is|are|does|do|did)\b/.test(lower) ||
			/\b(tell me|show me|list|summarize|summary|describe|explain|walk me through|give me)\b/.test(lower)
		);
		const referencesExistingStructure = (
			/\b(current|existing|selected|already|created|have|this|that)\b/.test(lower) &&
			/\b(outline|activity|checklist|tree|structure|node|nodes|children|lists?|sections?|items?)\b/.test(lower)
		) ||
		/\b(current outline|existing outline|selected node|selected section|selected list|selected item|activity structure|checklist structure)\b/.test(lower);
		const generationVerbWithoutExistingReference = /\b(create|generate|build|draft|add|insert|append|prepend|make|revise|modify|update|replace)\b/.test(lower) && !referencesExistingStructure;

		return hasQuestionTone && referencesExistingStructure && !generationVerbWithoutExistingReference;
	}

	buildStructureAnalysisPrompt(userMessage = "", structureContextOverride = null) {
		const structureContext = structureContextOverride || this.getStructureContext();
		const selectedSubtreeRaw = JSON.stringify(structureContext.selectedStructureNode || structureContext.projectedChecklist || {}, null, 2);
		const selectedSubtree = selectedSubtreeRaw.length > MAX_STRUCTURE_SELECTED_SUBTREE_CHARS
			? `${selectedSubtreeRaw.slice(0, MAX_STRUCTURE_SELECTED_SUBTREE_CHARS)}\n... [selected subtree truncated]`
			: selectedSubtreeRaw;
		const authoringSummary = this.authoringContextSummary
			? this.cleanContextText(this.authoringContextSummary, 1600)
			: "";
		const outlineSummary = this.buildStructureOutlineSummary(structureContext.projectedChecklist, {
			selectedPath: structureContext.checklistPath,
			maxNodes: MAX_STRUCTURE_OUTLINE_SUMMARY_NODES
		});
		const nodeCounts = this.buildStructureNodeCounts(structureContext.projectedChecklist);
		const selectedPathLabel = this.buildStructurePathLabel(structureContext.projectedChecklist, structureContext.checklistPath);

		return [
			"You are working in AmbiFi AI Structure Studio.",
			"Answer questions about the current activity outline and selected node in plain language.",
			"Do not generate JSON, YAML, structure patches, or new AmbiFi nodes unless the user explicitly asks to create or revise structure.",
			"If the user asks for a summary, inventory, counts, names, types, or traversal details, answer directly from the supplied outline context.",
			"Be concrete and accurate about what exists today in the outline.",
			`Selected node label: ${structureContext.targetLabel || "(none)"}`,
			`Selected node type: ${structureContext.targetType || "checklist"}`,
			`Selected node path: ${selectedPathLabel || "(root)"}`,
			`Outline counts: total=${nodeCounts.total}, lists=${nodeCounts.list}, sections=${nodeCounts.section}, itemContainers=${nodeCounts.itemContainer}, leafItems=${nodeCounts.items}`,
			authoringSummary ? `AmbiFi authoring context summary:\n${authoringSummary}` : "",
			outlineSummary ? `Current outline summary:\n${outlineSummary}` : "",
			`Selected subtree JSON:\n\`\`\`json\n${selectedSubtree}\n\`\`\``,
			`User question:\n${userMessage}`
		].filter(Boolean).join("\n\n");
	}

	getLatestStructureSubtreeSpec() {
		if (this.state.lastResponseMode !== STRUCTURE_ASSISTANT_MODE) {
			return null;
		}
		if (this.state.latestStructureSubtreeSpec) {
			return this.state.latestStructureSubtreeSpec;
		}
		const structureContext = this.getStructureContext();
		return normalizeGeneratedSubtreeSpecV1(coerceSubtreeSpecV1(this.props.aiAssistantResponseLast || ""), {
			selectedType: structureContext && structureContext.targetType ? structureContext.targetType : "",
			selectedName: structureContext && structureContext.targetLabel ? structureContext.targetLabel : "",
			generationMode: this.state.lastStructureGenerationMode || ""
		});
	}

	getStructureRawPayload(subtreeSpec = null, structureContextOverride = null) {
		const structureContext = structureContextOverride || this.getStructureContext();
		const normalizedSubtreeSpec = subtreeSpec || this.getLatestStructureSubtreeSpec();
		const targetPathLabel = structureContext
			? this.buildStructurePathLabel(structureContext.projectedChecklist, structureContext.checklistPath)
			: "";

		return {
			targetLabel: structureContext && structureContext.targetLabel ? structureContext.targetLabel : "Selected Node",
			targetType: structureContext && structureContext.targetType ? structureContext.targetType : "node",
			targetPath: targetPathLabel || "",
			generationMode: this.state.lastStructureGenerationMode || "",
			structure: normalizedSubtreeSpec
		};
	}

	getStructurePlanSummary(subtreeSpec = null) {
		const normalizedSubtreeSpec = subtreeSpec || this.getLatestStructureSubtreeSpec();
		if (!normalizedSubtreeSpec) {
			return null;
		}

		if (normalizedSubtreeSpec.checklist && typeof normalizedSubtreeSpec.checklist === "object") {
			return {
				kindLabel: "Checklist",
				topNodes: Array.isArray(normalizedSubtreeSpec.checklist.children) ? normalizedSubtreeSpec.checklist.children : [],
				counts: this.buildStructureNodeCounts(normalizedSubtreeSpec.checklist)
			};
		}

		const topNodes = Array.isArray(normalizedSubtreeSpec.nodes) ? normalizedSubtreeSpec.nodes : [];
		return {
			kindLabel: topNodes.length === 1 ? "Single Node" : "Node Set",
			topNodes,
			counts: this.buildStructureNodeCountsForList(topNodes)
		};
	}

	renderStructurePlanPreview() {
		if (!this.isStructureMode(this.state.selectedActivityOrFiles)) {
			return null;
		}

		const subtreeSpec = this.getLatestStructureSubtreeSpec();
		if (!subtreeSpec || this.state.lastStructureGenerationMode === "analysis") {
			return null;
		}

		const structureContext = this.getStructureContext();
		const rawPayload = this.getStructureRawPayload(subtreeSpec, structureContext);
		const summary = this.getStructurePlanSummary(subtreeSpec);
		const applyChoices = this.getStructureApplyChoices(subtreeSpec);
		const topNodes = summary && Array.isArray(summary.topNodes) ? summary.topNodes : [];
		const counts = summary && summary.counts ? summary.counts : this.buildStructureNodeCountsForList([]);

		return <div style={{
			marginTop: "12px",
			padding: "12px",
			borderRadius: "10px",
			border: "1px solid #2d3f57",
			backgroundColor: "#0f1827"
		}}>
			<div style={{ fontWeight: 700, color: "#f4f9ff", marginBottom: "4px" }}>Structure Plan</div>
			<div style={{ color: "#a8b8cd", marginBottom: "10px", lineHeight: 1.5 }}>
				<div><strong>Target:</strong> {rawPayload.targetLabel} ({rawPayload.targetType})</div>
				<div><strong>Path:</strong> {rawPayload.targetPath || "(root)"}</div>
				<div><strong>Generated:</strong> {summary ? summary.kindLabel : "Structure"}</div>
				<div><strong>Counts:</strong> total={counts.total}, lists={counts.list}, sections={counts.section}, itemContainers={counts.itemContainer}, leafItems={counts.items}</div>
			</div>
			{topNodes.length > 0 &&
				<div style={{ marginBottom: "10px" }}>
					<div style={{ fontWeight: 600, color: "#eaf2ff", marginBottom: "6px" }}>Top-Level Generated Nodes</div>
					<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
						{topNodes.map((node, index) => <div
							key={`structure-plan-top-node-${index}`}
							style={{
								padding: "10px 12px",
								borderRadius: "8px",
								border: "1px solid #314763",
								backgroundColor: "#122033",
								color: "#c9d7ea"
							}}
						>
							<div style={{ fontWeight: 600, color: "#eaf2ff" }}>{this.getStructureNodeDisplayLabel(node)}</div>
							<div style={{ fontSize: "13px" }}>
								<strong>Type:</strong> {node.type || "node"}
								{Array.isArray(node.children) && <span> | <strong>Children:</strong> {node.children.length}</span>}
							</div>
						</div>)}
					</div>
				</div>
			}
			<div style={{ marginBottom: "10px", color: "#c9d7ea" }}>
				<div style={{ fontWeight: 600, color: "#eaf2ff", marginBottom: "6px" }}>Apply Options</div>
				{applyChoices.length > 0
					? <ul style={{ margin: 0, paddingLeft: "18px" }}>
						{applyChoices.map((choice) => <li key={choice.key}>
							{choice.label}
							{choice.recommended ? " (recommended)" : ""}
						</li>)}
					</ul>
					: <div>No valid apply actions are available for the current target.</div>
				}
			</div>
			<details style={{ marginTop: "12px" }}>
				<summary style={{ cursor: "pointer", color: "#9ec0e8", fontWeight: 600 }}>View Raw JSON</summary>
				<pre style={{
					marginTop: "10px",
					padding: "12px",
					borderRadius: "8px",
					backgroundColor: "#09111d",
					border: "1px solid #24364d",
					color: "#dce8f8",
					whiteSpace: "pre-wrap",
					wordBreak: "break-word"
				}}>{JSON.stringify(rawPayload.structure, null, 2)}</pre>
			</details>
		</div>;
	}

	getStructureApplyChoices(subtreeSpec = null) {
		const structureContext = this.getStructureContext();
		const normalizedSubtreeSpec = subtreeSpec || this.getLatestStructureSubtreeSpec();
		if (!structureContext || !normalizedSubtreeSpec) {
			return [];
		}

		return resolveStructureStudioApplyChoices({
			selectedType: structureContext.targetType,
			parentType: structureContext.parentType,
			generationMode: this.state.lastStructureGenerationMode || "",
			selectedPath: structureContext.checklistPath,
			selectedChildren: Array.isArray(structureContext.selectedStructureNode && structureContext.selectedStructureNode.children)
				? structureContext.selectedStructureNode.children
				: [],
			parentChildren: Array.isArray(structureContext.parentStructureNode && structureContext.parentStructureNode.children)
				? structureContext.parentStructureNode.children
				: []
		}, normalizedSubtreeSpec);
	}

	getInsertedChecklistPathForApplyChoice(structureContext = null, subtreeSpec = null, applyChoice = null) {
		if (!structureContext || !applyChoice) {
			return [];
		}

		if (applyChoice.key === "replaceActivity") {
			return [];
		}

		const selectedChecklistPath = Array.isArray(structureContext.checklistPath) ? structureContext.checklistPath : [];
		const selectedStructureNode = structureContext.selectedStructureNode || structureContext.projectedChecklist || {};
		const currentChildren = Array.isArray(selectedStructureNode.children) ? selectedStructureNode.children : [];

		if (applyChoice.key === "appendChildren") {
			return [...selectedChecklistPath, currentChildren.length];
		}

		if (selectedChecklistPath.length === 0) {
			return [];
		}

		const parentPath = selectedChecklistPath.slice(0, -1);
		const selectedIndex = selectedChecklistPath[selectedChecklistPath.length - 1];
		if (applyChoice.key === "insertBefore") {
			return [...parentPath, selectedIndex];
		}
		if (applyChoice.key === "insertAfter") {
			return [...parentPath, selectedIndex + 1];
		}

		const nodes = subtreeSpec && Array.isArray(subtreeSpec.nodes) ? subtreeSpec.nodes : [];
		if (nodes.length > 0) {
			return selectedChecklistPath;
		}
		return [];
	}

	buildStructureModePrompt(userMessage = "", structureIntent = null, structureContextOverride = null) {
		const structureContext = structureContextOverride || this.getStructureContext();
		const selectedSubtreeRaw = JSON.stringify(structureContext.selectedStructureNode || structureContext.projectedChecklist || {}, null, 2);
		const selectedSubtree = selectedSubtreeRaw.length > 9000
			? `${selectedSubtreeRaw.slice(0, 9000)}\n... [selected subtree truncated]`
			: selectedSubtreeRaw;
		const additionalContextLines = Array.isArray(structureContext.additionalContextLines)
			? structureContext.additionalContextLines
			: [];
		const authoringSummary = this.authoringContextSummary
			? this.cleanContextText(this.authoringContextSummary, 1800)
			: "";
		const generationMode = structureIntent && typeof structureIntent.generationMode === "string"
			? structureIntent.generationMode
			: "contentPlan";
		const operationInstructions = structureIntent && structureIntent.requestedOperation === "appendChildren"
			? [
				"This request is asking for children to be added under the selected target.",
				"Return only the child nodes to append. Do not wrap them in another copy of the selected section, list, or checklist.",
				structureContext.targetType === "checklist" && Array.isArray(structureContext.selectedStructureNode && structureContext.selectedStructureNode.children) && structureContext.selectedStructureNode.children.length > 0
					? `Because the checklist root already has children and its first child is type "${((structureContext.selectedStructureNode || {}).children || [])[0] && ((structureContext.selectedStructureNode || {}).children || [])[0].type ? ((structureContext.selectedStructureNode || {}).children || [])[0].type : ""}", return only nodes compatible with that root child type.`
					: "",
				structureContext.targetType === "section"
					? "Because the selected target is a section, return only item or itemContainer nodes."
					: (structureContext.targetType === "list"
						? "Because the selected target is a list, return only section nodes."
						: (structureContext.targetType === "itemContainer"
							? "Because the selected target is an itemContainer, return only item or itemContainer nodes."
							: "Return only valid direct children for the selected target type."))
			].join("\n")
			: "";
		const revisionInstructions = generationMode === "subtreeRevision"
			? [
				"This request is a revision of the current selected subtree.",
				"Return the fully revised subtree for the selected node itself, not a brand-new child node.",
				"Preserve existing useful content unless the user explicitly asks to remove or replace it.",
				`If the selected node type is "${structureContext.targetType || "checklist"}", return that same node type unless the user explicitly asks for a different root type.`,
				"Do not return empty wrapper lists, sections, or containers.",
				structureContext.targetType === "checklist"
					? [
						"Because the selected target is the checklist root, return a full checklist object for revisions.",
						"Do not return a bare list, bare section, or bare child-node array when revising the checklist root.",
						"If you convert existing root sections into lists, preserve their content by placing their former items into one or more sections inside each new list."
					].join("\n")
					: ""
			].join("\n")
			: "";

		return [
			"You are working in AmbiFi AI Structure Studio.",
			"Return only structure JSON or YAML. Do not return markdown explanations, patch operations, or commentary.",
			"The app decides whether your generated subtree becomes children, siblings, or replaces the activity.",
			"Return one of these shapes only:",
			"- a single node object",
			"- an array of sibling nodes",
			"- a full checklist object only if the user explicitly asks for an entire activity",
			"Canonical structure rules:",
			"- checklist: { type: \"checklist\", name, children }",
			"- list: { type: \"list\", name, children: [section, ...] }",
			"- section: { type: \"section\", name, children: [item/itemContainer, ...] }",
			"- itemContainer: { type: \"itemContainer\", label1, optional label2, children: [item/itemContainer, ...] }",
			"- leaf item: { type, label1, optional label2, optional labelOnly }",
			"- label-only rows use type \"item\" with labelOnly: true",
			"Placement rules:",
			"- An empty checklist root may contain lists, sections, or items.",
			"- A non-empty checklist root may only add more children matching the structural class of its first child: list, section, or item.",
			"- Lists may only contain sections, and list siblings must also be lists.",
			"- Sections may only contain items or itemContainers, and section siblings must also be sections.",
			"- itemContainers may contain items and nested itemContainers.",
			"- Leaf items cannot have children; they only participate as siblings inside section or itemContainer content.",
			"Authoring guidance:",
			"- Prefer lists and sections when hierarchy is meaningful.",
			"- At the activity root, prefer list or section nodes over plain items and itemContainers.",
			"- Use itemContainer only when the selected parent already expects nested item groups. Do not use itemContainer as a substitute for list or section when list or section is allowed.",
			"- For recipes and procedures, use list for major buckets such as Ingredients or Instructions, then use sections inside those lists for subgroupings.",
			"- Prefer plain items for checklist/reference content.",
			"- Do not use labelOnly for structural headings or grouping.",
			"- Use labelOnly only for informational content that should render as a non-checklist card with an acknowledgment action such as OK, Next, or Continue.",
			"- Do not use interactive input item types unless the user clearly asks for input fields.",
			"- If the user asks for a specific node type and explicit name, return exactly that node and do not invent extra content.",
			operationInstructions,
			revisionInstructions,
			`Selected target node label: ${structureContext.targetLabel || "(none)"}`,
			`Selected target node type: ${structureContext.targetType || "checklist"}`,
			`Selected target parent type: ${structureContext.parentType || "(activity root)"}`,
			structureContext.featureName ? `Feature: ${structureContext.featureName}` : "",
			structureContext.featureDescription ? `Feature description: ${structureContext.featureDescription}` : "",
			additionalContextLines.length > 0 ? `Additional context:\n${additionalContextLines.map((line) => `- ${line}`).join("\n")}` : "",
			authoringSummary ? `AmbiFi authoring context summary:\n${authoringSummary}` : "",
			`Current selected subtree example:\n\`\`\`json\n${selectedSubtree}\n\`\`\``,
			`User request:\n${userMessage}`
		].filter(Boolean).join("\n\n");
	}

	getDefaultScriptContext(mode) {
		if (mode === SCRIPT_ASSISTANT_MODE_FUNCTIONS) {
			return {
				mode,
				targetPath: ["tree", "root", "entity", "functions"],
				targetLabel: "Activity Functions",
				targetReadOnly: false,
				featureName: "Functions",
				featureDescription: "Activity-level reusable script functions.",
				additionalContextLines: [
					"This is the activity-level Functions script.",
					"Use AmbiFi runtime API through af.* methods."
				]
			};
		}

		if (mode === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER) {
			const selected = this.getSelectedNodeEntity();
			const selectedEntity = selected.entity || {};
			if (!selected.entity || selected.entity.type !== "item") {
				return null;
			}
			const itemId = selectedEntity.id || selectedEntity.guid || "";
			return {
				mode,
				targetPath: [...selected.nodePath, "entity", "valueTrigger"],
				targetLabel: itemId ? `Value Trigger for ${itemId}` : "Selected Item Value Trigger",
				targetReadOnly: false,
				featureName: "Value Trigger",
				featureDescription: "Item-level script triggered as value changes.",
				additionalContextLines: [
					`Current item type: ${selectedEntity.type || "(none)"}`,
					`Current item label 1: ${selectedEntity.label || "(none)"}`,
					`Current item label 2: ${selectedEntity.label2 || "(none)"}`,
					"Avoid recursive write loops when using af.setValue in Value Trigger."
				]
			};
		}

		return null;
	}

	getScriptContextForMode(mode) {
		const stateContext = this.state.scriptContext;
		const requestedContext = stateContext && stateContext.mode === mode ? stateContext : null;
		let baseContext = requestedContext;
		if (!baseContext || !Array.isArray(baseContext.targetPath) || baseContext.targetPath.length === 0) {
			baseContext = this.getDefaultScriptContext(mode);
		}

		if (!baseContext || !Array.isArray(baseContext.targetPath) || baseContext.targetPath.length === 0) {
			return null;
		}

		const currentScriptRaw = state.get(baseContext.targetPath);
		const currentScript = typeof currentScriptRaw === "string" ? currentScriptRaw : "";

		return {
			...baseContext,
			currentScript
		};
	}

	getActivityScriptingInventory() {
		const rootEntity = state.get(["tree", "root", "entity"]);
		if (!rootEntity || typeof rootEntity !== "object") {
			return {
				activityName: "",
				functionsScript: "",
				counts: { lists: 0, sections: 0, items: 0 },
				valueTriggers: []
			};
		}

		const counts = {
			lists: 0,
			sections: 0,
			items: 0
		};
		const valueTriggers = [];
		const functionsScript = typeof rootEntity.functions === "string" ? rootEntity.functions : "";
		const activityName = typeof rootEntity.name === "string"
			? rootEntity.name
			: (typeof rootEntity.title === "string" ? rootEntity.title : "");

		const visitEntity = (entity, context = {}) => {
			if (!entity || typeof entity !== "object") {
				return;
			}

			const entityType = typeof entity.type === "string" ? entity.type : "";
			const isItem = entityType === "item" || entityType.indexOf("item") === 0;
			let nextContext = context;

			if (entityType === "list") {
				counts.lists += 1;
				nextContext = {
					...context,
					listName: typeof entity.name === "string" ? entity.name : (typeof entity.title === "string" ? entity.title : ""),
					listId: entity.id || entity.guid || ""
				};
			} else if (entityType === "section") {
				counts.sections += 1;
				nextContext = {
					...context,
					sectionName: typeof entity.name === "string" ? entity.name : (typeof entity.title === "string" ? entity.title : ""),
					sectionId: entity.id || entity.guid || ""
				};
			} else if (isItem) {
				counts.items += 1;
				const rawValueTrigger = typeof entity.valueTrigger === "string" ? entity.valueTrigger : "";
				const valueTrigger = rawValueTrigger.trim();
				if (valueTrigger !== "") {
					valueTriggers.push({
						itemId: entity.id || entity.guid || "",
						itemType: entityType,
						label1: typeof entity.label === "string" ? entity.label : (typeof entity.label1 === "string" ? entity.label1 : ""),
						label2: typeof entity.label2 === "string" ? entity.label2 : "",
						listName: nextContext.listName || "",
						sectionName: nextContext.sectionName || "",
						script: rawValueTrigger
					});
				}
			}

			if (Array.isArray(entity.children) && entity.children.length > 0) {
				entity.children.forEach((child) => visitEntity(child, nextContext));
			}
		};

		visitEntity(rootEntity, {});

		return {
			activityName,
			functionsScript,
			counts,
			valueTriggers
		};
	}

	extractScriptTargetItemId(scriptContext = null) {
		if (!scriptContext || scriptContext.mode !== SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER) {
			return "";
		}
		const label = typeof scriptContext.targetLabel === "string" ? scriptContext.targetLabel : "";
		const match = label.match(/Value Trigger for (.+)$/);
		return match && match[1] ? match[1].trim() : "";
	}

	truncateScriptContextText(text = "", maxChars = 400) {
		if (!text || typeof text !== "string") {
			return "";
		}
		if (text.length <= maxChars) {
			return text;
		}
		const headChars = Math.max(0, Math.floor((maxChars - 42) / 2));
		const tailChars = Math.max(0, maxChars - headChars - 42);
		return `${text.slice(0, headChars)}\n/* ... truncated ... */\n${text.slice(text.length - tailChars)}`;
	}

	getPromptTokenSet(message = "") {
		const tokens = (message || "").toLowerCase().match(/[a-z0-9_/-]{2,}/g) || [];
		return new Set(tokens);
	}

	buildActivityScriptingPromptContext(scriptContext = null, userMessage = "") {
		const inventory = this.getActivityScriptingInventory();
		const tokenSet = this.getPromptTokenSet(userMessage);
		const functionsScript = inventory.functionsScript || "";
		const valueTriggersRaw = Array.isArray(inventory.valueTriggers) ? inventory.valueTriggers : [];
		const activeItemId = this.extractScriptTargetItemId(scriptContext);
		const currentScript = scriptContext && typeof scriptContext.currentScript === "string" ? scriptContext.currentScript.trim() : "";
		const functionsScriptTrimmed = functionsScript.trim();

		let currentScriptMatchedAsValueTrigger = false;
		const valueTriggers = valueTriggersRaw.filter((entry) => {
			if (!entry || typeof entry.script !== "string") {
				return false;
			}

			const entryScriptTrimmed = entry.script.trim();
			const isActiveItem = activeItemId !== "" && entry.itemId === activeItemId;
			if (isActiveItem) {
				return false;
			}

			if (!currentScriptMatchedAsValueTrigger &&
				scriptContext &&
				scriptContext.mode === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER &&
				currentScript !== "" &&
				entryScriptTrimmed === currentScript) {
				currentScriptMatchedAsValueTrigger = true;
				return false;
			}

			return true;
		});

		const scoreEntry = (entry) => {
			let score = 0;
			const itemId = (entry.itemId || "").toLowerCase();
			const label1 = (entry.label1 || "").toLowerCase();
			const label2 = (entry.label2 || "").toLowerCase();
			const listName = (entry.listName || "").toLowerCase();
			const sectionName = (entry.sectionName || "").toLowerCase();
			const script = (entry.script || "").toLowerCase();

			tokenSet.forEach((token) => {
				if (token.length < 3) {
					return;
				}
				if (itemId.indexOf(token) > -1) {
					score += 8;
				}
				if (label1.indexOf(token) > -1 || label2.indexOf(token) > -1) {
					score += 6;
				}
				if (listName.indexOf(token) > -1 || sectionName.indexOf(token) > -1) {
					score += 3;
				}
				if (script.indexOf(token) > -1) {
					score += 1;
				}
			});

			return score;
		};

		const rankedValueTriggers = valueTriggers
			.map((entry) => ({
				...entry,
				score: scoreEntry(entry)
			}))
			.sort((a, b) => {
				if (b.score !== a.score) {
					return b.score - a.score;
				}
				return (a.itemId || "").localeCompare(b.itemId || "");
			});

		const sectionParts = [];
		let totalChars = 0;
		const appendSection = (text) => {
			if (!text || typeof text !== "string") {
				return false;
			}
			const trimmed = text.trim();
			if (!trimmed) {
				return false;
			}

			const separator = sectionParts.length > 0 ? 2 : 0;
			if (totalChars + separator + trimmed.length <= MAX_SCRIPT_CONTEXT_CHARS) {
				sectionParts.push(trimmed);
				totalChars += separator + trimmed.length;
				return true;
			}

			const remaining = MAX_SCRIPT_CONTEXT_CHARS - totalChars - separator;
			if (remaining <= 96) {
				return false;
			}

			const clipped = `${trimmed.slice(0, remaining - 24)}\n...[context truncated]`;
			sectionParts.push(clipped);
			totalChars = MAX_SCRIPT_CONTEXT_CHARS;
			return false;
		};

		appendSection([
			"Activity scripting inventory:",
			`- Activity: ${inventory.activityName || "(unnamed activity)"}`,
			`- Lists: ${inventory.counts.lists}, Sections: ${inventory.counts.sections}, Items: ${inventory.counts.items}`,
			`- Functions script present: ${functionsScriptTrimmed ? "yes" : "no"}`,
			`- Non-empty Value Triggers: ${valueTriggersRaw.length}`
		].join("\n"));

		const shouldIncludeFunctionsScript = !!functionsScriptTrimmed &&
			!(scriptContext && scriptContext.mode === SCRIPT_ASSISTANT_MODE_FUNCTIONS && currentScript === functionsScriptTrimmed);
		if (shouldIncludeFunctionsScript) {
			appendSection([
				"Activity Functions script context:",
				this.truncateScriptContextText(functionsScript, MAX_SCRIPT_FUNCTIONS_CHARS)
			].join("\n"));
		}

		let includedValueTriggers = 0;
		let omittedValueTriggers = 0;
		for (let i = 0; i < rankedValueTriggers.length; i++) {
			if (includedValueTriggers >= MAX_SCRIPT_VALUE_TRIGGER_ENTRIES) {
				omittedValueTriggers += (rankedValueTriggers.length - i);
				break;
			}

			const entry = rankedValueTriggers[i];
			const meta = [
				`itemId=${entry.itemId || "(none)"}`,
				`type=${entry.itemType || "(item)"}`,
				entry.label1 ? `label1=${entry.label1}` : "",
				entry.label2 ? `label2=${entry.label2}` : "",
				entry.listName ? `list=${entry.listName}` : "",
				entry.sectionName ? `section=${entry.sectionName}` : ""
			].filter(Boolean).join(" | ");

			const didAppend = appendSection([
				`Value Trigger context (${includedValueTriggers + 1}): ${meta}`,
				this.truncateScriptContextText(entry.script, MAX_SCRIPT_VALUE_TRIGGER_CHARS)
			].join("\n"));

			if (!didAppend) {
				omittedValueTriggers += (rankedValueTriggers.length - i);
				break;
			}
			includedValueTriggers += 1;
		}

		if (omittedValueTriggers > 0) {
			appendSection(`Additional value trigger scripts omitted due to prompt limits: ${omittedValueTriggers}.`);
		}

		const contextSummaryLines = [
			`Activity scripting context attached: functions=${functionsScriptTrimmed ? "yes" : "no"}, valueTriggers=${valueTriggersRaw.length}.`,
			`Included value trigger script contexts in prompt: ${includedValueTriggers}${omittedValueTriggers > 0 ? ` (${omittedValueTriggers} omitted for size)` : ""}.`
		];

		return {
			activityScriptingContext: sectionParts.join("\n\n"),
			contextSummaryLines
		};
	}

	buildActivityAnalysisValueTriggerSummary(inventory = null) {
		const valueTriggers = inventory && Array.isArray(inventory.valueTriggers)
			? inventory.valueTriggers
			: [];
		if (valueTriggers.length === 0) {
			return "Value Trigger inventory:\n- None";
		}

		const lines = ["Value Trigger inventory:"];
		let totalChars = lines[0].length;
		let included = 0;
		let omitted = 0;

		for (let i = 0; i < valueTriggers.length; i++) {
			if (included >= MAX_ACTIVITY_ANALYSIS_VALUE_TRIGGER_ENTRIES) {
				omitted = valueTriggers.length - i;
				break;
			}

			const entry = valueTriggers[i] || {};
			const line = [
				`- itemId=${entry.itemId || "(none)"}`,
				`type=${entry.itemType || "item"}`,
				entry.label1 ? `label1=${entry.label1}` : "",
				entry.label2 ? `label2=${entry.label2}` : "",
				entry.listName ? `list=${entry.listName}` : "",
				entry.sectionName ? `section=${entry.sectionName}` : ""
			].filter(Boolean).join(" | ");

			if (totalChars + line.length + 1 > MAX_ACTIVITY_ANALYSIS_VALUE_TRIGGER_CHARS) {
				omitted = valueTriggers.length - i;
				break;
			}

			lines.push(line);
			totalChars += line.length + 1;
			included += 1;
		}

		if (omitted > 0) {
			lines.push(`- ... ${omitted} additional value trigger entries omitted`);
		}

		return lines.join("\n");
	}

	getActivityAnalysisContext() {
		const rootNode = state.get(["tree", "root"]);
		const rootEntity = state.get(["tree", "root", "entity"]) || {};
		const activityName = typeof rootEntity.name === "string"
			? rootEntity.name
			: (typeof rootEntity.title === "string" ? rootEntity.title : "");
		const rootStructureContext = this.buildStructureContextFromTargetPath(["tree", "root"], {
			targetLabel: activityName || "Current Activity",
			featureName: "Activity Analysis",
			featureDescription: "Read-only analysis of the current activity JSON and outline."
		});
		const selected = this.getSelectedNodeEntity();
		const selectedChecklistPath = treePathToChecklistPath(selected && Array.isArray(selected.nodePath) ? selected.nodePath : []);
		const selectedEntity = selected && selected.entity ? selected.entity : null;
		const selectedType = selectedEntity && typeof selectedEntity.type === "string" ? selectedEntity.type : "";
		const selectedPathLabel = rootStructureContext.projectedChecklist
			? this.buildStructurePathLabel(rootStructureContext.projectedChecklist, selectedChecklistPath)
			: "";
		const inventory = this.getActivityScriptingInventory();

		let activityJson = "";
		let activityJsonTruncated = false;
		let activityJsonWarning = "";
		try {
			const publishedChecklist = transformFromChecklistEntities(rootNode, false, false, false);
			const rawJson = JSON.stringify(publishedChecklist || {}, null, 2);
			if (rawJson.length > MAX_ACTIVITY_ANALYSIS_JSON_CHARS) {
				activityJson = `${rawJson.slice(0, MAX_ACTIVITY_ANALYSIS_JSON_CHARS)}\n... [activity JSON truncated]`;
				activityJsonTruncated = true;
			} else {
				activityJson = rawJson;
			}
		} catch (err) {
			activityJsonWarning = err && err.message ? err.message : "Unable to serialize current activity JSON.";
			try {
				const fallbackJson = JSON.stringify(rootEntity || {}, null, 2);
				if (fallbackJson.length > MAX_ACTIVITY_ANALYSIS_JSON_CHARS) {
					activityJson = `${fallbackJson.slice(0, MAX_ACTIVITY_ANALYSIS_JSON_CHARS)}\n... [activity entity JSON truncated]`;
					activityJsonTruncated = true;
				} else {
					activityJson = fallbackJson;
				}
			} catch (fallbackErr) {
				activityJson = "{}";
			}
		}

		return {
			activityName,
			rootStructureContext,
			selectedChecklistPath,
			selectedType,
			selectedPathLabel,
			inventory,
			activityJson,
			activityJsonTruncated,
			activityJsonWarning
		};
	}

	buildActivityAnalysisPrompt(userMessage = "") {
		const analysisContext = this.getActivityAnalysisContext();
		const rootStructureContext = analysisContext.rootStructureContext || {};
		const projectedChecklist = rootStructureContext.projectedChecklist;
		const outlineSummary = this.buildStructureOutlineSummary(projectedChecklist, {
			selectedPath: analysisContext.selectedChecklistPath,
			maxNodes: MAX_STRUCTURE_OUTLINE_SUMMARY_NODES
		});
		const nodeCounts = this.buildStructureNodeCounts(projectedChecklist);
		const valueTriggerSummary = this.buildActivityAnalysisValueTriggerSummary(analysisContext.inventory);
		const functionsScript = analysisContext.inventory && typeof analysisContext.inventory.functionsScript === "string"
			? analysisContext.inventory.functionsScript.trim()
			: "";
		const authoringSummary = this.state.authoringContextStatus === "ready" && this.authoringContextSummary
			? this.cleanContextText(this.authoringContextSummary, 1400)
			: "";
		const warningLines = []
			.concat(Array.isArray(rootStructureContext.additionalContextLines) ? rootStructureContext.additionalContextLines : [])
			.concat(analysisContext.activityJsonWarning ? [`Activity JSON warning: ${analysisContext.activityJsonWarning}`] : []);

		return [
			"You are the AmbiFi Activity Analysis Assistant.",
			"Answer questions about the current activity in plain language using the supplied activity JSON, outline summary, and scripting inventory.",
			"This is a read-only analysis mode. Do not generate bulk edit plans, structure JSON, or direct mutation instructions unless the user explicitly asks to switch modes.",
			"Be concrete. When relevant, mention the exact node labels, ids, types, paths, and property names that support your answer.",
			`Current activity: ${analysisContext.activityName || "(unnamed activity)"}`,
			`Current selection: ${analysisContext.selectedPathLabel || "(root)"}${analysisContext.selectedType ? ` (${analysisContext.selectedType})` : ""}`,
			`Activity counts: total=${nodeCounts.total}, lists=${nodeCounts.list}, sections=${nodeCounts.section}, itemContainers=${nodeCounts.itemContainer}, leafItems=${nodeCounts.items}`,
			`Functions script present: ${functionsScript ? "yes" : "no"}`,
			`Non-empty Value Triggers: ${analysisContext.inventory && Array.isArray(analysisContext.inventory.valueTriggers) ? analysisContext.inventory.valueTriggers.length : 0}`,
			warningLines.length > 0 ? `Context warnings:\n- ${warningLines.map((line) => this.cleanContextText(line, 240)).join("\n- ")}` : "",
			authoringSummary ? `AmbiFi authoring context summary:\n${authoringSummary}` : "",
			outlineSummary ? `Current outline summary:\n${outlineSummary}` : "",
			valueTriggerSummary,
			`Current activity JSON${analysisContext.activityJsonTruncated ? " (truncated)" : ""}:\n\`\`\`json\n${analysisContext.activityJson || "{}"}\n\`\`\``,
			`User question:\n${userMessage}`
		].filter(Boolean).join("\n\n");
	}

	getDefaultDraftContext(mode) {
		if (mode !== DRAFT_ASSISTANT_MODE_FIELD_TEXT) {
			return null;
		}

		return {
			mode,
			targetPath: null,
			targetLabel: "",
			targetFieldType: "text_plain",
			responseFormat: DRAFT_RESPONSE_FORMAT_CANDIDATES,
			targetReadOnly: false,
			featureName: "Authoring Drafts",
			featureDescription: "Draft and rewrite authoring content for selected properties.",
			additionalContextLines: []
		};
	}

	getDraftContextForMode(mode) {
		const stateContext = this.state.draftContext;
		const requestedContext = stateContext && stateContext.mode === mode ? stateContext : null;
		const baseContextRaw = requestedContext || this.getDefaultDraftContext(mode);
		const baseContext = baseContextRaw ? { ...baseContextRaw } : null;
		if (!baseContext) {
			return null;
		}

		const hasExplicitRequestedTargetPath = !!(
			requestedContext &&
			Array.isArray(requestedContext.targetPath) &&
			requestedContext.targetPath.length > 0
		);
		const focusedTarget = this.props.aiAssistantFocusedTarget || state.get(["appState", "aiAssistantFocusedTarget"]);
		if (!hasExplicitRequestedTargetPath &&
			focusedTarget &&
			Array.isArray(focusedTarget.targetPath) &&
			focusedTarget.targetPath.length > 0) {
			const sameTargetPath = Array.isArray(baseContext.targetPath) &&
				baseContext.targetPath.length === focusedTarget.targetPath.length &&
				baseContext.targetPath.every((segment, idx) => segment === focusedTarget.targetPath[idx]);
			baseContext.targetPath = focusedTarget.targetPath;
			baseContext.targetLabel = focusedTarget.targetLabel || baseContext.targetLabel || "";
			baseContext.targetFieldType = focusedTarget.targetFieldType || baseContext.targetFieldType || "text_plain";
			baseContext.targetReadOnly = focusedTarget.targetReadOnly === true;
			baseContext.featureName = focusedTarget.targetLabel || baseContext.featureName || "";
			if (!sameTargetPath) {
				baseContext.additionalContextLines = [];
			}
		}

		let currentValue = "";
		if (Array.isArray(baseContext.targetPath) && baseContext.targetPath.length > 0) {
			const currentValueRaw = state.get(baseContext.targetPath);
			currentValue = typeof currentValueRaw === "string" ? currentValueRaw : "";
		}

		return {
			...baseContext,
			currentValue
		};
	}

	resolveDraftResponseFormat(question = "", draftContext = null) {
		const questionLower = (question || "").toLowerCase();
		const asksForBullets =
			/\bbullets?\b/.test(questionLower) ||
			/\bbullet[-\s]?list\b/.test(questionLower) ||
			/\bmarkdown\s+bullets?\b/.test(questionLower);

		if (asksForBullets) {
			return DRAFT_RESPONSE_FORMAT_MARKDOWN_BULLETS;
		}

		const requestedFormat = draftContext && typeof draftContext.responseFormat === "string"
			? draftContext.responseFormat
			: "";
		if (requestedFormat && requestedFormat !== DRAFT_RESPONSE_FORMAT_MARKDOWN_BULLETS) {
			return requestedFormat;
		}

		return DRAFT_RESPONSE_FORMAT_CANDIDATES;
	}

	isDraftAttachmentAnalysisRequest(question = "", attachmentFileIds = null) {
		const selectedAttachmentFileIds = Array.isArray(attachmentFileIds)
			? attachmentFileIds.filter(Boolean)
			: this.getSelectedPromptAttachmentFileIds();
		if (selectedAttachmentFileIds.length === 0) {
			return false;
		}

		const text = (question || "").trim().toLowerCase();
		if (!text) {
			return false;
		}

		const explicitDraftPatterns = [
			/\b(write|rewrite|draft|create|generate|improve|polish|rephrase|shorten|expand|condense)\b/,
			/\b(insert|replace|paste)\b/,
			/\bcandidate\b/,
			/\bfor (this|the) field\b/,
			/\bfor (this|the) property\b/,
			/\bfor (label|title|description|caption|alt text|body|content)\b/
		];
		if (explicitDraftPatterns.some((pattern) => pattern.test(text))) {
			return false;
		}

		const directAttachmentAnalysisPatterns = [
			/\bdescribe\b/,
			/\bsummar(?:ize|y)\b/,
			/\bwhat do you see\b/,
			/\bwhat did i attach\b/,
			/\bwhat is attached\b/,
			/\bwhat's attached\b/,
			/\banaly[sz]e\b/,
			/\bexplain\b/,
			/\bidentify\b/,
			/\bextract text\b/,
			/\bocr\b/,
			/\btranscrib(?:e|ed|ing|tion)\b/,
			/\battached\b/,
			/\battachment\b/
		];

		return directAttachmentAnalysisPatterns.some((pattern) => pattern.test(text));
	}

	buildDraftAttachmentAnalysisPrompt({
		question = "",
		targetLabel = "",
		targetFieldType = "text_plain",
		featureName = "",
		featureDescription = "",
		currentValue = "",
		additionalContextLines = []
	} = {}) {
		const sections = [];

		sections.push([
			"You are the AmbiFi Assistant.",
			"The author is currently in field drafting mode, but for this request they want you to analyze the attached file directly.",
			"Answer the question about the attached file itself.",
			"Do not return Candidate 1 / Candidate 2 style output unless the author explicitly asks for multiple options.",
			"Do not default to generic AmbiFi authoring advice when the question is about the attachment."
		].join("\n"));

		sections.push([
			"Selected field context:",
			`- Field label: ${targetLabel || "None selected"}`,
			`- Field type: ${targetFieldType || "text_plain"}`,
			`- Property name: ${featureName || "unknown"}`,
			`- Property description: ${featureDescription || "n/a"}`
		].join("\n"));

		if (Array.isArray(additionalContextLines) && additionalContextLines.length > 0) {
			sections.push([
				"Additional context:",
				...additionalContextLines.map((line) => `- ${this.cleanContextText(line, 240)}`)
			].join("\n"));
		}

		if (typeof currentValue === "string" && currentValue.trim() !== "") {
			sections.push([
				"Current field value:",
				currentValue.length > 1800 ? `${currentValue.slice(0, 1800)}...` : currentValue
			].join("\n"));
		}

		sections.push(`Author question:\n${question || ""}`);

		sections.push([
			"Response policy:",
			"- If the author asks what is attached, describe the attached file plainly and concretely.",
			"- If the attachment is an image or screenshot, describe what is visible in the image.",
			"- If the author asks for a summary, summarize the attachment content directly.",
			"- Keep the answer concise unless the author asks for more detail.",
			"- If the attached file cannot be interpreted, say so clearly."
		].join("\n"));

		return sections.join("\n\n").trim();
	}

	handleLaunchRequest(request = null) {
		if (!request || !request.requestId || request.requestId === this.lastHandledLaunchRequestId) {
			return;
		}
		this.lastHandledLaunchRequestId = request.requestId;

		const requestedMode = request.mode;
		const nextState = {};
		if (typeof request.prefillQuestion === "string") {
			nextState.inputAiMessage = request.prefillQuestion;
		}

		if (this.isScriptMode(requestedMode)) {
			nextState.selectedActivityOrFiles = requestedMode;
			nextState.scriptContext = {
				mode: requestedMode,
				targetPath: Array.isArray(request.targetPath) ? request.targetPath : null,
				targetLabel: request.targetLabel || "",
				targetReadOnly: request.targetReadOnly === true,
				featureName: request.featureName || "",
				featureDescription: request.featureDescription || "",
				additionalContextLines: Array.isArray(request.additionalContextLines) ? request.additionalContextLines : []
			};
			this.setState(nextState, () => {
				this.ensureAuthoringContextLoaded();
				if (request.autoRun === true && (this.state.inputAiMessage || "").trim() !== "") {
					this.runScriptModeRequest(requestedMode);
				}
			});
		} else if (this.isDraftMode(requestedMode)) {
			this.preferFocusedInputForDraftApply = false;
			nextState.selectedActivityOrFiles = requestedMode;
			nextState.draftContext = {
				mode: requestedMode,
				targetPath: Array.isArray(request.targetPath) ? request.targetPath : null,
				targetLabel: request.targetLabel || "",
				targetFieldType: request.targetFieldType || "text_plain",
				responseFormat: request.responseFormat || DRAFT_RESPONSE_FORMAT_CANDIDATES,
				targetReadOnly: request.targetReadOnly === true,
				featureName: request.featureName || "",
				featureDescription: request.featureDescription || "",
				additionalContextLines: Array.isArray(request.additionalContextLines) ? request.additionalContextLines : []
			};
			this.setState(nextState, () => {
				this.ensureAuthoringContextLoaded();
				if (request.autoRun === true && (this.state.inputAiMessage || "").trim() !== "") {
					this.runDraftModeRequest(requestedMode);
				}
			});
		} else if (this.isStructureMode(requestedMode)) {
			nextState.selectedActivityOrFiles = requestedMode;
			nextState.structureContext = {
				mode: requestedMode,
				targetPath: Array.isArray(request.targetPath) ? request.targetPath : null,
				targetLabel: request.targetLabel || "",
				targetReadOnly: request.targetReadOnly === true,
				featureName: request.featureName || "",
				featureDescription: request.featureDescription || "",
				additionalContextLines: Array.isArray(request.additionalContextLines) ? request.additionalContextLines : []
			};
			nextState.activeStructureContext = null;
			nextState.latestStructureSubtreeSpec = null;
			this.setState(nextState, () => {
				this.ensureAuthoringContextLoaded();
				if (request.autoRun === true && (this.state.inputAiMessage || "").trim() !== "") {
					this.runStructureModeRequest();
				}
			});
		} else if (this.isBulkEditMode(requestedMode)) {
			nextState.selectedActivityOrFiles = requestedMode;
			nextState.bulkEditContext = {
				mode: requestedMode,
				targetPath: Array.isArray(request.targetPath) ? request.targetPath : null,
				targetLabel: request.targetLabel || "",
				targetReadOnly: request.targetReadOnly === true,
				featureName: request.featureName || "",
				featureDescription: request.featureDescription || "",
				additionalContextLines: Array.isArray(request.additionalContextLines) ? request.additionalContextLines : []
			};
			nextState.activeBulkEditContext = null;
			nextState.latestBulkEditInstructions = null;
			this.setState(nextState, () => {
				if (request.autoRun === true && (this.state.inputAiMessage || "").trim() !== "") {
					this.runBulkEditModeRequest();
				}
			});
		} else if (requestedMode === "authoring" || requestedMode === "activity" || requestedMode === "org" || requestedMode === "files" || requestedMode === DRIVE_ASSET_ASSISTANT_MODE) {
			nextState.selectedActivityOrFiles = requestedMode;
			this.setState(nextState, () => {
				if (requestedMode === "authoring") {
					this.ensureAuthoringContextLoaded();
				}
			});
		}

		this.context.tree.set(["appState", "aiAssistantLaunchRequest"], null);
	}

	async runDraftModeRequest(mode) {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(mode)) {
			this.appendAssistantErrorMessage("Selected draft mode is not available on this screen.");
			return;
		}

		const draftContext = this.getDraftContextForMode(mode);
		if (!draftContext) {
			this.appendAssistantErrorMessage("Draft context is not available.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}

		const liveFocusedInput = this.getWritableFocusedInputTarget();
		const hasLiveFocusedInput = !!liveFocusedInput;
		const liveFocusedInputValue = hasLiveFocusedInput && typeof liveFocusedInput.value === "string"
			? liveFocusedInput.value
			: "";
		const focusedTargetState = this.props.aiAssistantFocusedTarget || state.get(["appState", "aiAssistantFocusedTarget"]);
		const hasFocusedTargetPath = !!(
			focusedTargetState &&
			Array.isArray(focusedTargetState.targetPath) &&
			focusedTargetState.targetPath.length > 0
		);
		const hasExplicitDraftTargetPath = Array.isArray(draftContext.targetPath) && draftContext.targetPath.length > 0;
		const shouldUseLiveFocusedInput = hasLiveFocusedInput && !hasExplicitDraftTargetPath;
		const effectiveCurrentValue = shouldUseLiveFocusedInput ? liveFocusedInputValue : (draftContext.currentValue || "");
		const effectiveTargetLabel = shouldUseLiveFocusedInput ? "" : (draftContext.targetLabel || "");
		const effectiveFeatureName = shouldUseLiveFocusedInput ? "" : (draftContext.featureName || "");
		const effectiveAdditionalContextLines = (shouldUseLiveFocusedInput && !hasFocusedTargetPath)
			? []
			: (Array.isArray(draftContext.additionalContextLines) ? draftContext.additionalContextLines : []);
		const attachmentFileIds = this.isPromptAttachmentModeEnabled(mode)
			? this.getSelectedPromptAttachmentFileIds()
			: [];
		const shouldAnalyzeAttachments = this.isDraftAttachmentAnalysisRequest(userMessage, attachmentFileIds);

		const resolvedResponseFormat = this.resolveDraftResponseFormat(userMessage, draftContext);

		await this.ensureAuthoringContextLoaded();
		const prompt = shouldAnalyzeAttachments
			? this.buildDraftAttachmentAnalysisPrompt({
				question: userMessage,
				currentValue: effectiveCurrentValue,
				targetLabel: effectiveTargetLabel,
				targetFieldType: draftContext.targetFieldType || "text_plain",
				featureName: effectiveFeatureName,
				featureDescription: draftContext.featureDescription || "",
				additionalContextLines: effectiveAdditionalContextLines
			})
			: buildDraftAssistantPrompt({
				question: userMessage,
				currentValue: effectiveCurrentValue,
				targetLabel: effectiveTargetLabel,
				targetFieldType: draftContext.targetFieldType || "text_plain",
				responseFormat: resolvedResponseFormat,
				featureName: effectiveFeatureName,
				featureDescription: draftContext.featureDescription || "",
				contextIndex: this.authoringContextIndex,
				contextSummary: this.authoringContextSummary,
				additionalContextLines: effectiveAdditionalContextLines
			});

			this.appendConversationHeader(userMessage, mode);
			this.startWaitingForResponse();

			try {
				const draftResponse = await this.runResponsesConversationTurn({
					mode,
					conversationOptions: {
						targetPath: Array.isArray(draftContext.targetPath) ? draftContext.targetPath : null
					},
					messages: [
						{
							role: "system",
							content: "You are a helpful assistant."
						},
						{
							role: "user",
							content: prompt
						}
					],
					model: DEFAULT_ASSISTANT_CHAT_MODEL
				});
				const responseText = draftResponse && typeof draftResponse === "string"
					? draftResponse
					: "I was unable to generate a response.";

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
		} catch (err) {
			this.appendAssistantErrorMessage(this.getAssistantErrorMessage("Failed to process drafting response.", err));
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async runScriptModeRequest(mode) {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(mode)) {
			this.appendAssistantErrorMessage("Selected script mode is not available on this screen.");
			return;
		}

		const scriptContext = this.getScriptContextForMode(mode);
		if (!scriptContext || !Array.isArray(scriptContext.targetPath)) {
			this.appendAssistantErrorMessage("No valid script target was found for this mode.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}

		await this.ensureAuthoringContextLoaded();
		const activityScriptContext = this.buildActivityScriptingPromptContext(scriptContext, userMessage);
		const baseAdditionalContextLines = Array.isArray(scriptContext.additionalContextLines)
			? scriptContext.additionalContextLines
			: [];
		const combinedAdditionalContextLines = [
			...baseAdditionalContextLines,
			...(Array.isArray(activityScriptContext.contextSummaryLines) ? activityScriptContext.contextSummaryLines : [])
		];
		const prompt = buildScriptAssistantPrompt({
			mode,
			question: userMessage,
			currentScript: scriptContext.currentScript || "",
			featureName: scriptContext.featureName || "",
			featureDescription: scriptContext.featureDescription || "",
			contextIndex: this.authoringContextIndex,
			contextSummary: this.authoringContextSummary,
			additionalContextLines: combinedAdditionalContextLines,
			activityScriptingContext: activityScriptContext.activityScriptingContext || ""
		});

			this.appendConversationHeader(userMessage, mode);
			this.startWaitingForResponse();

			try {
				const scriptResponse = await this.runResponsesConversationTurn({
					mode,
					conversationOptions: {
						targetPath: Array.isArray(scriptContext.targetPath) ? scriptContext.targetPath : null
					},
					messages: [
						{
							role: "system",
							content: "You are a helpful assistant."
						},
						{
							role: "user",
							content: prompt
						}
					],
					model: DEFAULT_ASSISTANT_CHAT_MODEL
				});
				const responseText = scriptResponse && typeof scriptResponse === "string"
					? scriptResponse
					: "I was unable to generate a response.";

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
		} catch (err) {
			this.appendAssistantErrorMessage(this.getAssistantErrorMessage("Failed to process script generation response.", err));
		} finally {
			this.stopWaitingForResponse();
		}
	}

	insertScriptFromAssistant({ replace = false } = {}) {
		const mode = this.state.selectedActivityOrFiles;
		if (!this.isScriptMode(mode)) {
			return;
		}

		const scriptContext = this.getScriptContextForMode(mode);
		if (!scriptContext || !Array.isArray(scriptContext.targetPath)) {
			this.appendAssistantErrorMessage("No valid script target is selected.");
			return;
		}
		if (scriptContext.targetReadOnly) {
			this.appendAssistantErrorMessage("This target is read-only and cannot be updated.");
			return;
		}

		const aiResponse = this.props.aiAssistantResponseLast || "";
		const extractedCode = extractCodeFromAssistantResponse(aiResponse);
		if (!extractedCode) {
			this.appendAssistantErrorMessage("No JavaScript code block was found in the latest assistant response. Ask for script generation to enable Insert/Replace.");
			return;
		}

		const currentValueRaw = state.get(scriptContext.targetPath);
		const currentValue = typeof currentValueRaw === "string" ? currentValueRaw : "";
		const nextCode = `${extractedCode.trim()}\n`;
		const nextValue = replace
			? nextCode
			: `${currentValue}${currentValue && !currentValue.endsWith("\n") ? "\n" : ""}${nextCode}`;

		this.context.tree.set(scriptContext.targetPath, nextValue);
		this.bumpEditorRefreshCounter();
	}

	bumpEditorRefreshCounter() {
		const currentRefresh = state.get(["appState", "forceEditorRefresh"]);
		const nextRefresh = typeof currentRefresh === "number" ? currentRefresh + 1 : 1;
		state.set(["appState", "forceEditorRefresh"], nextRefresh);
	}

	resolveDraftApplyTargetContext() {
		const mode = this.state.selectedActivityOrFiles;
		const draftContext = this.getDraftContextForMode(mode);
		if (draftContext &&
			Array.isArray(draftContext.targetPath) &&
			draftContext.targetPath.length > 0) {
			return {
				targetPath: draftContext.targetPath,
				targetReadOnly: draftContext.targetReadOnly === true
			};
		}

		const focusedTarget = this.props.aiAssistantFocusedTarget || state.get(["appState", "aiAssistantFocusedTarget"]);
		if (focusedTarget &&
			Array.isArray(focusedTarget.targetPath) &&
			focusedTarget.targetPath.length > 0) {
			return {
				targetPath: focusedTarget.targetPath,
				targetReadOnly: focusedTarget.targetReadOnly === true
			};
		}

		return null;
	}

	getWritableFocusedInputTarget() {
		if (typeof document === "undefined") {
			return null;
		}

		if (this.isWritableExternalInputElement(this.lastFocusedExternalEditableElement)) {
			return this.lastFocusedExternalEditableElement;
		}

		if (this.isWritableExternalInputElement(document.activeElement)) {
			this.lastFocusedExternalEditableElement = document.activeElement;
			return document.activeElement;
		}

		return null;
	}

	canApplyDraftContent() {
		if (this.state.isWaitingForResponse) {
			return false;
		}
		if ((this.props.aiAssistantResponseLast || "").trim() === "") {
			return false;
		}
		const focusedInputTarget = this.getWritableFocusedInputTarget();
		if (this.preferFocusedInputForDraftApply === true) {
			return !!focusedInputTarget;
		}
		if (focusedInputTarget) {
			return true;
		}
		const targetContext = this.resolveDraftApplyTargetContext();
		return !!(
			targetContext &&
			Array.isArray(targetContext.targetPath) &&
			targetContext.targetPath.length > 0 &&
			!targetContext.targetReadOnly
		);
	}

	applyDraftContentToFocusedInput(content, { replace = false } = {}) {
		const target = this.getWritableFocusedInputTarget();
		if (!target) {
			return false;
		}
		const tag = target.tagName ? target.tagName.toUpperCase() : "";

		const insertContent = typeof content === "string" ? content : "";
		const currentValue = typeof target.value === "string" ? target.value : "";
		const start = typeof target.selectionStart === "number" ? target.selectionStart : currentValue.length;
		const end = typeof target.selectionEnd === "number" ? target.selectionEnd : currentValue.length;
		const nextValue = replace
			? insertContent
			: `${currentValue.slice(0, start)}${insertContent}${currentValue.slice(end)}`;

		const prototype = tag === "TEXTAREA" ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
		const valueSetterDescriptor = Object.getOwnPropertyDescriptor(prototype, "value");
		if (valueSetterDescriptor && typeof valueSetterDescriptor.set === "function") {
			valueSetterDescriptor.set.call(target, nextValue);
		} else {
			target.value = nextValue;
		}

		const nextCursorPos = replace ? nextValue.length : start + insertContent.length;
		if (typeof target.setSelectionRange === "function") {
			target.setSelectionRange(nextCursorPos, nextCursorPos);
		}
		target.dispatchEvent(new Event("input", { bubbles: true }));
		target.dispatchEvent(new Event("change", { bubbles: true }));
		this.bumpEditorRefreshCounter();
		return true;
	}

	getPreferredDraftContentFromResponse(responseText = "") {
		const blocks = this.getResponseBlocks(responseText);
		if (!Array.isArray(blocks) || blocks.length === 0) {
			return "";
		}

		const candidateBlock = blocks.find((block) => {
			const content = block && typeof block.content === "string" ? block.content.trim() : "";
			if (!content) {
				return false;
			}
			if (/^#{1,6}\s+/m.test(content) && content.split(/\n/).length === 1) {
				return false;
			}
			return content.length > 4;
		});
		return candidateBlock && candidateBlock.content ? candidateBlock.content.trim() : "";
	}

	applyDraftContentToTarget(content, { replace = false } = {}) {
		const trimmedContent = typeof content === "string" ? content.trim() : "";
		if (!trimmedContent) {
			this.appendAssistantErrorMessage("No draft content was found in the latest assistant response.");
			return;
		}

		if (this.preferFocusedInputForDraftApply === true) {
			if (this.applyDraftContentToFocusedInput(trimmedContent, { replace })) {
				return;
			}
			this.appendAssistantErrorMessage("No focused input target is available. Click into a field and try Insert/Replace again.");
			return;
		}

		const targetContext = this.resolveDraftApplyTargetContext();
		if (targetContext && Array.isArray(targetContext.targetPath) && targetContext.targetPath.length > 0) {
			if (targetContext.targetReadOnly) {
				this.appendAssistantErrorMessage("This target is read-only and cannot be updated.");
				return;
			}

			const currentValueRaw = state.get(targetContext.targetPath);
			const currentValue = typeof currentValueRaw === "string" ? currentValueRaw : "";
			const nextValue = replace
				? trimmedContent
				: `${currentValue}${currentValue ? "\n" : ""}${trimmedContent}`;

			this.context.tree.set(targetContext.targetPath, nextValue);
			this.bumpEditorRefreshCounter();
			return;
		}

		if (this.applyDraftContentToFocusedInput(trimmedContent, { replace })) {
			return;
		}

		if (!targetContext || !Array.isArray(targetContext.targetPath) || targetContext.targetPath.length === 0) {
			this.appendAssistantErrorMessage("No draft target is selected. Launch from a field to enable insert actions.");
			return;
		}
	}

	insertDraftFromAssistant({ replace = false } = {}) {
		const mode = this.state.selectedActivityOrFiles;
		if (!this.isDraftMode(mode)) {
			return;
		}
		const aiResponse = this.props.aiAssistantResponseLast || "";
		const draftContent = this.getPreferredDraftContentFromResponse(aiResponse);
		this.applyDraftContentToTarget(draftContent, { replace });
	}

	insertPromptFromFocusedInput({ replace = false } = {}) {
		const sourceTarget = this.getFocusedExternalEditableSource();
		if (!sourceTarget) {
			return;
		}
		const sourceValue = typeof sourceTarget.value === "string" ? sourceTarget.value : "";
		if (!replace && (sourceValue || "").trim() === "") {
			return;
		}

		const currentPrompt = typeof this.state.inputAiMessage === "string" ? this.state.inputAiMessage : "";
		const nextPrompt = replace
			? sourceValue
			: `${currentPrompt}${currentPrompt && !currentPrompt.endsWith("\n") ? "\n" : ""}${sourceValue}`;
		this.preferFocusedInputForDraftApply = true;

		this.setState({
			inputAiMessage: nextPrompt
		}, () => {
			const promptEl = this.refs.inputAiMessage;
			if (promptEl && typeof promptEl.focus === "function") {
				promptEl.focus();
				if (typeof promptEl.setSelectionRange === "function") {
					const endPos = nextPrompt.length;
					promptEl.setSelectionRange(endPos, endPos);
				}
			}
		});
	}

	appendAssistantErrorMessage(message) {
		let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
		newData = newData + `\n\n<b style='color: #ff8c8c'>${message}</b>\n\n`;
		this.context.tree.set(["appState", "aiAssistantResponse"], newData);

		let newDataLast = this.context.tree.get(["appState", "aiAssistantResponseLast"]);
		newDataLast = newDataLast + message;
		this.context.tree.set(["appState", "aiAssistantResponseLast"], newDataLast);
	}

	appendConversationHeader(message, mode = "") {
		let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
		newData = newData + `\n\n---\n\n**You:** ${message}\n\n---\n\n**Assistant:**\n\n`;

		this.context.tree.set(["appState", "aiAssistantResponse"], newData);
		this.context.tree.set(["appState", "aiAssistantResponseLast"], "");
		if (mode) {
			this.updateConversationSummaryForMode(mode, { userMessage: message });
			this.setState({
				lastResponseMode: mode
			});
		}
	}

	clearWaitingTimers() {
		if (this.responseSettleTimeoutId) {
			clearTimeout(this.responseSettleTimeoutId);
			this.responseSettleTimeoutId = null;
		}
		if (this.responseMaxWaitTimeoutId) {
			clearTimeout(this.responseMaxWaitTimeoutId);
			this.responseMaxWaitTimeoutId = null;
		}
	}

	startWaitingForResponse() {
		this.clearWaitingTimers();
		this.setState({
			isWaitingForResponse: true,
			hasReceivedResponseChunk: false
		});

		this.responseMaxWaitTimeoutId = setTimeout(() => {
			this.setState({
				isWaitingForResponse: false
			});
			this.responseMaxWaitTimeoutId = null;
		}, MAX_WAIT_FOR_RESPONSE_MS);
	}

	scheduleStopWaitingForResponse() {
		if (this.responseSettleTimeoutId) {
			clearTimeout(this.responseSettleTimeoutId);
		}

		this.responseSettleTimeoutId = setTimeout(() => {
			this.setState({
				isWaitingForResponse: false
			});
			this.responseSettleTimeoutId = null;
			if (this.responseMaxWaitTimeoutId) {
				clearTimeout(this.responseMaxWaitTimeoutId);
				this.responseMaxWaitTimeoutId = null;
			}
		}, STREAM_SETTLE_DELAY_MS);
	}

	stopWaitingForResponse() {
		this.clearWaitingTimers();
		this.setState({
			isWaitingForResponse: false
		});
	}

	clearConversationState() {
		this.conversationStateByKey = {};
		this.driveTranscriptCacheByConversationKey = {};
	}

	async handleNewChatClick() {
		this.stopWaitingForResponse();
		this.clearConversationState();
		this.context.tree.set(["appState", "aiAssistantResponse"], "");
		this.context.tree.set(["appState", "aiAssistantResponseLast"], "");
		this.setState({
			activeStructureContext: null,
			activeBulkEditContext: null,
			latestStructureSubtreeSpec: null,
			latestBulkEditInstructions: null,
			threadId: "",
			lastStructureGenerationMode: "",
			lastResponseMode: "",
			responseViewTab: "response",
			hasReceivedResponseChunk: false,
			promptAttachmentFileIds: [],
			promptAttachmentLocalAssetsById: {},
			showPromptAttachmentPicker: false,
			pendingModeCarryOverPrompt: null,
			queuedModeCarryOverByKey: {}
		});
	}

	handleAcceptModeCarryOver() {
		const pendingPrompt = this.state.pendingModeCarryOverPrompt;
		if (!pendingPrompt || !pendingPrompt.targetConversationKey) {
			return;
		}

		const queuedModeCarryOverByKey = this.state && this.state.queuedModeCarryOverByKey && typeof this.state.queuedModeCarryOverByKey === "object"
			? this.state.queuedModeCarryOverByKey
			: {};

		this.setState({
			pendingModeCarryOverPrompt: null,
			queuedModeCarryOverByKey: {
				...queuedModeCarryOverByKey,
				[pendingPrompt.targetConversationKey]: {
					sourceMode: pendingPrompt.sourceMode,
					targetMode: pendingPrompt.targetMode,
					sourceLabel: pendingPrompt.sourceLabel,
					targetLabel: pendingPrompt.targetLabel,
					summaryText: pendingPrompt.summaryText,
					sourceUpdatedAt: pendingPrompt.sourceUpdatedAt || Date.now(),
					queuedAt: Date.now()
				}
			}
		});
	}

	handleDismissModeCarryOver() {
		if (!this.state.pendingModeCarryOverPrompt) {
			return;
		}
		this.setState({
			pendingModeCarryOverPrompt: null
		});
	}

	clearQueuedModeCarryOverForCurrentMode() {
		const conversationKey = this.getConversationScopeKey(this.state.selectedActivityOrFiles, this.getConversationOptionsForMode(this.state.selectedActivityOrFiles));
		const queuedModeCarryOverByKey = this.state && this.state.queuedModeCarryOverByKey && typeof this.state.queuedModeCarryOverByKey === "object"
			? this.state.queuedModeCarryOverByKey
			: {};
		if (!queuedModeCarryOverByKey[conversationKey]) {
			return;
		}

		const nextQueuedModeCarryOverByKey = { ...queuedModeCarryOverByKey };
		delete nextQueuedModeCarryOverByKey[conversationKey];
		this.setState({
			queuedModeCarryOverByKey: nextQueuedModeCarryOverByKey
		});
	}

	renderModeCarryOverBanner() {
		const pendingPrompt = this.state.pendingModeCarryOverPrompt;
		const conversationKey = this.getConversationScopeKey(this.state.selectedActivityOrFiles, this.getConversationOptionsForMode(this.state.selectedActivityOrFiles));
		const queuedModeCarryOverByKey = this.state && this.state.queuedModeCarryOverByKey && typeof this.state.queuedModeCarryOverByKey === "object"
			? this.state.queuedModeCarryOverByKey
			: {};
		const queuedEntry = queuedModeCarryOverByKey[conversationKey] || null;

		if (!pendingPrompt && !queuedEntry) {
			return null;
		}

		const cardStyle = {
			marginTop: "10px",
			padding: "10px 12px",
			borderRadius: "8px",
			border: "1px solid #35557d",
			backgroundColor: "#132238",
			color: "#d9e7f7"
		};
		const smallButtonStyle = {
			borderRadius: "7px",
			padding: "3px 10px",
			fontSize: "12px"
		};

		if (pendingPrompt) {
			return <div style={cardStyle}>
				<div style={{ fontWeight: 600, marginBottom: "4px" }}>Carry prior context into this mode?</div>
				<div style={{ fontSize: "12px", color: "#bcd1ea" }}>
					Context exists in <b>{pendingPrompt.sourceLabel}</b>. You can carry a compact summary into <b>{pendingPrompt.targetLabel}</b> for the next request.
				</div>
				<div style={{ marginTop: "8px", maxHeight: "78px", overflow: "auto", fontSize: "12px", whiteSpace: "pre-wrap", color: "#a8bfdc" }}>
					{pendingPrompt.summaryText}
				</div>
				<div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
					<Button
						bsStyle="primary"
						style={{ ...smallButtonStyle, backgroundColor: "#255ca1", borderColor: "#3069af" }}
						onClick={() => this.handleAcceptModeCarryOver()}
					>
						Carry Summary
					</Button>
					<Button
						bsStyle="primary"
						style={{ ...smallButtonStyle, backgroundColor: "#2f3a4d", borderColor: "#4b5c78" }}
						onClick={() => this.handleDismissModeCarryOver()}
					>
						Start Fresh
					</Button>
				</div>
			</div>;
		}

		return <div style={cardStyle}>
			<div style={{ fontWeight: 600, marginBottom: "4px" }}>Carried context queued</div>
			<div style={{ fontSize: "12px", color: "#bcd1ea" }}>
				A compact summary from <b>{queuedEntry.sourceLabel || "another mode"}</b> will be included in the next request you send in this mode.
			</div>
			<div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
				<Button
					bsStyle="primary"
					style={{ ...smallButtonStyle, backgroundColor: "#2f3a4d", borderColor: "#4b5c78" }}
					onClick={() => this.clearQueuedModeCarryOverForCurrentMode()}
				>
					Clear
				</Button>
			</div>
		</div>;
	}

	getContextGeneratedAtLabel() {
		const generatedAt = this.authoringContextIndex &&
			this.authoringContextIndex.meta &&
			this.authoringContextIndex.meta.generatedAtIso
			? this.authoringContextIndex.meta.generatedAtIso
			: "";
		if (!generatedAt) {
			return "";
		}

		try {
			return new Date(generatedAt).toLocaleString();
		} catch (_err) {
			return generatedAt;
		}
	}

	getAuthoringContextTokenSet(message) {
		const tokens = ((message || "").toLowerCase().match(/[a-z0-9_/-]{2,}/g) || []);
		return new Set(tokens);
	}

	tokenSetIncludes(tokenSet, candidates) {
		for (const token of tokenSet) {
			for (const candidate of candidates) {
				if (token.indexOf(candidate) > -1 || candidate.indexOf(token) > -1) {
					return true;
				}
			}
		}
		return false;
	}

	cleanContextText(text, maxChars = 240) {
		if (!text || typeof text !== "string") {
			return "";
		}
		const cleaned = text.replace(/\s+/g, " ").trim();
		return cleaned.length > maxChars ? `${cleaned.slice(0, maxChars)}...` : cleaned;
	}

	pushPlainTextBlocks(rawText, blocks, blockIdRef) {
		if (!rawText || typeof rawText !== "string") {
			return;
		}

		const text = rawText
			.replace(/\r\n/g, "\n")
			.trim();
		if (!text) {
			return;
		}

		const candidateHeadingRegex = /^#{1,6}\s*candidate\b[^\n]*$/gim;
		const candidateMatches = [];
		let candidateMatch;
		while ((candidateMatch = candidateHeadingRegex.exec(text)) !== null) {
			candidateMatches.push({
				index: candidateMatch.index,
				text: candidateMatch[0] || ""
			});
		}
		if (candidateMatches.length > 0) {
			const firstMatchIdx = typeof candidateMatches[0].index === "number" ? candidateMatches[0].index : 0;
			const leadIn = text.slice(0, firstMatchIdx).trim();
			if (leadIn) {
				blocks.push({
					id: `b${blockIdRef.value++}`,
					type: "text",
					title: `Snippet ${blocks.length + 1}`,
					content: leadIn
				});
			}

			candidateMatches.forEach((candidateMatch, idx) => {
				const headingLine = (candidateMatch.text || "").replace(/^#{1,6}\s*/, "").trim();
				const headingStart = typeof candidateMatch.index === "number" ? candidateMatch.index : 0;
				const contentStart = headingStart + (candidateMatch.text || "").length;
				const nextMatch = candidateMatches[idx + 1];
				const contentEnd = nextMatch && typeof nextMatch.index === "number" ? nextMatch.index : text.length;
				const candidateContent = text.slice(contentStart, contentEnd).trim();
				if (!candidateContent) {
					return;
				}

				blocks.push({
					id: `b${blockIdRef.value++}`,
					type: "candidate",
					title: headingLine || `Candidate ${idx + 1}`,
					content: candidateContent
				});
			});
			return;
		}

		const paragraphs = text
			.split(/\n{2,}/)
			.map((chunk) => chunk.trim())
			.filter(Boolean);

		paragraphs.forEach((paragraph) => {
			blocks.push({
				id: `b${blockIdRef.value++}`,
				type: "text",
				title: `Snippet ${blocks.length + 1}`,
				content: paragraph
			});
		});
	}

	pushTextAndBulletBlocks(rawText, blocks, blockIdRef) {
		if (!rawText || typeof rawText !== "string") {
			return;
		}
		const text = rawText.replace(/\r\n/g, "\n");
		if (!text.trim()) {
			return;
		}

		const bulletGroupRegex = /((?:^|\n)\s*(?:[-*]|\d+\.)\s+[^\n]+(?:\n\s*(?:[-*]|\d+\.)\s+[^\n]+)+)/g;
		let cursor = 0;
		let match = bulletGroupRegex.exec(text);
		while (match) {
			const start = match.index;
			const end = start + match[0].length;
			const before = text.slice(cursor, start);
			this.pushPlainTextBlocks(before, blocks, blockIdRef);

			const bulletContent = match[0].trim();
			if (bulletContent) {
				blocks.push({
					id: `b${blockIdRef.value++}`,
					type: "bullets",
					title: `Bullet List ${blocks.length + 1}`,
					content: bulletContent
				});
			}

			cursor = end;
			match = bulletGroupRegex.exec(text);
		}

		const tail = text.slice(cursor);
		this.pushPlainTextBlocks(tail, blocks, blockIdRef);
	}

	getResponseBlocks(responseText) {
		if (!responseText || typeof responseText !== "string") {
			return [];
		}
		const normalized = responseText.replace(/\r\n/g, "\n").trim();
		if (!normalized) {
			return [];
		}

		const blocks = [];
		const blockIdRef = { value: 1 };
		const codeFenceRegex = /```([a-zA-Z0-9_-]+)?\s*\n([\s\S]*?)```/g;
		let cursor = 0;
		let match = codeFenceRegex.exec(normalized);
		while (match) {
			const start = match.index;
			const end = start + match[0].length;
			const before = normalized.slice(cursor, start);
			this.pushTextAndBulletBlocks(before, blocks, blockIdRef);

			const language = (match[1] || "").trim().toLowerCase();
			const code = (match[2] || "").trim();
			if (code) {
				blocks.push({
					id: `b${blockIdRef.value++}`,
					type: "code",
					title: language ? `Code (${language})` : `Code ${blocks.length + 1}`,
					content: code,
					language
				});
			}

			cursor = end;
			match = codeFenceRegex.exec(normalized);
		}

		const tail = normalized.slice(cursor);
		this.pushTextAndBulletBlocks(tail, blocks, blockIdRef);

		if (blocks.length === 0) {
			return [{
				id: "b1",
				type: "text",
				title: "Snippet 1",
				content: normalized
			}];
		}

		return blocks;
	}

	renderResponseSnippetContent(block) {
		const content = (block && block.content) ? block.content : "";
		const preview = content.length > MAX_RESPONSE_SNIPPET_PREVIEW_CHARS
			? `${content.slice(0, MAX_RESPONSE_SNIPPET_PREVIEW_CHARS)}...`
			: content;

		if (block.type === "code") {
			return <pre style={{
				margin: 0,
				padding: "10px",
				whiteSpace: "pre-wrap",
				wordBreak: "break-word",
				backgroundColor: "#0a1220",
				border: "1px solid #253a55",
				borderRadius: "8px",
				color: "#dbe8fa",
				fontSize: "12px",
				lineHeight: 1.45
			}}>{preview}</pre>;
		}

		return <div style={{
			whiteSpace: "pre-wrap",
			wordBreak: "break-word",
			color: "#dce8f8",
			fontSize: "13px",
			lineHeight: 1.45
		}}>{preview}</div>;
	}

	getResponseSnippetBlocks() {
		const selectedMode = this.state.selectedActivityOrFiles;
		const responseMode = this.state.lastResponseMode || selectedMode;
		const shouldShowSnippets =
			this.isDraftMode(selectedMode) ||
			this.isDraftMode(responseMode);
		if (!shouldShowSnippets) {
			return [];
		}

		const latestResponse = this.props.aiAssistantResponseLast || "";
		const blocks = this.getResponseBlocks(latestResponse);
		if (!Array.isArray(blocks) || blocks.length === 0) {
			return [];
		}

		return blocks;
	}

	renderResponseSnippets(blocks = []) {
		if (!Array.isArray(blocks) || blocks.length === 0) {
			return null;
		}

		const selectedMode = this.state.selectedActivityOrFiles;
		const canApplyDraftBlock = this.isDraftMode(selectedMode) && this.canApplyDraftContent();

		return <div style={{
			display: "flex",
			flexDirection: "column",
			gap: "8px"
		}}>
			<div style={{ color: "#bcd1ea", fontWeight: 600, marginBottom: "2px" }}>Response Snippets</div>
			{blocks.map((block) => (
				<div key={block.id} style={{
					border: "1px solid #263a53",
					borderRadius: "8px",
					padding: "8px",
					backgroundColor: "#101b2d"
				}}>
					<div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: "6px", gap: "8px" }}>
						<div style={{ color: "#9fc2e6", fontWeight: 600, fontSize: "12px" }}>{block.title}</div>
						<div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", marginLeft: "auto" }}>
							{canApplyDraftBlock &&
								<>
									<Button
										bsStyle="primary"
										style={{ borderRadius: "7px", backgroundColor: "#255ca1", borderColor: "#3069af", padding: "4px 8px", fontSize: "12px" }}
										onClick={() => this.applyDraftContentToTarget(block.content, { replace: false })}
									>
										Insert
									</Button>
									<Button
										bsStyle="primary"
										style={{ borderRadius: "7px", backgroundColor: "#1d4f8a", borderColor: "#2a629e", padding: "4px 8px", fontSize: "12px" }}
										onClick={() => this.applyDraftContentToTarget(block.content, { replace: true })}
									>
										Replace
									</Button>
								</>
							}
							<Button
								bsStyle="primary"
								style={{ borderRadius: "7px", backgroundColor: "#1f4d88", borderColor: "#2f68ab", padding: "4px 8px", fontSize: "12px" }}
								onClick={() => copyToClipboard(block.content)}
							>
								<FontAwesomeIcon icon="copy" /> Copy
							</Button>
						</div>
					</div>
					{this.renderResponseSnippetContent(block)}
				</div>
			))}
		</div>;
	}

	getMatchedPropertyDocs(index, tokenSet, message) {
		const byScope = (index && index.propertyDocs && index.propertyDocs.byScope) ? index.propertyDocs.byScope : {};
		const docs = [];

		Object.keys(byScope).forEach((scope) => {
			const scopedProperties = (byScope[scope] && Array.isArray(byScope[scope].properties)) ? byScope[scope].properties : [];
			scopedProperties.forEach((doc) => {
				docs.push({
					scope,
					key: doc.key || "",
					name: doc.name || "",
					description: doc.description || ""
				});
			});
		});

		const question = (message || "").toLowerCase();
		const scored = docs.map((doc) => {
			let score = 0;
			const key = (doc.key || "").toLowerCase();
			const name = (doc.name || "").toLowerCase();
			const description = (doc.description || "").toLowerCase();

			if (key && question.indexOf(key) > -1) {
				score += 12;
			}
			if (name && question.indexOf(name) > -1) {
				score += 7;
			}

			for (const token of tokenSet) {
				if (token.length < 3) {
					continue;
				}
				if (key === token || name === token) {
					score += 6;
				} else if (key.indexOf(token) > -1 || name.indexOf(token) > -1) {
					score += 4;
				}

				if (description.indexOf(token) > -1) {
					score += 1;
				}
			}

			return { ...doc, score };
		})
			.filter((doc) => doc.score > 0)
			.sort((a, b) => {
				if (b.score !== a.score) {
					return b.score - a.score;
				}
				if (a.scope !== b.scope) {
					return a.scope.localeCompare(b.scope);
				}
				return a.key.localeCompare(b.key);
			});

		return scored.slice(0, MAX_AUTHORING_MATCHED_PROPERTIES);
	}

	// includeGuide: send the whole authoring guide (the first question of a conversation; follow-ups chain on it).
	buildAuthoringContextMessage(userMessage, { includeGuide = false } = {}) {
		const message = userMessage || "";
		const guideSections = buildAuthoringGuideSections({
			question: message,
			guide: this.authoringGuideText || "",
			reference: this.authoringGuideReference || null,
			itemTypes: (this.authoringContextIndex && this.authoringContextIndex.authoring && this.authoringContextIndex.authoring.itemTypes) || [],
			includeGuide
		});

		if (!this.authoringContextIndex) {
			const summary = this.cleanContextText(this.authoringContextSummary, 8000);
			return [
				"You are the AmbiFi Authoring Help Assistant.",
				"Use the provided context to answer questions about authoring capabilities and runtime behavior.",
				"From an author perspective, treat the player-checklist JSON model as canonical.",
				summary ? `Context Summary:\n${summary}` : "",
				...guideSections,
				`Author question: ${message}`
			].filter(Boolean).join("\n\n");
		}

		const index = this.authoringContextIndex;
		const tokenSet = this.getAuthoringContextTokenSet(message);
		const questionLower = message.toLowerCase();
		const includeRuntime = this.tokenSetIncludes(tokenSet, ["runtime", "api", "web", "mobile", "player", "method", "function", "script"]);
		const includeProperties = this.tokenSetIncludes(tokenSet, ["property", "properties", "field", "fields", "schema", "option", "setting", "label", "author", "content"]);
		const includeToolbar = this.tokenSetIncludes(tokenSet, ["toolbar", "menu", "nav", "navigation", "button", "layout", "panel", "screen"]);
		const isVisibleIfQuestion =
			questionLower.indexOf("visible if") > -1 ||
			questionLower.indexOf("conditional visible") > -1 ||
			this.tokenSetIncludes(tokenSet, ["conditionalvisible", "visibleif"]) ||
			(
				this.tokenSetIncludes(tokenSet, ["visible", "visibility", "show", "hide"]) &&
				this.tokenSetIncludes(tokenSet, ["condition", "conditional", "logic", "rule", "expression"])
			);

		const sections = [];
		sections.push([
			"You are the AmbiFi Authoring Help Assistant.",
			"Answer with practical, accurate guidance for AmbiFi authors.",
			"Important: from an author perspective, the canonical model is player-checklist JSON. Avoid internal authoring-memory terminology unless explicitly asked."
		].join("\n"));

		const contextMeta = index.meta || {};
		const runtimeParity = index.runtimeApiParity || {};
		const transform = index.transform || {};
		const authoring = index.authoring || {};
		const models = index.models || {};
		const playerSchema = models.schema && models.schema.playerChecklist ? models.schema.playerChecklist : {};
		const overrides = index.overrides || {};
		const overrideDirectives = Array.isArray(overrides.authoringPromptDirectives) ? overrides.authoringPromptDirectives : [];
		const visibleIfDirectives = Array.isArray(overrides.visibleIfPromptDirectives) ? overrides.visibleIfPromptDirectives : [];
		const overrideHierarchyRules = Array.isArray(overrides.authoringHierarchyRules) ? overrides.authoringHierarchyRules : [];
		const overrideCorrections = Array.isArray(overrides.knownCorrections) ? overrides.knownCorrections : [];

		if (isVisibleIfQuestion) {
			sections.push([
				"Visible If response policy:",
				"- Do not provide code examples.",
				"- Explain the concept in author-friendly terms.",
				"- Refer to AmbiFi docs for detailed implementation syntax."
			].join("\n"));
		}

		if (overrideDirectives.length > 0 || visibleIfDirectives.length > 0 || overrideHierarchyRules.length > 0 || overrideCorrections.length > 0) {
			const overrideLines = ["Authoritative manual overrides (follow these rules over inferred guidance):"];

				if (overrideDirectives.length > 0) {
					overrideLines.push("- Prompt directives:");
					overrideDirectives.slice(0, 20).forEach((directive) => {
						overrideLines.push(`  - ${this.cleanContextText(directive, 240)}`);
					});
				}

				if (isVisibleIfQuestion && visibleIfDirectives.length > 0) {
					overrideLines.push("- Visible If directives:");
					visibleIfDirectives.slice(0, 20).forEach((directive) => {
						overrideLines.push(`  - ${this.cleanContextText(directive, 240)}`);
					});
				}

			if (overrideHierarchyRules.length > 0) {
				overrideLines.push("- Authoring hierarchy rules:");
				overrideHierarchyRules.slice(0, 20).forEach((rule) => {
					overrideLines.push(`  - ${this.cleanContextText(rule, 220)}`);
				});
			}

			if (overrideCorrections.length > 0) {
				overrideLines.push("- Known corrections:");
				overrideCorrections.slice(0, 20).forEach((correction) => {
					const topic = correction.topic ? `${this.cleanContextText(correction.topic, 80)}: ` : "";
					const correct = this.cleanContextText(correction.correct || "", 220);
					if (correct) {
						overrideLines.push(`  - ${topic}${correct}`);
					}
				});
			}

			sections.push(overrideLines.join("\n"));
		}

		const activityJsonGuide = index.activityJsonGuide || null;
		if (activityJsonGuide && Array.isArray(activityJsonGuide.lines) && activityJsonGuide.lines.length > 0) {
			sections.push([
				`Activity JSON rules (summary of ${activityJsonGuide.path}; follow them when producing, importing or repairing activity JSON):`,
				...activityJsonGuide.lines.slice(0, 40).map((line) => `- ${this.cleanContextText(line, 600)}`)
			].join("\n"));
		}

		sections.push([
			"Authoring Context Snapshot:",
			`- Generated: ${contextMeta.generatedAtIso || "unknown"}`,
			`- Fingerprint: ${contextMeta.sourceFingerprint || "unknown"}`,
			`- Runtime parity web/mobile: ${runtimeParity.parityPercent || 0}% (${runtimeParity.commonMethodCount || 0} common methods)`,
			`- Item types: ${Array.isArray(authoring.itemTypes) ? authoring.itemTypes.map((item) => `${item.name} (${item.type})`).join(", ") : ""}`,
			`- Link action types: ${Array.isArray(authoring.linkActionTypes) ? authoring.linkActionTypes.join(", ") : ""}`,
			`- Transform functions: ${Array.isArray(transform.exportedFunctions) ? transform.exportedFunctions.join(", ") : ""}`
		].join("\n"));

		if (Array.isArray(playerSchema.topLevelProperties) && playerSchema.topLevelProperties.length > 0) {
			sections.push([
				"Player checklist top-level fields:",
				playerSchema.topLevelProperties.join(", ")
			].join("\n"));
		}

		if (includeProperties) {
			const matches = this.getMatchedPropertyDocs(index, tokenSet, message);
			if (matches.length > 0) {
				sections.push([
					"Most relevant documented properties:",
					...matches.map((doc) => `- ${doc.scope}.${doc.key}: ${this.cleanContextText(doc.description || doc.name, 240)}`)
				].join("\n"));
			}
		}

		if (includeToolbar) {
			const toolbarLabels = Array.isArray(authoring.toolbarLabels) ? authoring.toolbarLabels : [];
			const navRoutes = Array.isArray(authoring.navRoutes) ? authoring.navRoutes : [];
			sections.push([
				"UI capability surfaces:",
				`- Toolbar labels: ${toolbarLabels.join(", ")}`,
				`- Navigation routes: ${navRoutes.map((route) => `${route.label} (${route.route})`).join(", ")}`
			].join("\n"));
		}

		if (includeRuntime) {
			const commonMethods = Array.isArray(runtimeParity.commonMethods) ? runtimeParity.commonMethods.slice(0, MAX_AUTHORING_METHODS) : [];
			const webOnlyMethods = Array.isArray(runtimeParity.webOnlyMethods) ? runtimeParity.webOnlyMethods : [];
			const mobileOnlyMethods = Array.isArray(runtimeParity.mobileOnlyMethods) ? runtimeParity.mobileOnlyMethods : [];

			sections.push([
				"Runtime API details:",
				`- Common methods: ${commonMethods.join(", ")}`,
				`- Web-only methods: ${webOnlyMethods.join(", ") || "none"}`,
				`- Mobile-only methods: ${mobileOnlyMethods.join(", ") || "none"}`
			].join("\n"));
		}

		if (this.authoringContextSummary) {
			sections.push([
				"Generated summary excerpt:",
				this.cleanContextText(this.authoringContextSummary, 1800)
			].join("\n"));
		}

		const trimmedSections = [];
		let currentLength = 0;
		sections.forEach((section) => {
			if (!section) {
				return;
			}
			const nextLength = currentLength + section.length + 2;
			if (nextLength > MAX_AUTHORING_CONTEXT_CHARS) {
				return;
			}
			trimmedSections.push(section);
			currentLength = nextLength;
		});

		return [...trimmedSections, ...guideSections, `Author question: ${message}`].join("\n\n");
	}

	// The activity JSON authoring guide and the parsed reference for the authoring help chat.
	async ensureAuthoringGuideLoaded() {
		const { guide, reference } = await loadAuthoringGuideDocuments();
		if (reference && reference !== this.authoringGuideReferenceSource) {
			this.authoringGuideReference = parseAuthoringReference(reference);
			this.authoringGuideReferenceSource = reference;
		}
		this.authoringGuideText = guide || "";
	}

	async ensureAuthoringContextLoaded() {
		if (!this.isAuthoringModeEnabled()) {
			return false;
		}
		if (this.authoringContextIndex || this.authoringContextSummary) {
			return true;
		}
		if (this.authoringContextLoadPromise) {
			return this.authoringContextLoadPromise;
		}

		this.setState({
			authoringContextStatus: "loading",
			authoringContextError: ""
		});

		this.authoringContextLoadPromise = (async () => {
			try {
				const response = await fetch(AUTHORING_CONTEXT_INDEX_URL, {
					method: "GET",
					cache: "no-cache"
				});

				if (response.ok) {
					const json = await response.json();
					this.authoringContextIndex = json;
					this.setState({
						authoringContextStatus: "ready",
						authoringContextError: ""
					});
					return true;
				}
			} catch (_err) {
				// Fall through to summary fallback below.
			}

			try {
				const summaryResponse = await fetch(AUTHORING_CONTEXT_SUMMARY_URL, {
					method: "GET",
					cache: "no-cache"
				});

				if (summaryResponse.ok) {
					this.authoringContextSummary = await summaryResponse.text();
					this.setState({
						authoringContextStatus: "ready",
						authoringContextError: ""
					});
					return true;
				}
			} catch (_err) {
				// Continue to error state.
			}

			this.setState({
				authoringContextStatus: "error",
				authoringContextError: "Authoring context was not found at /assistant-context. Run the assistant-context generator to publish context artifacts."
			});
			return false;
		})();

		try {
			return await this.authoringContextLoadPromise;
		} finally {
			this.authoringContextLoadPromise = null;
		}
	}

	async createThreadIfNeeded() {
		if (this.state.threadId) {
			return this.state.threadId;
		}

		try {
			const responseCurrentThread = await fetch(`${env.apiGateway.baseUrl}/services/openai/threads`, {
				method: "POST",
				headers: { Authorization: getJwtToken() }
			});
			const jsonResponseCurrentThread = await responseCurrentThread.json();

			if (jsonResponseCurrentThread && jsonResponseCurrentThread.id) {
				this.setState({
					threadId: jsonResponseCurrentThread.id
				});
				return jsonResponseCurrentThread.id;
			}
		} catch (e) {
			console.error(e);
		}

		return "";
	}

	componentDidUpdate(prevProps, prevState) {
		let messageBody = document.getElementById("openai-markdown2");
		if (messageBody) {
			messageBody.scrollTop = 10000000;
			console.log("SCROLL", messageBody.scrollTop);
		}

		if (this.props.aiAssistantLaunchRequest &&
			(!prevProps.aiAssistantLaunchRequest ||
				this.props.aiAssistantLaunchRequest.requestId !== prevProps.aiAssistantLaunchRequest.requestId)) {
			this.handleLaunchRequest(this.props.aiAssistantLaunchRequest);
		}

		if (this.props.aiAssistantId !== prevProps.aiAssistantId && this.props.aiAssistantId && this.props.aiAssistantId !== "") {
			this.createThreadIfNeeded();
		}

		const currentDriveSelectionKey = this.getDriveSelectionKeyFromCursor(this.props.driveActiveCursor);
		const previousDriveSelectionKey = this.getDriveSelectionKeyFromCursor(prevProps.driveActiveCursor);
		if (currentDriveSelectionKey !== previousDriveSelectionKey) {
			this.lastAutoDriveModeSelectionKey = "";
		}
		if (this.shouldAutoSelectDriveAssetMode(currentDriveSelectionKey)) {
			this.lastAutoDriveModeSelectionKey = currentDriveSelectionKey;
			this.setState({
				selectedActivityOrFiles: DRIVE_ASSET_ASSISTANT_MODE
			});
			return;
		}

		if ((this.state.selectedActivityOrFiles === "authoring" || this.isScriptMode(this.state.selectedActivityOrFiles) || this.isDraftMode(this.state.selectedActivityOrFiles) || this.isStructureMode(this.state.selectedActivityOrFiles)) &&
			prevState.selectedActivityOrFiles !== this.state.selectedActivityOrFiles) {
			this.ensureAuthoringContextLoaded();
		}

		if ((this.state.selectedActivityOrFiles === "authoring" || this.isScriptMode(this.state.selectedActivityOrFiles) || this.isDraftMode(this.state.selectedActivityOrFiles) || this.isStructureMode(this.state.selectedActivityOrFiles)) &&
			prevProps.aiAssistantId !== this.props.aiAssistantId) {
			this.ensureAuthoringContextLoaded();
		}

		const availableAssistantFileIds = new Set(this.getAssistantFiles().map((file) => file.id));
		const currentAttachmentIds = this.getSelectedPromptAttachmentFileIds();
		const prunedAttachmentIds = currentAttachmentIds.filter((fileId) => availableAssistantFileIds.has(fileId));
		if (prunedAttachmentIds.length !== currentAttachmentIds.length) {
			const nextLocalAssets = { ...this.getPromptAttachmentLocalAssetsById() };
			Object.keys(nextLocalAssets).forEach((fileId) => {
				if (!availableAssistantFileIds.has(fileId)) {
					delete nextLocalAssets[fileId];
				}
			});
			this.setState({
				promptAttachmentFileIds: prunedAttachmentIds,
				promptAttachmentLocalAssetsById: nextLocalAssets
			});
			return;
		}

		const modeChanged = prevState.selectedActivityOrFiles !== this.state.selectedActivityOrFiles;
		if (modeChanged) {
			const pendingModeCarryOverPrompt = this.buildPendingModeCarryOverPrompt(
				prevState.selectedActivityOrFiles,
				this.state.selectedActivityOrFiles
			);

			if (!this.isPromptAttachmentModeEnabled(this.state.selectedActivityOrFiles) &&
				(this.state.showPromptAttachmentPicker || currentAttachmentIds.length > 0)) {
				this.setState({
					showPromptAttachmentPicker: false,
					promptAttachmentFileIds: [],
					promptAttachmentLocalAssetsById: {},
					pendingModeCarryOverPrompt
				});
				return;
			}

			if (this.state.pendingModeCarryOverPrompt !== pendingModeCarryOverPrompt) {
				this.setState({
					pendingModeCarryOverPrompt
				});
				return;
			}
		}

		const currentResponseLast = this.props.aiAssistantResponseLast || "";
		const previousResponseLast = prevProps.aiAssistantResponseLast || "";
		const hasNewResponseChunk = currentResponseLast.length > previousResponseLast.length &&
			currentResponseLast.indexOf(previousResponseLast) === 0;

		if (hasNewResponseChunk && this.state.lastResponseMode) {
			this.updateConversationSummaryForMode(this.state.lastResponseMode, {
				assistantText: currentResponseLast
			});
		}

		if (this.state.isWaitingForResponse && hasNewResponseChunk) {
			if (!this.state.hasReceivedResponseChunk) {
				this.setState({
					hasReceivedResponseChunk: true
				});
			}
			this.scheduleStopWaitingForResponse();
		}

		if (hasNewResponseChunk &&
			this.state.responseViewTab !== "snippets" &&
			this.isDraftMode(this.state.lastResponseMode)) {
			this.setState({
				responseViewTab: "snippets"
			});
		}

		this.ensureSelectedMode();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.aiAssistantResponse !== nextProps.aiAssitantResponse) {
			let messageBody = document.getElementById("openai-markdown2");
			messageBody.scrollTop = 10000;

			console.log("SCROLL", messageBody.scrollTop);
		}
	}

	async componentDidMount() {
		if (typeof document !== "undefined" && typeof document.addEventListener === "function") {
			document.addEventListener("focusin", this.handleDocumentFocusIn, true);
			if (this.isWritableExternalInputElement(document.activeElement)) {
				this.lastFocusedExternalEditableElement = document.activeElement;
			}
		}

		const element = document.getElementById("openai-markdown");
		const renderer = smd.default_renderer(element);
		parser = smd.parser(renderer);

		// let headers = new Headers();

		// headers.append('Authorization', 'Basic amVmZi5ib25hc3NvQG1pcmFsb3VhZXJvLmNvbTpTaXhGb3VyNzJHb2xm');

		// The environment's own API (this was hard-coded to the US production API). A failed listing
		// leaves the file list empty instead of stopping the rest of the assistant's setup.
		let files = [];
		try {
			const response = await fetch(`${env.apiGateway.baseUrl}/services/openai/files`, {
				method: "GET",
				headers: { Authorization: getJwtToken() }
			});
			const jsonResponse = await response.json();
			files = (Array.isArray(jsonResponse && jsonResponse.data) ? jsonResponse.data : []).filter((file) => {
				return typeof file.filename === "string" && file.filename.startsWith(this.props.user.identityId + "/");
			});
		} catch (e) {
			console.error(e);
		}

		this.context.tree.set(["tree", "root", "entity", "aiAssistantFiles"], files);

		if (this.props.aiAssistantId && this.props.aiAssistantId !== "") {
			// TODO: will need to upgrade to use a vector store

			// const responseChecklistFiles = await fetch(`${env.apiGateway.baseUrl}/services/openai/assistants/${this.props.aiAssistantId}/files`, {
			// 	method: "GET",
			// 	// headers: headers
			// });
			// const jsonResponseChecklistFiles = await responseChecklistFiles.json();
			// const checklistFiles = jsonResponseChecklistFiles.data.filter((file) => {
			// 	return file;
			// });

			// this.context.tree.set(["tree", "root", "entity", "aiAssistantChecklistFiles"], checklistFiles);

			// Create thread - probably need a way to clear everything too
			const responseCurrentThread = await fetch(`${env.apiGateway.baseUrl}/services/openai/threads`, {
				method: "POST",
				headers: { Authorization: getJwtToken() }
			});
			const jsonResponseCurrentThread = await responseCurrentThread.json();

			this.setState({
				threadId: jsonResponseCurrentThread.id
			});
		}

		if (this.isAuthoringModeEnabled()) {
			this.ensureAuthoringContextLoaded();
		}

		const availableModes = this.getAvailableModes();
		if (availableModes.includes("authoring") && this.state.selectedActivityOrFiles === "org") {
			this.setState({
				selectedActivityOrFiles: "authoring"
			});
		}

		const initialDriveSelectionKey = this.getDriveSelectionKeyFromCursor(this.props.driveActiveCursor);
		if (this.shouldAutoSelectDriveAssetMode(initialDriveSelectionKey)) {
			this.lastAutoDriveModeSelectionKey = initialDriveSelectionKey;
			this.setState({
				selectedActivityOrFiles: DRIVE_ASSET_ASSISTANT_MODE
			});
		}

		if (this.props.aiAssistantLaunchRequest && this.props.aiAssistantLaunchRequest.requestId) {
			this.handleLaunchRequest(this.props.aiAssistantLaunchRequest);
		}

		this.ensureSelectedMode();
	}

	componentWillUnmount() {
		this.clearWaitingTimers();
		if (typeof document !== "undefined" && typeof document.removeEventListener === "function") {
			document.removeEventListener("focusin", this.handleDocumentFocusIn, true);
		}
	}

	getModeOptionLabel(mode) {
		if (mode === STRUCTURE_ASSISTANT_MODE) {
			return "Generate or revise outline structure for the selected node.";
		}
		if (mode === BULK_EDIT_ASSISTANT_MODE) {
			return "Bulk edit selected outline subtree properties.";
		}
		if (mode === ACTIVITY_ANALYSIS_ASSISTANT_MODE) {
			return "Analyze the current activity JSON and structure.";
		}
		if (mode === "authoring") {
			return "Ask questions about AmbiFi authoring capabilities.";
		}
		if (mode === DRAFT_ASSISTANT_MODE_FIELD_TEXT) {
			return "Create or rewrite content for a field (with insert actions).";
		}
		if (mode === SCRIPT_ASSISTANT_MODE_FUNCTIONS) {
			return "Script activity Functions (with insert actions).";
		}
		if (mode === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER) {
			return "Script selected Value Trigger (with insert actions).";
		}
		if (mode === "activity") {
			return "Share current activity content with the assistant.";
		}
		if (mode === "org") {
			return "Chat with all content shared in the org.";
		}
		if (mode === "files") {
			return "General chat and share selected files with the assistant.";
		}
		if (mode === DRIVE_ASSET_ASSISTANT_MODE) {
			return "Work with selected Drive asset (summarize, transcribe, describe, tag suggestions).";
		}
		return "Select assistant mode.";
	}

	renderCollapsedModeSummary() {
		const mode = this.state.selectedActivityOrFiles;
		const label = this.getModeOptionLabel(mode);

		return <div style={{ color: "#dbe5f4" }}>
			<div style={{ fontWeight: 600, fontSize: "13px", lineHeight: 1.35 }}>{label}</div>
		</div>;
	}

	renderSelectActivityOrFiles() {
		const getOptionStyle = (isSelected) => {
			return {
				display: "block",
				padding: "10px 12px",
				marginTop: "8px",
				borderRadius: "8px",
				border: isSelected ? "1px solid #4d88d8" : "1px solid #2d3f57",
				backgroundColor: isSelected ? "#16263a" : "#101a29",
				color: isSelected ? "#f4f9ff" : "#dbe5f4",
				fontWeight: isSelected ? 600 : 500
			};
		};

		const availableModes = this.getAvailableModes();

		return <div style={{ display: "flex", flexDirection: "column" }}>
			{availableModes.includes("authoring") &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === "authoring")}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value="authoring"
						checked={this.state.selectedActivityOrFiles === "authoring"}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: "authoring"
							}, () => {
								this.ensureAuthoringContextLoaded();
							});
						}}
					/>
					Ask questions about AmbiFi authoring capabilities.
				</label>
			}
			{this.state.selectedActivityOrFiles === "authoring" && this.renderAuthoringContext()}
			{availableModes.includes(STRUCTURE_ASSISTANT_MODE) &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === STRUCTURE_ASSISTANT_MODE)}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value={STRUCTURE_ASSISTANT_MODE}
						checked={this.state.selectedActivityOrFiles === STRUCTURE_ASSISTANT_MODE}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: STRUCTURE_ASSISTANT_MODE,
								activeStructureContext: null,
								latestStructureSubtreeSpec: null
							}, () => {
								this.ensureAuthoringContextLoaded();
							});
						}}
					/>
					Generate or revise outline structure for the selected node.
				</label>
			}
			{this.state.selectedActivityOrFiles === STRUCTURE_ASSISTANT_MODE && this.renderStructureContext()}
			{availableModes.includes(BULK_EDIT_ASSISTANT_MODE) &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === BULK_EDIT_ASSISTANT_MODE)}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value={BULK_EDIT_ASSISTANT_MODE}
						checked={this.state.selectedActivityOrFiles === BULK_EDIT_ASSISTANT_MODE}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: BULK_EDIT_ASSISTANT_MODE,
								activeBulkEditContext: null,
								latestBulkEditInstructions: null
							});
						}}
					/>
					Bulk edit selected outline subtree properties.
				</label>
			}
			{this.state.selectedActivityOrFiles === BULK_EDIT_ASSISTANT_MODE && this.renderBulkEditContext()}
			{availableModes.includes(ACTIVITY_ANALYSIS_ASSISTANT_MODE) &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === ACTIVITY_ANALYSIS_ASSISTANT_MODE)}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value={ACTIVITY_ANALYSIS_ASSISTANT_MODE}
						checked={this.state.selectedActivityOrFiles === ACTIVITY_ANALYSIS_ASSISTANT_MODE}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: ACTIVITY_ANALYSIS_ASSISTANT_MODE
							});
						}}
					/>
					Analyze the current activity JSON and structure.
				</label>
			}
			{this.state.selectedActivityOrFiles === ACTIVITY_ANALYSIS_ASSISTANT_MODE && this.renderActivityAnalysisContext()}
			{availableModes.includes(DRAFT_ASSISTANT_MODE_FIELD_TEXT) &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === DRAFT_ASSISTANT_MODE_FIELD_TEXT)}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value={DRAFT_ASSISTANT_MODE_FIELD_TEXT}
						checked={this.state.selectedActivityOrFiles === DRAFT_ASSISTANT_MODE_FIELD_TEXT}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: DRAFT_ASSISTANT_MODE_FIELD_TEXT
							}, () => {
								this.ensureAuthoringContextLoaded();
							});
						}}
					/>
					Create or rewrite content for a field (with insert actions).
				</label>
			}
			{this.state.selectedActivityOrFiles === DRAFT_ASSISTANT_MODE_FIELD_TEXT && this.renderDraftContext(DRAFT_ASSISTANT_MODE_FIELD_TEXT)}
			{availableModes.includes(SCRIPT_ASSISTANT_MODE_FUNCTIONS) &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === SCRIPT_ASSISTANT_MODE_FUNCTIONS)}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value={SCRIPT_ASSISTANT_MODE_FUNCTIONS}
						checked={this.state.selectedActivityOrFiles === SCRIPT_ASSISTANT_MODE_FUNCTIONS}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: SCRIPT_ASSISTANT_MODE_FUNCTIONS
							}, () => {
								this.ensureAuthoringContextLoaded();
							});
						}}
					/>
					Script activity Functions (with insert actions).
				</label>
			}
			{this.state.selectedActivityOrFiles === SCRIPT_ASSISTANT_MODE_FUNCTIONS && this.renderScriptContext(SCRIPT_ASSISTANT_MODE_FUNCTIONS)}
			{availableModes.includes(SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER) &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER)}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value={SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER}
						checked={this.state.selectedActivityOrFiles === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER
							}, () => {
								this.ensureAuthoringContextLoaded();
							});
						}}
					/>
					Script selected Value Trigger (with insert actions).
				</label>
			}
			{this.state.selectedActivityOrFiles === SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER && this.renderScriptContext(SCRIPT_ASSISTANT_MODE_VALUE_TRIGGER)}
			{availableModes.includes("activity") &&
				<label style={getOptionStyle(this.state.selectedActivityOrFiles === "activity")}>
					<input
						style={{ marginRight: "10px" }}
						type="radio"
						value="activity"
						checked={this.state.selectedActivityOrFiles === "activity"}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: "activity"
							});
						}}
					/>
					Share current activity content with the assistant.
				</label>
			}
				{this.state.selectedActivityOrFiles === "activity" && this.renderCurrentActivity()}
				{availableModes.includes("org") &&
					<label style={getOptionStyle(this.state.selectedActivityOrFiles === "org")}>
						<input
							style={{ marginRight: "10px" }}
							type="radio"
						value="org"
						checked={this.state.selectedActivityOrFiles === "org"}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: "org"
							});
						}}
						/>
						Chat with all content shared in the org.
					</label>
				}
				{this.state.selectedActivityOrFiles === "org" && this.renderOrg()}
				{availableModes.includes(DRIVE_ASSET_ASSISTANT_MODE) &&
					<label style={getOptionStyle(this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE)}>
						<input
							style={{ marginRight: "10px" }}
							type="radio"
							value={DRIVE_ASSET_ASSISTANT_MODE}
							checked={this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE}
							onChange={() => {
								this.setState({
									selectedActivityOrFiles: DRIVE_ASSET_ASSISTANT_MODE
								});
							}}
						/>
						Work with selected Drive asset (summarize, transcribe, describe, tag suggestions).
					</label>
				}
				{this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE && this.renderDriveAssetContext()}
				{availableModes.includes("files") &&
					<label style={getOptionStyle(this.state.selectedActivityOrFiles === "files")}>
						<input
							style={{ marginRight: "10px" }}
							type="radio"
						value="files"
						checked={this.state.selectedActivityOrFiles === "files"}
						onChange={() => {
							this.setState({
								selectedActivityOrFiles: "files"
							});
						}}
					/>
					General chat and share selected files with the assistant.
				</label>
			}
			{this.state.selectedActivityOrFiles === "files" && this.renderFiles()}
		</div>;
	}

	renderStructureContext() {
		if (this.state.selectedActivityOrFiles !== STRUCTURE_ASSISTANT_MODE) {
			return null;
		}

		const structureContext = this.getStructureContext();
		const latestSubtreeSpec = this.getLatestStructureSubtreeSpec();
		const applyChoices = this.getStructureApplyChoices(latestSubtreeSpec);
		const generatedAtLabel = this.getContextGeneratedAtLabel();
		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>Ask questions about the current outline or generate subtree JSON for the current selection. Plain-language answers do not produce apply actions; generated structure does.</i></div>
			<div style={{ marginTop: "6px" }}><i>Selected node: {structureContext.targetLabel || "(none)"} ({structureContext.targetType || "node"})</i></div>
			{latestSubtreeSpec && applyChoices.length > 0 &&
				<div style={{ marginTop: "6px" }}><i>Latest structure is ready to apply. Available actions: {applyChoices.map((choice) => choice.label).join(", ")}</i></div>
			}
			{latestSubtreeSpec && applyChoices.length === 0 &&
				<div style={{ marginTop: "6px", color: "#ffb3b3" }}><i>The latest generated structure is not valid for the current target. Select a higher-level node or ask the assistant to return a valid {structureContext.targetType || "selected"} subtree.</i></div>
			}
			{!latestSubtreeSpec && this.state.lastResponseMode === STRUCTURE_ASSISTANT_MODE && this.state.lastStructureGenerationMode === "analysis" &&
				<div style={{ marginTop: "6px" }}><i>Latest response is an outline answer only. No structure apply actions are available for that response.</i></div>
			}
			{this.state.authoringContextStatus === "loading" &&
				<div style={{ marginTop: "6px" }}><i>Loading authoring context...</i></div>
			}
			{this.state.authoringContextStatus === "ready" && generatedAtLabel &&
				<div style={{ marginTop: "6px" }}><i>Context generated: {generatedAtLabel}</i></div>
			}
			{this.state.authoringContextStatus === "error" &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>{this.state.authoringContextError}</i></div>
			}
		</div>;
	}

	renderBulkEditContext() {
		if (this.state.selectedActivityOrFiles !== BULK_EDIT_ASSISTANT_MODE) {
			return null;
		}

		const bulkEditContext = this.getBulkEditContext();
		const latestInstructionCount = Array.isArray(this.state.latestBulkEditInstructions)
			? this.state.latestBulkEditInstructions.length
			: 0;
		const targetPathLabel = bulkEditContext
			? this.buildStructurePathLabel(bulkEditContext.projectedChecklist, bulkEditContext.checklistPath)
			: "";
		const filterSummary = this.describeBulkEditFilterSummary(this.state.latestBulkEditInstructions);

			return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
				<div><i>The selected node is the default root for bulk edit operations, and changes apply throughout its descendant subtree. If your prompt names a more specific structural path, that path becomes the target instead.</i></div>
			<div style={{ marginTop: "6px" }}><i>Selected node: {bulkEditContext.targetLabel || "(none)"} ({bulkEditContext.targetType || "node"})</i></div>
			<div style={{ marginTop: "6px" }}><i>Target path: {targetPathLabel || "(root)"}</i></div>
			{bulkEditContext.targetReadOnly &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>This target is read-only. You can draft a bulk edit plan, but apply actions are disabled.</i></div>
			}
			{latestInstructionCount > 0 &&
				<div style={{ marginTop: "6px" }}><i>Latest bulk edit plan is ready to apply. Instruction count: {latestInstructionCount}. Additional label filter: {filterSummary}.</i></div>
			}
		</div>;
	}

	renderActivityAnalysisContext() {
		if (this.state.selectedActivityOrFiles !== ACTIVITY_ANALYSIS_ASSISTANT_MODE) {
			return null;
		}

		const analysisContext = this.getActivityAnalysisContext();
		const activityName = analysisContext.activityName || "(unnamed activity)";
		const valueTriggerCount = analysisContext.inventory && Array.isArray(analysisContext.inventory.valueTriggers)
			? analysisContext.inventory.valueTriggers.length
			: 0;
		const hasFunctionsScript = analysisContext.inventory &&
			typeof analysisContext.inventory.functionsScript === "string" &&
			analysisContext.inventory.functionsScript.trim() !== "";

		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>Ask read-only questions about the current activity JSON, outline, scripts, and property usage. The entire current activity is shared with the assistant for analysis, while the selected node is included as focus context when relevant.</i></div>
			<div style={{ marginTop: "6px" }}><i>Activity: {activityName}</i></div>
			<div style={{ marginTop: "6px" }}><i>Current selection: {analysisContext.selectedPathLabel || "(root)"}{analysisContext.selectedType ? ` (${analysisContext.selectedType})` : ""}</i></div>
			<div style={{ marginTop: "6px" }}><i>Value triggers detected: {valueTriggerCount}. Functions script present: {hasFunctionsScript ? "yes" : "no"}.</i></div>
			{analysisContext.activityJsonTruncated &&
				<div style={{ marginTop: "6px" }}><i>Large activity JSON will be truncated in the prompt when needed.</i></div>
			}
			{analysisContext.activityJsonWarning &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>{analysisContext.activityJsonWarning}</i></div>
			}
		</div>;
	}

	renderAuthoringContext() {
		if (this.state.selectedActivityOrFiles !== "authoring") {
			return null;
		}

		const generatedAtLabel = this.getContextGeneratedAtLabel();

		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>Ask how to author activities, configure properties, and use runtime APIs across web and mobile players. This mode uses generated AmbiFi authoring context.</i></div>
			{this.state.authoringContextStatus === "loading" &&
				<div style={{ marginTop: "6px" }}><i>Loading authoring context...</i></div>
			}
			{this.state.authoringContextStatus === "ready" && generatedAtLabel &&
				<div style={{ marginTop: "6px" }}><i>Context generated: {generatedAtLabel}</i></div>
			}
			{this.state.authoringContextStatus === "error" &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>{this.state.authoringContextError}</i></div>
			}
		</div>;
	}

	renderDraftContext(mode) {
		if (this.state.selectedActivityOrFiles !== mode) {
			return null;
		}

		const draftContext = this.getDraftContextForMode(mode);
		const generatedAtLabel = this.getContextGeneratedAtLabel();

		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>Generate concise authoring text candidates and use Insert/Replace actions to apply the response.</i></div>
			{draftContext && draftContext.targetReadOnly &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>This target is read-only. You can ask questions, but insert actions are disabled.</i></div>
			}
			{this.state.authoringContextStatus === "loading" &&
				<div style={{ marginTop: "6px" }}><i>Loading authoring context...</i></div>
			}
			{this.state.authoringContextStatus === "ready" && generatedAtLabel &&
				<div style={{ marginTop: "6px" }}><i>Context generated: {generatedAtLabel}</i></div>
			}
			{this.state.authoringContextStatus === "error" &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>{this.state.authoringContextError}</i></div>
			}
		</div>;
	}

	renderScriptContext(mode) {
		if (this.state.selectedActivityOrFiles !== mode) {
			return null;
		}

		const scriptContext = this.getScriptContextForMode(mode);
		const targetLabel = scriptContext && scriptContext.targetLabel ? scriptContext.targetLabel : "";
		const generatedAtLabel = this.getContextGeneratedAtLabel();

		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>Generate AmbiFi JavaScript using shared authoring/runtime context, then insert or replace directly in the target script.</i></div>
			{targetLabel &&
				<div style={{ marginTop: "6px" }}><i>Target: {targetLabel}</i></div>
			}
			{scriptContext && scriptContext.targetReadOnly &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>This target is read-only. You can ask questions, but insert actions are disabled.</i></div>
			}
			{this.state.authoringContextStatus === "loading" &&
				<div style={{ marginTop: "6px" }}><i>Loading authoring context...</i></div>
			}
			{this.state.authoringContextStatus === "ready" && generatedAtLabel &&
				<div style={{ marginTop: "6px" }}><i>Context generated: {generatedAtLabel}</i></div>
			}
			{this.state.authoringContextStatus === "error" &&
				<div style={{ marginTop: "6px", color: "#ff9f9f" }}><i>{this.state.authoringContextError}</i></div>
			}
		</div>;
	}

	renderOrg() {
		if (this.state.selectedActivityOrFiles !== "org") {
			return null;
		}

		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>This will allow you to ask questions about all of the content shared in your organization that you have access to.</i></div>
		</div>;
	}

	renderCurrentActivity() {
		if (this.state.selectedActivityOrFiles !== "activity") {
			return null;
		}

		const hasActivity = this.getCurrentActivityId() !== "";

		if (hasActivity) {
			return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
				<div><i>The content of this activity will be shared with your assistant. This will update content directly in your activity.</i></div>
			</div>;
		}

		return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
			<div><i>Activity context is not available on this screen.</i></div>
		</div>;
	}

	renderFiles() {
		if (this.state.selectedActivityOrFiles !== "files") {
			return null;
		}

		const files = this.getAssistantFiles();
		const checklistFiles = Array.isArray(this.props.checklistFiles) ? this.props.checklistFiles : (Array.isArray(this.props.rootAssistantChecklistFiles) ? this.props.rootAssistantChecklistFiles : []);

		let fileRows = files.map((item) => {
			// Need to determine if checked based on a parallel data structure looking at files enabled in this assistant

			let fileChecked = false;
			if (checklistFiles.find((newItem) => {
				return newItem === item.id;
			})) {
				fileChecked = true;
			}

			return <tr style={{ borderStyle: "none" }} key={item.id}>
				<td style={{ borderStyle: "none", width: "50%", wordBreak: "break-all" }}>
					<Checkbox checked={fileChecked} onChange={(e) => {
						if (e.target.checked) {
							// Add to Assistant Files
							assistantsFilesCreate(this.props.aiAssistantId, item.id);
						} else {
							// Remove from Assistant Files
							assistantsFilesDelete(this.props.aiAssistantId, item.id);
						}
					}}>
						{item.filename.replace(this.props.user.identityId + "/", "")}
					</Checkbox>
				</td>
				<td style={{ borderStyle: "none", width: "25%" }}>
					{new Date(item.created_at * 1000).toLocaleString()}
				</td>
				<td style={{ borderStyle: "none", width: "25%" }}>
					<div style={{ display: "flex" }}>
						{/* <Button style={{color: "white", backgroundColor: "#0E7AFE"}} onClick={() => {
							// getContent(this.props.aiAssistantId, item.id);

							getContentStreamed(smd, parser, item.id, this.props.aiAssistantId, );
						}}>
							Get Content
						</Button>	 */}
						<Button style={{ color: "white", backgroundColor: "red" }} onClick={() => {
							filesDelete(item.id);
						}}>
							Delete
						</Button>
					</div>
				</td>
			</tr>;
		});

		if (fileRows.length === 0) {
			return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}><i>You currently do not have any files uploaded.</i></div>;
		} else {
			const filesComponent = <div style={{ maxHeight: "200px", overflow: "auto" }}><table style={{ borderStyle: "none" }}>
				<thead>
					<tr style={{ borderStyle: "none" }}>
						<th style={{ borderStyle: "none", width: "50%" }} scope="col">Filename</th>
						<th style={{ borderStyle: "none", width: "25%" }} scope="col">Created At</th>
						<th style={{ borderStyle: "none", width: "25%" }} scope="col">Actions</th>
					</tr>
				</thead>
				<tbody>
					{fileRows}
				</tbody>
			</table></div>;

			return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
				<div><i>Enable any files below that you want to share with your AI Assistant</i></div>
				{filesComponent}
			</div>;
		}
	}

	async handlePromptAttachmentUpload(event) {
		const file = event && event.target && event.target.files && event.target.files[0]
			? event.target.files[0]
			: null;
		if (!file) {
			return;
		}

		this.setState({
			isUploadingPromptAttachment: true
		});

		try {
			const [uploadedFile, localAsset] = await Promise.all([
				uploadAiFile(env.s3.aiBucket, "openai/files/" + this.props.user.identityId, file),
				this.buildPromptAttachmentLocalAsset(file).catch(() => null)
			]);
			if (uploadedFile && uploadedFile.id) {
				this.setState((prevState) => {
					const currentIds = Array.isArray(prevState.promptAttachmentFileIds) ? prevState.promptAttachmentFileIds : [];
					if (currentIds.includes(uploadedFile.id)) {
						return null;
					}
					const nextLocalAssets = {
						...(prevState.promptAttachmentLocalAssetsById && typeof prevState.promptAttachmentLocalAssetsById === "object"
							? prevState.promptAttachmentLocalAssetsById
							: {})
					};
					if (localAsset) {
						nextLocalAssets[uploadedFile.id] = localAsset;
					}
					return {
						promptAttachmentFileIds: currentIds.concat(uploadedFile.id),
						promptAttachmentLocalAssetsById: nextLocalAssets
					};
				});
			}
		} catch (_err) {
			this.appendAssistantErrorMessage("Unable to upload the selected file for prompt attachment.");
		} finally {
			if (event && event.target) {
				event.target.value = "";
			}
			this.setState({
				isUploadingPromptAttachment: false
			});
		}
	}

	renderPromptAttachmentComposer() {
		if (!this.isPromptAttachmentModeEnabled()) {
			return null;
		}

		const selectedFiles = this.getSelectedPromptAttachmentFiles();
		const actionButtonStyle = {
			borderRadius: "7px",
			padding: "4px 10px",
			fontSize: "12px",
			backgroundColor: "#1f3048",
			borderColor: "#304866",
			color: "#ffffff"
		};

		return <div style={{ marginBottom: "10px", display: "flex", flexDirection: "column", gap: "8px" }}>
			<div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "8px" }}>
				<Button
					style={{ ...actionButtonStyle, backgroundColor: "#274567", borderColor: "#365b87" }}
					bsStyle="primary"
					bsSize="small"
					disabled={this.state.isUploadingPromptAttachment}
					onClick={() => {
						if (this.promptAttachmentUploadInputRef && typeof this.promptAttachmentUploadInputRef.click === "function") {
							this.promptAttachmentUploadInputRef.click();
						}
					}}
				>
					{this.state.isUploadingPromptAttachment ? <span><FontAwesomeIcon icon="spinner" spin /> Uploading</span> : "Upload and Attach"}
				</Button>
				<input
					ref={(node) => {
						this.promptAttachmentUploadInputRef = node;
					}}
					type="file"
					style={{ display: "none" }}
					onChange={async (event) => {
						await this.handlePromptAttachmentUpload(event);
					}}
				/>
				<div style={{ color: "#9fb2cd", fontSize: "12px" }}>
					Files attached here stay with this chat only and clear on New Chat.
				</div>
			</div>
			{selectedFiles.length > 0 &&
				<div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
					{selectedFiles.map((file) => <div
						key={`prompt-attachment-chip-${file.id}`}
						style={{
							display: "inline-flex",
							alignItems: "center",
							gap: "6px",
							padding: "4px 8px",
							borderRadius: "999px",
							backgroundColor: "#132238",
							border: "1px solid #314763",
							color: "#dce8f8",
							fontSize: "12px",
							maxWidth: "100%"
						}}
					>
						<FontAwesomeIcon icon="paperclip" />
						<span style={{ wordBreak: "break-all" }}>{this.getAssistantFileDisplayName(file)}</span>
						<button
							type="button"
							onClick={() => this.removePromptAttachmentFile(file.id)}
							style={{
								background: "transparent",
								border: "none",
								color: "#dce8f8",
								padding: 0,
								lineHeight: 1,
								cursor: "pointer"
							}}
						>
							×
						</button>
					</div>)}
				</div>
			}
		</div>;
	}

		renderDriveAssetContext() {
			if (this.state.selectedActivityOrFiles !== DRIVE_ASSET_ASSISTANT_MODE) {
				return null;
		}

		const asset = this.getSelectedDriveAssetResource();
		if (!asset) {
			return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
				<div><i>Select a file in Drive to enable asset AI actions.</i></div>
			</div>;
		}

			const mediaType = this.getDriveAssetMediaType(asset);
			const path = this.getDriveAssetPath(asset);
			const quickPrompts = this.getDriveAssetQuickPrompts();
			const canShowTranscriptMode = mediaType === "video" || mediaType === "audio";

			return <div style={{ marginLeft: "32px", marginTop: "8px", color: "#a8b8cd" }}>
				<div><i>Analyze the selected Drive file in chat. Use "Set Title", "Set Description", "Set Transcript", or "Set Tags" after a response to save to Drive metadata.</i></div>
			<div style={{ marginTop: "6px" }}><b>Selected:</b> {asset.name || "(unnamed file)"}</div>
			<div style={{ marginTop: "2px" }}><b>Type:</b> {mediaType}{this.getDriveAssetExtension(asset) ? ` (.${this.getDriveAssetExtension(asset)})` : ""}</div>
				{path &&
					<div style={{ marginTop: "2px", wordBreak: "break-all" }}><b>Path:</b> {path}</div>
				}
				{canShowTranscriptMode &&
					<div style={{ marginTop: "8px", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
						<span style={{ color: "#9fb2cd", fontSize: "12px" }}><b>Transcript Output:</b></span>
						<Button
							bsStyle={this.state.driveTranscriptRenderMode === DRIVE_TRANSCRIPT_RENDER_MODE_DECORATED ? "primary" : "default"}
							bsSize="xsmall"
							style={{
								borderRadius: "7px",
								backgroundColor: this.state.driveTranscriptRenderMode === DRIVE_TRANSCRIPT_RENDER_MODE_DECORATED ? "#1f4d88" : "#274567",
								borderColor: "#2f68ab",
								padding: "2px 8px",
								fontSize: "11px",
								color: "white"
							}}
							onClick={() => this.setState({ driveTranscriptRenderMode: DRIVE_TRANSCRIPT_RENDER_MODE_DECORATED })}
						>
							Decorated
						</Button>
						<Button
							bsStyle={this.state.driveTranscriptRenderMode === DRIVE_TRANSCRIPT_RENDER_MODE_RAW ? "primary" : "default"}
							bsSize="xsmall"
							style={{
								borderRadius: "7px",
								backgroundColor: this.state.driveTranscriptRenderMode === DRIVE_TRANSCRIPT_RENDER_MODE_RAW ? "#1f4d88" : "#274567",
								borderColor: "#2f68ab",
								padding: "2px 8px",
								fontSize: "11px",
								color: "white"
							}}
							onClick={() => this.setState({ driveTranscriptRenderMode: DRIVE_TRANSCRIPT_RENDER_MODE_RAW })}
						>
							Raw
						</Button>
					</div>
				}
				<div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
					{quickPrompts.map((item) => (
						<Button
						key={item.label}
						bsStyle="primary"
						bsSize="small"
						style={{ borderRadius: "7px", backgroundColor: "#1f4d88", borderColor: "#2f68ab", padding: "4px 8px", fontSize: "12px" }}
						onClick={() => this.setState({ inputAiMessage: item.prompt })}
					>
						{item.label}
					</Button>
				))}
			</div>
		</div>;
	}

	buildDriveAssetContextMessage(userMessage) {
		const asset = this.getSelectedDriveAssetResource();
		const requestText = (userMessage || "").trim();
		if (!asset) {
			return requestText;
		}

		const mediaType = this.getDriveAssetMediaType(asset);
		const path = this.getDriveAssetPath(asset);
		const assetUrl = this.getDriveAssetUrl(asset);
		const conversationKey = this.getDriveTranscriptConversationKey(asset);
		const hasResponseChain = !!(
			this.conversationStateByKey[conversationKey] &&
			this.conversationStateByKey[conversationKey].responseId
		);
		const cachedTranscript = this.getCachedDriveTranscript(asset);
		const metaData = asset && asset.metaData && typeof asset.metaData === "object" ? asset.metaData : {};
		const tags = Array.isArray(metaData.tags) ? metaData.tags : [];
		const title = this.cleanDriveTitleCandidate(metaData.title || "");
		const description = this.cleanDriveDescriptionCandidate(metaData.description || "");
		const metadataTranscript = this.cleanDriveTranscriptCandidate(metaData.transcript || "");
		const effectiveTranscript = cachedTranscript || metadataTranscript;
		const shouldAttachEffectiveTranscriptContext = effectiveTranscript !== "" &&
			(!hasResponseChain || this.isLikelyDriveTranscriptFollowUpRequest(requestText));
		const instruction = [
			"You are the AmbiFi Drive Asset Assistant.",
			"Use the selected asset context below to answer the user request.",
			shouldAttachEffectiveTranscriptContext
				? "A transcript from an earlier turn is included below. Use it as the source of truth for content questions and do not claim file bytes are unavailable."
				: "If you cannot directly access the file bytes from the provided context, state that clearly and still provide the best possible help (summary guidance, next steps, tag suggestions).",
			"For tag-generation requests, return a single comma-separated line of tags first."
		].join("\n");

		const contextLines = [
			"Selected Asset Context:",
			`- Name: ${asset.name || "(unnamed file)"}`,
			`- Media Type: ${mediaType}`,
			`- Extension: ${this.getDriveAssetExtension(asset) || "(none)"}`,
			`- GUID: ${asset.guid || "(none)"}`,
			`- Path: ${path || "(none)"}`,
			`- URL: ${assetUrl || "(not available)"}`,
			`- Existing Tags: ${tags.length > 0 ? tags.join(", ") : "(none)"}`,
			`- Existing Title: ${title || "(none)"}`,
			`- Existing Description: ${description || "(none)"}`,
			`- Existing Transcript: ${metadataTranscript !== "" ? "yes" : "no"}`,
			`- Transcript Available: ${effectiveTranscript !== "" ? "yes" : "no"}`
		];

		if (shouldAttachEffectiveTranscriptContext) {
			const transcriptForPrompt = effectiveTranscript.length > MAX_DRIVE_TRANSCRIPT_FOLLOWUP_CONTEXT_CHARS
				? `${effectiveTranscript.slice(0, MAX_DRIVE_TRANSCRIPT_FOLLOWUP_CONTEXT_CHARS)}\n\n[Transcript truncated due to length.]`
				: effectiveTranscript;
			return [
				instruction,
				contextLines.join("\n"),
				"Transcript from earlier turn:",
				transcriptForPrompt,
				`User request: ${requestText}`
			].join("\n\n");
		}

		return [instruction, contextLines.join("\n"), `User request: ${requestText}`].join("\n\n");
	}

	async getDriveAssetImageDataUrl(asset, assetUrl) {
		if (!asset || !assetUrl || typeof assetUrl !== "string") {
			return "";
		}
		if (assetUrl.indexOf("data:image/") === 0) {
			return assetUrl;
		}

		const cacheKey = [
			asset.guid || "",
			this.getDriveAssetPath(asset) || "",
			asset.revision || asset.revisionTs || "",
			assetUrl
		].join("|");
		if (this.driveImageDataUrlCache[cacheKey]) {
			return this.driveImageDataUrlCache[cacheKey];
		}

		if (typeof fetch !== "function" || typeof FileReader === "undefined") {
			return "";
		}

		try {
			const response = await fetch(assetUrl, { credentials: "include" });
			if (!response || !response.ok) {
				return "";
			}

			const contentType = (response.headers.get("content-type") || "").toLowerCase();
			if (!contentType || contentType.indexOf("image/") !== 0) {
				return "";
			}

			const blob = await response.blob();
			if (!blob || !blob.size || blob.size > MAX_IMAGE_DATA_URL_BYTES) {
				return "";
			}

			const dataUrl = await new Promise((resolve, reject) => {
				const fileReader = new FileReader();
				fileReader.onloadend = () => {
					resolve(typeof fileReader.result === "string" ? fileReader.result : "");
				};
				fileReader.onerror = () => reject(fileReader.error || new Error("Unable to read image blob."));
				fileReader.readAsDataURL(blob);
			});

			if (typeof dataUrl === "string" && dataUrl.indexOf("data:image/") === 0) {
				this.driveImageDataUrlCache[cacheKey] = dataUrl;
				return dataUrl;
			}

			return "";
		} catch (_err) {
			return "";
		}
	}

	async buildDriveAssetMessages(userMessage) {
		const asset = this.getSelectedDriveAssetResource();
		const mediaType = this.getDriveAssetMediaType(asset);
		const assetUrl = this.getDriveAssetUrl(asset);
		const userContextMessage = this.buildDriveAssetContextMessage(userMessage);

		if (mediaType === "image" && assetUrl) {
			const imageDataUrl = await this.getDriveAssetImageDataUrl(asset, assetUrl);
			const contentParts = [{ type: "text", text: userContextMessage }];
			if (imageDataUrl) {
				contentParts.push({ type: "image_url", image_url: { url: imageDataUrl } });
			} else {
				contentParts.push({
					type: "text",
					text: "Image bytes could not be attached directly for analysis in this request. Continue with available file metadata."
				});
			}

			return [
				{
					role: "system",
					content: "You are a helpful assistant."
				},
				{
					role: "user",
					content: contentParts
				}
			];
		}

		return [
			{
				role: "system",
				content: "You are a helpful assistant."
			},
			{
				role: "user",
				content: userContextMessage
			}
		];
	}

	async transcribeDriveAssetToText(asset, promptText = "") {
		const s3Key = this.getDriveAssetS3Key(asset);
		if (!s3Key) {
			throw new Error("Missing S3 key for selected Drive asset.");
		}
		const mediaType = this.getDriveAssetMediaType(asset);
		const transcriptionTemplate = {
			bucket: env.s3.assetsBucket,
			key: s3Key,
			fileName: asset.name || "",
			mediaType,
			prompt: (promptText || "").trim() || `Transcribe this selected ${mediaType} to plain text with useful section breaks.`
		};
		const transcriptionResponse = await getAudioTranscriptionsLambda(JSON.stringify(transcriptionTemplate));
		const transcriptText = this.extractResponsesText(transcriptionResponse);
		if (!transcriptText) {
			throw new Error("Transcription returned an empty response.");
		}
		const transcriptionModeLabel = transcriptionResponse &&
			typeof transcriptionResponse === "object" &&
			typeof transcriptionResponse.transcription_mode === "string"
			? transcriptionResponse.transcription_mode
			: "";
		return {
			transcriptText,
			transcriptionModeLabel
		};
	}

	async runDriveAssetModeRequest(mode = DRIVE_ASSET_ASSISTANT_MODE) {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(mode)) {
			this.appendAssistantErrorMessage("Drive asset mode is not available. Select a file in Drive first.");
			return;
		}

		const asset = this.getSelectedDriveAssetResource();
		if (!asset) {
			this.appendAssistantErrorMessage("No Drive file is selected.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}

		this.appendConversationHeader(userMessage, mode);
		this.startWaitingForResponse();

		try {
			const isTranscriptionRequest = this.isDriveAssetTranscriptionRequest(userMessage, asset);
			const mediaType = this.getDriveAssetMediaType(asset);
			let driveAssetResponse = "";
			const cachedTranscript = this.getCachedDriveTranscript(asset);
			const shouldPrimeTranscriptForContentAnalysis = !isTranscriptionRequest &&
				cachedTranscript === "" &&
				this.isDriveAssetContentAnalysisRequest(userMessage, asset);

			if (shouldPrimeTranscriptForContentAnalysis) {
				const { transcriptText, transcriptionModeLabel } = await this.transcribeDriveAssetToText(asset);
				this.cacheDriveTranscript(asset, transcriptText);
				if (transcriptionModeLabel) {
					this.appendAssistantInfoMessage(`Transcription mode: ${transcriptionModeLabel} (auto for analysis)`);
				}
			}

			if (isTranscriptionRequest) {
				const { transcriptText, transcriptionModeLabel } = await this.transcribeDriveAssetToText(asset, userMessage);
					this.cacheDriveTranscript(asset, transcriptText);
				if (transcriptionModeLabel) {
					this.appendAssistantInfoMessage(`Transcription mode: ${transcriptionModeLabel}`);
				}

				if (this.state.driveTranscriptRenderMode === DRIVE_TRANSCRIPT_RENDER_MODE_RAW) {
					driveAssetResponse = transcriptText;
				} else {
					const transcriptForContext = transcriptText.length > MAX_TRANSCRIPT_CONTEXT_CHARS
						? `${transcriptText.slice(0, MAX_TRANSCRIPT_CONTEXT_CHARS)}\n\n[Transcript truncated due to length.]`
						: transcriptText;
					const transcriptionPrompt = [
						"You are the AmbiFi Drive Asset Assistant.",
						"Use the provided transcript as the source of truth for this asset.",
						"Do not claim that you cannot access the file bytes in this response.",
						`Selected asset: ${asset.name || "(unnamed file)"}`,
						`Original request: ${userMessage}`,
						"",
						"Transcript:",
						transcriptForContext,
						"",
						"Return the transcript in plain text with useful section breaks."
					].join("\n");
					driveAssetResponse = await this.runResponsesConversationTurn({
						mode,
						conversationOptions: { asset },
						messages: [
							{
								role: "system",
								content: "You are a helpful assistant."
							},
							{
								role: "user",
								content: transcriptionPrompt
							}
						],
						model: DEFAULT_ASSISTANT_CHAT_MODEL
					});
				}
			} else if (mediaType === "pdf") {
				driveAssetResponse = await this.runPdfDriveAssetConversationTurn({
					mode,
					asset,
					userMessage
				});
			} else if (mediaType === "image") {
				const s3Key = this.getDriveAssetS3Key(asset);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected Drive image asset.");
				}

				const imageTemplate = {
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: asset.name || "",
					mediaType,
					prompt: userMessage
				};
				const imageAnalysisResponse = await getImageDescriptionsLambda(JSON.stringify(imageTemplate));
				const imageAnalysisText = (typeof imageAnalysisResponse === "string" && imageAnalysisResponse.trim() !== "")
					? imageAnalysisResponse
					: (imageAnalysisResponse && typeof imageAnalysisResponse === "object")
						? JSON.stringify(imageAnalysisResponse, null, 2)
						: "";
				if (!imageAnalysisText) {
					throw new Error("Image analysis returned an empty response.");
				}

				const imageAnalysisForContext = imageAnalysisText.length > MAX_IMAGE_ANALYSIS_CONTEXT_CHARS
					? `${imageAnalysisText.slice(0, MAX_IMAGE_ANALYSIS_CONTEXT_CHARS)}\n\n[Image analysis truncated due to length.]`
					: imageAnalysisText;
				const imagePrompt = [
					"You are the AmbiFi Drive Asset Assistant.",
					"Use the provided image analysis as the source of truth for this asset.",
					"Do not claim that you cannot access the image bytes in this response.",
					`Selected asset: ${asset.name || "(unnamed file)"}`,
					`Original request: ${userMessage}`,
					"",
					"Image analysis:",
					imageAnalysisForContext
				].join("\n");

				driveAssetResponse = await this.runResponsesConversationTurn({
					mode,
					conversationOptions: { asset },
					messages: [
						{
							role: "system",
							content: "You are a helpful assistant."
						},
						{
							role: "user",
							content: imagePrompt
						}
					],
					model: DEFAULT_ASSISTANT_CHAT_MODEL
				});
			} else {
				driveAssetResponse = await this.runResponsesConversationTurn({
					mode,
					conversationOptions: { asset },
					messages: await this.buildDriveAssetMessages(userMessage),
					model: DEFAULT_ASSISTANT_CHAT_MODEL
				});
			}

			const responseText = driveAssetResponse && typeof driveAssetResponse === "string"
				? driveAssetResponse
				: "I was unable to generate a response.";

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
		} catch (err) {
			this.appendAssistantErrorMessage(this.getAssistantErrorMessage("Failed to process Drive asset response.", err));
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async runAuthoringModeRequest() {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes("authoring")) {
			this.appendAssistantErrorMessage("Authoring help mode is not available on this screen.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}

		await this.ensureAuthoringContextLoaded();
		await this.ensureAuthoringGuideLoaded();
		const conversation = this.conversationStateByKey[this.getConversationScopeKey("authoring")];
		const authoringMessage = this.buildAuthoringContextMessage(userMessage, { includeGuide: !(conversation && conversation.responseId) });

		this.appendConversationHeader(userMessage, "authoring");
		this.startWaitingForResponse();
		try {
			const authoringResponse = await this.runResponsesConversationTurn({
				mode: "authoring",
				messages: [
					{
						role: "system",
						content: "You are a helpful assistant."
					},
					{
						role: "user",
						content: authoringMessage
					}
				],
				model: DEFAULT_ASSISTANT_CHAT_MODEL
			});
			const responseText = authoringResponse && typeof authoringResponse === "string"
				? authoringResponse
				: "I was unable to generate a response.";

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
		} catch (err) {
			this.appendAssistantErrorMessage(this.getAssistantErrorMessage("Failed to process authoring help response.", err));
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async runActivityAnalysisModeRequest() {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(ACTIVITY_ANALYSIS_ASSISTANT_MODE)) {
			this.appendAssistantErrorMessage("Activity analysis mode is not available on this screen.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}

		const analysisPrompt = this.buildActivityAnalysisPrompt(userMessage);

		this.appendConversationHeader(userMessage, ACTIVITY_ANALYSIS_ASSISTANT_MODE);
		this.startWaitingForResponse();
		try {
			const analysisResponse = await this.runResponsesConversationTurn({
				mode: ACTIVITY_ANALYSIS_ASSISTANT_MODE,
				messages: [
					{
						role: "system",
						content: "You are a helpful assistant."
					},
					{
						role: "user",
						content: analysisPrompt
					}
				],
				model: DEFAULT_ASSISTANT_CHAT_MODEL
			});
			const responseText = analysisResponse && typeof analysisResponse === "string"
				? analysisResponse
				: "I was unable to generate a response.";

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
		} catch (err) {
			this.appendAssistantErrorMessage(this.getAssistantErrorMessage("Failed to process activity analysis response.", err));
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async runBulkEditModeRequest() {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(BULK_EDIT_ASSISTANT_MODE)) {
			this.appendAssistantErrorMessage("Bulk edit mode is not available on this screen.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}

		const bulkEditContext = this.resolveBulkEditContextForRequest(userMessage);
		if (!bulkEditContext || !Array.isArray(bulkEditContext.targetPath)) {
			this.appendAssistantErrorMessage("No valid bulk edit target is selected.");
			return;
		}

		this.setState({
			activeBulkEditContext: null,
			latestBulkEditInstructions: null
		});
		this.appendConversationHeader(userMessage, BULK_EDIT_ASSISTANT_MODE);
		this.startWaitingForResponse();

		try {
			const carryOverText = this.consumeModeCarryOverText(BULK_EDIT_ASSISTANT_MODE, {
				targetPath: bulkEditContext.targetPath
			});
			const instructionResult = await generateAiBulkEditInstructions(this.context.tree, {
				prompt: this.applyCarryOverToPrompt(this.buildBulkEditPrompt(userMessage, bulkEditContext), carryOverText),
				rawUserPrompt: userMessage,
				maxOps: 100,
				selectedPath: bulkEditContext.targetPath,
				showSpinner: false
			});
			const responseText = this.formatBulkEditInstructionsForDisplay(instructionResult, bulkEditContext);

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
			this.setState({
				activeBulkEditContext: {
					targetPath: bulkEditContext.targetPath,
					targetLabel: bulkEditContext.targetLabel,
					targetReadOnly: bulkEditContext.targetReadOnly === true,
					featureName: bulkEditContext.featureName || "",
					featureDescription: bulkEditContext.featureDescription || "",
					additionalContextLines: Array.isArray(bulkEditContext.additionalContextLines) ? bulkEditContext.additionalContextLines : []
				},
				latestBulkEditInstructions: instructionResult.instructions || []
			});
		} catch (err) {
			this.appendAssistantErrorMessage(err && err.message ? err.message : "Failed to generate bulk edit instructions.");
		} finally {
			this.stopWaitingForResponse();
		}
	}

	async runStructureModeRequest() {
		const availableModes = this.getAvailableModes();
		if (!availableModes.includes(STRUCTURE_ASSISTANT_MODE)) {
			this.appendAssistantErrorMessage("Structure mode is not available on this screen.");
			return;
		}

		const userMessage = (this.state.inputAiMessage || "").trim();
		if (!userMessage) {
			return;
		}
		const structureContext = this.resolveStructureContextForRequest(userMessage);
		if (!structureContext || !Array.isArray(structureContext.targetPath)) {
			this.appendAssistantErrorMessage("No valid structure target is selected.");
			return;
		}
		const structureIntent = inferStructureStudioIntent(userMessage);
		const isAnalysisRequest = this.isStructureAnalysisRequest(userMessage, structureIntent);

		this.appendConversationHeader(userMessage, STRUCTURE_ASSISTANT_MODE);

		if (!isAnalysisRequest) {
			const directSubtreeSpec = normalizeGeneratedSubtreeSpecV1(coerceSubtreeSpecV1(userMessage), {
				selectedType: structureContext.targetType,
				selectedName: structureContext.targetLabel,
				generationMode: structureIntent.generationMode
			});
			if (directSubtreeSpec) {
				const responseText = "Structure plan ready. Review the structured plan below before applying.";
				let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
				newData = newData + responseText;
				this.context.tree.set(["appState", "aiAssistantResponse"], newData);
				this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
				this.setState({
					activeStructureContext: {
						targetPath: structureContext.targetPath,
						targetLabel: structureContext.targetLabel,
						targetReadOnly: structureContext.targetReadOnly === true,
						featureName: structureContext.featureName || "",
						featureDescription: structureContext.featureDescription || "",
						additionalContextLines: Array.isArray(structureContext.additionalContextLines) ? structureContext.additionalContextLines : []
					},
					latestStructureSubtreeSpec: directSubtreeSpec,
					lastStructureGenerationMode: structureIntent.generationMode
				});
				return;
			}
		}

		await this.ensureAuthoringContextLoaded();
		const prompt = isAnalysisRequest
			? this.buildStructureAnalysisPrompt(userMessage, structureContext)
			: this.buildStructureModePrompt(userMessage, structureIntent, structureContext);

		this.startWaitingForResponse();
		try {
			const structureResponse = await this.runResponsesConversationTurn({
				mode: STRUCTURE_ASSISTANT_MODE,
				conversationOptions: {
					targetPath: Array.isArray(structureContext.targetPath) ? structureContext.targetPath : null
				},
				messages: [
					{
						role: "system",
						content: "You are a helpful assistant."
					},
					{
						role: "user",
						content: prompt
					}
				],
				model: DEFAULT_ASSISTANT_CHAT_MODEL
			});
			const normalizedSubtreeSpec = !isAnalysisRequest
				? normalizeGeneratedSubtreeSpecV1(coerceSubtreeSpecV1(structureResponse || ""), {
					selectedType: structureContext.targetType,
					selectedName: structureContext.targetLabel,
					generationMode: structureIntent.generationMode
				})
				: null;
			const responseText = normalizedSubtreeSpec
				? "Structure plan ready. Review the structured plan below before applying."
				: (structureResponse && typeof structureResponse === "string"
					? structureResponse
					: "I was unable to generate a response.");

			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = newData + responseText;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.context.tree.set(["appState", "aiAssistantResponseLast"], responseText);
			this.setState({
				activeStructureContext: {
					targetPath: structureContext.targetPath,
					targetLabel: structureContext.targetLabel,
					targetReadOnly: structureContext.targetReadOnly === true,
					featureName: structureContext.featureName || "",
					featureDescription: structureContext.featureDescription || "",
					additionalContextLines: Array.isArray(structureContext.additionalContextLines) ? structureContext.additionalContextLines : []
				},
				latestStructureSubtreeSpec: normalizedSubtreeSpec,
				lastStructureGenerationMode: isAnalysisRequest ? "analysis" : structureIntent.generationMode
			});
		} catch (err) {
			this.appendAssistantErrorMessage(this.getAssistantErrorMessage("Failed to process structure generation response.", err));
		} finally {
			this.stopWaitingForResponse();
		}
	}

	applyBulkEditFromAssistant() {
		const bulkEditContext = this.getBulkEditContext();
		const instructions = Array.isArray(this.state.latestBulkEditInstructions)
			? this.state.latestBulkEditInstructions
			: [];

		if (!bulkEditContext || !Array.isArray(bulkEditContext.targetPath)) {
			this.appendAssistantErrorMessage("No valid bulk edit target is selected.");
			return;
		}
		if (bulkEditContext.targetReadOnly) {
			this.appendAssistantErrorMessage("The selected bulk edit target is read-only.");
			return;
		}
		if (instructions.length === 0) {
			this.appendAssistantErrorMessage("No bulk edit plan is available to apply.");
			return;
		}

		try {
			const applyResult = applyAiBulkEditInstructions(this.context.tree, instructions, {
				selectedPath: bulkEditContext.targetPath
			});
			let newData = this.context.tree.get(["appState", "aiAssistantResponse"]);
			newData = `${newData}\n\n<i>Applied bulk edit. Changed ${applyResult.changedCount} node(s).</i>`;
			this.context.tree.set(["appState", "aiAssistantResponse"], newData);
			this.setState({
				activeBulkEditContext: null,
				latestBulkEditInstructions: null
			});
		} catch (err) {
			this.appendAssistantErrorMessage(err && err.message ? err.message : "Unable to apply bulk edit plan.");
		}
	}

	applyStructureFromAssistant(choiceKey = "") {
		const structureContext = this.getStructureContext();
		const subtreeSpec = this.getLatestStructureSubtreeSpec();
		if (!structureContext || !subtreeSpec) {
			this.appendAssistantErrorMessage("No valid structure JSON is available to apply.");
			return;
		}

		const applyChoices = this.getStructureApplyChoices(subtreeSpec);
		if (!Array.isArray(applyChoices) || applyChoices.length === 0) {
			this.appendAssistantErrorMessage("No valid apply actions are available for the generated structure and current selection.");
			return;
		}

		const applyChoice = applyChoices.find((choice) => choice.key === choiceKey) ||
			applyChoices.find((choice) => choice.recommended) ||
			applyChoices[0];
		if (!applyChoice) {
			this.appendAssistantErrorMessage("Unable to resolve an apply action for the generated structure.");
			return;
		}

		try {
			const currentChecklist = transformFromChecklistEntities(state.get(["tree", "root"]), false, false, false);
			const nextSelectionChecklistPath = this.getInsertedChecklistPathForApplyChoice(structureContext, subtreeSpec, applyChoice);
			const patchedChecklist = applySubtreeSpecV1(currentChecklist, subtreeSpec, applyChoice, {
				selectedPath: structureContext.checklistPath
			});
			const srcTree = transformToChecklistEntities(patchedChecklist);
			srcTree.root.expanded = true;
			resetTree(srcTree.root.children);

			const nextSelectionTreePath = checklistPathToTreePath(nextSelectionChecklistPath);
			this.context.tree.set("selectedChecklistId", srcTree.root.id);
			this.context.tree.set(["tree"], srcTree);
			handleSelectNodeAtPath(this.context.tree, nextSelectionTreePath);
			saveUndoState();
			this.context.tree.commit();

			this.setState({
				structureContext: null
			});
		} catch (err) {
			this.appendAssistantErrorMessage(`Unable to apply generated structure. ${err.message}`);
		}
	}

	render() {
		// this.renderCurrentActivity();
		// this.renderFiles();
		const currentActivityId = this.getCurrentActivityId();
		const availableModes = this.getAvailableModes();
		const selectedScriptContext = this.isScriptMode(this.state.selectedActivityOrFiles)
			? this.getScriptContextForMode(this.state.selectedActivityOrFiles)
			: null;
		const structureSubtreeSpec = this.isStructureMode(this.state.selectedActivityOrFiles)
			? this.getLatestStructureSubtreeSpec()
			: null;
		const structureApplyChoices = this.isStructureMode(this.state.selectedActivityOrFiles)
			? this.getStructureApplyChoices(structureSubtreeSpec)
			: [];
		const orderedStructureApplyChoices = Array.isArray(structureApplyChoices)
			? [...structureApplyChoices].sort((a, b) => {
				if ((a.recommended ? 1 : 0) === (b.recommended ? 1 : 0)) {
					return 0;
				}
				return a.recommended ? -1 : 1;
			})
			: [];
		const canApplyStructure = this.isStructureMode(this.state.selectedActivityOrFiles) &&
			!this.state.isWaitingForResponse &&
			!!structureSubtreeSpec &&
			orderedStructureApplyChoices.length > 0;
		const hasStructurePlanPreview = this.isStructureMode(this.state.selectedActivityOrFiles) &&
			!!structureSubtreeSpec &&
			this.state.lastStructureGenerationMode !== "analysis";
		const bulkEditContext = this.isBulkEditMode(this.state.selectedActivityOrFiles)
			? this.getBulkEditContext()
			: null;
		const canApplyBulkEdit = this.isBulkEditMode(this.state.selectedActivityOrFiles) &&
			!this.state.isWaitingForResponse &&
			!!bulkEditContext &&
			bulkEditContext.targetReadOnly !== true &&
			Array.isArray(this.state.latestBulkEditInstructions) &&
			this.state.latestBulkEditInstructions.length > 0;
		const hasBulkEditPlanPreview = this.isBulkEditMode(this.state.selectedActivityOrFiles) &&
			Array.isArray(this.state.latestBulkEditInstructions) &&
			this.state.latestBulkEditInstructions.length > 0;
		const latestScriptCode = this.isScriptMode(this.state.selectedActivityOrFiles)
			? extractCodeFromAssistantResponse(this.props.aiAssistantResponseLast || "")
			: "";
		const canInsertScript = !!(
			selectedScriptContext &&
			Array.isArray(selectedScriptContext.targetPath) &&
			!selectedScriptContext.targetReadOnly &&
			latestScriptCode.trim() !== "" &&
			!this.state.isWaitingForResponse
		);
		const canInsertDraft = this.isDraftMode(this.state.selectedActivityOrFiles) && this.canApplyDraftContent();
		const canApplyDriveTags = this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE &&
			!this.state.isWaitingForResponse &&
			!!this.getSelectedDriveAssetResource() &&
			this.isLikelyDriveTagList(this.getTagsFromAssistantResponse(this.props.aiAssistantResponseLast || ""));
		const canApplyDriveDescription = this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE &&
			!this.state.isWaitingForResponse &&
			!!this.getSelectedDriveAssetResource() &&
			this.isLikelyDriveDescription(this.getDescriptionFromAssistantResponse(this.props.aiAssistantResponseLast || ""));
		const canApplyDriveTranscript = this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE &&
			!this.state.isWaitingForResponse &&
			!!this.getSelectedDriveAssetResource() &&
			this.isLikelyDriveTranscript(this.getTranscriptFromAssistantResponse(this.props.aiAssistantResponseLast || ""));
		const canApplyDriveTitle = this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE &&
			!this.state.isWaitingForResponse &&
			!!this.getSelectedDriveAssetResource() &&
			this.isLikelyDriveTitle(this.getTitleFromAssistantResponse(this.props.aiAssistantResponseLast || ""));
		const focusedEditableSourceForPrompt = this.getFocusedExternalEditableSource();
		const canInsertPromptFromField = this.isDraftMode(this.state.selectedActivityOrFiles) &&
			!this.state.isWaitingForResponse &&
			!!focusedEditableSourceForPrompt;
		const snippetBlocks = this.getResponseSnippetBlocks();
		const hasSnippetTab = Array.isArray(snippetBlocks) && snippetBlocks.length > 0;
		const responseViewTab = hasSnippetTab ? this.state.responseViewTab : "response";
		const modePanelCollapsed = this.state.modePanelCollapsed === true;
		const getTabButtonStyle = (isActive) => ({
			borderRadius: "7px",
			padding: "4px 10px",
			fontSize: "12px",
			fontWeight: 600,
			backgroundColor: isActive ? "#2b7de9" : "#1a2d46",
			borderColor: isActive ? "#2b7de9" : "#2f4d73",
			color: "#ffffff"
		});
		const responseActionButtonStyle = {
			borderRadius: "7px",
			padding: "4px 10px",
			fontSize: "12px"
		};

		return (
			// <div style={{ width: "100%", height: "100%" }}>
			<div
				id="app-ai-assistant-root"
				data-ai-assistant-root="true"
				ref={(node) => { this.assistantRootEl = node; }}
				style={{ display: "flex", flexDirection: "column", height: "100%", gap: "10px" }}
			>
				<div style={{
					flex: "0 0 auto",
					flexShrink: 0,
					minHeight: modePanelCollapsed ? "58px" : "190px",
					maxHeight: modePanelCollapsed ? "92px" : "42%",
					overflow: "hidden",
					border: "1px solid #2d3f57",
					borderRadius: "10px",
					backgroundColor: "#0f1827",
					display: "flex",
					flexDirection: "column"
				}}>
					<div style={{
						flex: "0 0 auto",
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						padding: "8px 10px",
						borderBottom: modePanelCollapsed ? "none" : "1px solid #2d3f57",
						backgroundColor: "#101a2b"
					}}>
						<div style={{ color: "#bcd1ea", fontWeight: 600, fontSize: "13px" }}>Assistant Mode</div>
						<Button
							bsStyle="primary"
							style={{
								borderRadius: "7px",
								padding: "2px 8px",
								backgroundColor: "#1a2d46",
								borderColor: "#2f4d73",
								color: "#ffffff"
							}}
							onClick={() => this.setState({ modePanelCollapsed: !modePanelCollapsed })}
						>
							<FontAwesomeIcon icon={modePanelCollapsed ? "chevron-down" : "chevron-up"} />
						</Button>
					</div>

					{modePanelCollapsed
						? <div style={{ flex: 1, minHeight: 0, padding: "10px 12px" }}>
							{this.renderCollapsedModeSummary()}
						</div>
						: <div style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", padding: "10px 12px" }}>
							{this.renderSelectActivityOrFiles()}
							{this.renderModeCarryOverBanner()}
							{this.state.selectedActivityOrFiles === "files" && availableModes.includes("files") &&
								<div style={{ flex: 0, marginLeft: "32px", marginTop: "10px", color: "#a8b8cd" }}>
									<label>Upload File</label>
									<div>
									<input type="file" /*accept=".*" */ onChange={async (event) => {
										console.log("Selected file:", event.target.files[0]);
										try {
											await uploadAiFile(env.s3.aiBucket, "openai/files/" + this.props.user.identityId, event.target.files[0]);
										} catch (e) {
											console.log(e);
										}
									}} />
									</div>
								</div>
							}
						</div>
					}
				</div>

				<div style={{ flex: 1, minHeight: 0, border: "1px solid #2d3f57", borderRadius: "10px", backgroundColor: "#0b121e", display: "flex", flexDirection: "column", overflow: "hidden" }}>
					<div style={{ flex: "0 0 auto", display: "flex", alignItems: "center", gap: "8px", padding: "8px 10px", borderBottom: "1px solid #2d3f57", backgroundColor: "#101a2b" }}>
						<Button
							bsStyle="primary"
							style={getTabButtonStyle(responseViewTab === "response")}
							onClick={() => this.setState({ responseViewTab: "response" })}
						>
							Response
						</Button>
						{hasSnippetTab &&
							<Button
								bsStyle="primary"
								style={getTabButtonStyle(responseViewTab === "snippets")}
								onClick={() => this.setState({ responseViewTab: "snippets" })}
							>
								Snippets
							</Button>
						}
					</div>

						<div id="openai-markdown2" style={{ flex: 1, minHeight: 0, overflow: "auto", padding: "12px", color: "#dce8f8" }}>
							{responseViewTab === "snippets"
								? this.renderResponseSnippets(snippetBlocks)
								: <>
									{!(hasBulkEditPlanPreview || hasStructurePlanPreview) &&
										<div dangerouslySetInnerHTML={createMarkupForLabel(this.props.aiAssistantResponse)} />
									}
									{this.renderStructurePlanPreview()}
									{this.renderBulkEditPlanPreview()}
									{this.state.isWaitingForResponse &&
										<div style={{
											display: "flex",
										alignItems: "center",
										gap: "8px",
										marginTop: "10px",
										paddingTop: "10px",
										borderTop: "1px dashed #2d3f57",
										color: "#9ec0e8",
										fontStyle: "italic"
									}}>
										<FontAwesomeIcon icon="spinner" spin />
										<span>{this.state.hasReceivedResponseChunk ? "Assistant is responding..." : "Assistant is thinking..."}</span>
									</div>
								}
							</>
						}
					</div>
					<div style={{
						flex: "0 0 auto",
						display: "flex",
						alignItems: "center",
						flexWrap: "wrap",
						gap: "6px",
						padding: "8px 10px",
						borderTop: "1px solid #2d3f57",
						backgroundColor: "#0f1827"
					}}>
						{this.isStructureMode(this.state.selectedActivityOrFiles) &&
							orderedStructureApplyChoices.map((choice, index) => <Button
								key={choice.key || index}
								style={{
									...responseActionButtonStyle,
									backgroundColor: choice.recommended ? "#255ca1" : "#1d4f8a",
									borderColor: choice.recommended ? "#3069af" : "#2a629e"
								}}
								bsStyle="primary"
								disabled={!canApplyStructure}
								onClick={() => this.applyStructureFromAssistant(choice.key)}
							>
								{choice.label}
							</Button>)
						}
						{this.isBulkEditMode(this.state.selectedActivityOrFiles) &&
							<Button
								style={{ ...responseActionButtonStyle, backgroundColor: "#255ca1", borderColor: "#3069af" }}
								bsStyle="primary"
								disabled={!canApplyBulkEdit}
								onClick={() => this.applyBulkEditFromAssistant()}
							>
								Apply Bulk Edit
							</Button>
						}
						{this.isScriptMode(this.state.selectedActivityOrFiles) &&
							<>
								<Button
									style={{ ...responseActionButtonStyle, backgroundColor: "#255ca1", borderColor: "#3069af" }}
									bsStyle="primary"
									disabled={!canInsertScript}
									onClick={() => this.insertScriptFromAssistant({ replace: false })}
								>
									Insert
								</Button>
								<Button
									style={{ ...responseActionButtonStyle, backgroundColor: "#1d4f8a", borderColor: "#2a629e" }}
									bsStyle="primary"
									disabled={!canInsertScript}
									onClick={() => this.insertScriptFromAssistant({ replace: true })}
								>
									Replace
								</Button>
							</>
						}
							{this.isDraftMode(this.state.selectedActivityOrFiles) &&
								<>
								<Button
									style={{ ...responseActionButtonStyle, backgroundColor: "#255ca1", borderColor: "#3069af" }}
									bsStyle="primary"
									disabled={!canInsertDraft}
									onClick={() => this.insertDraftFromAssistant({ replace: false })}
								>
									Insert
								</Button>
									<Button
										style={{ ...responseActionButtonStyle, backgroundColor: "#1d4f8a", borderColor: "#2a629e" }}
										bsStyle="primary"
										disabled={!canInsertDraft}
										onClick={() => this.insertDraftFromAssistant({ replace: true })}
									>
										Replace
									</Button>
								</>
							}
							{this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE &&
								<>
									<Button
										style={{ ...responseActionButtonStyle, backgroundColor: "#255ca1", borderColor: "#3069af" }}
										bsStyle="primary"
										disabled={!canApplyDriveTags}
										onClick={async () => {
											await this.applyDriveTagsFromLatestResponse();
										}}
									>
										Set Tags
									</Button>
									<Button
										style={{ ...responseActionButtonStyle, backgroundColor: "#2a5f8e", borderColor: "#3474aa" }}
										bsStyle="primary"
										disabled={!canApplyDriveTitle}
										onClick={async () => {
											await this.applyDriveTitleFromLatestResponse();
										}}
									>
										Set Title
									</Button>
									<Button
										style={{ ...responseActionButtonStyle, backgroundColor: "#1f4d88", borderColor: "#2f68ab" }}
										bsStyle="primary"
										disabled={!canApplyDriveDescription}
										onClick={async () => {
											await this.applyDriveDescriptionFromLatestResponse();
										}}
									>
										Set Description
									</Button>
									<Button
										style={{ ...responseActionButtonStyle, backgroundColor: "#245487", borderColor: "#3b76b5" }}
										bsStyle="primary"
										disabled={!canApplyDriveTranscript}
										onClick={async () => {
											await this.applyDriveTranscriptFromLatestResponse();
										}}
									>
										Set Transcript
									</Button>
								</>
							}
							<Button
								style={{ ...responseActionButtonStyle, backgroundColor: "#1f3048", borderColor: "#304866" }}
								bsStyle="primary"
								onClick={() => {
									const copyText = hasBulkEditPlanPreview
										? JSON.stringify(this.getBulkEditRawPayload(), null, 2)
										: hasStructurePlanPreview
											? JSON.stringify(this.getStructureRawPayload().structure, null, 2)
										: this.props.aiAssistantResponseLast;
									copyToClipboard(copyText);
								}}
							>
								<FontAwesomeIcon icon="copy" /> Copy Full Response
							</Button>
							<Button
								style={{ ...responseActionButtonStyle, backgroundColor: "#2f3a4d", borderColor: "#4b5c78" }}
								bsStyle="primary"
								onClick={() => this.handleNewChatClick()}
							>
								New Chat
							</Button>
						</div>
				</div>

				<div style={{ flex: "0 0 auto", flexShrink: 0, display: "flex", flexDirection: "column", border: "1px solid #2d3f57", borderRadius: "10px", backgroundColor: "#0f1827", padding: "12px" }}>
					{this.renderPromptAttachmentComposer()}
					<textarea ref="inputAiMessage" style={{ height: "110px", marginTop: "0px", marginBottom: "10px", borderRadius: "8px", border: "1px solid #58739a", backgroundColor: "#f5f9ff", color: "#1a2535" }} className="form-control" placeholder="Enter your message..." value={this.state.inputAiMessage} onChange={(e) => {
						this.setState({
							inputAiMessage: e.target.value
						});
					}} />
						<div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "8px" }}>
							<Button disabled={this.state.inputAiMessage === "" || this.state.isWaitingForResponse} style={{ color: "white", backgroundColor: "#2b7de9", borderColor: "#2b7de9", minWidth: "84px", borderRadius: "8px", fontWeight: 600 }} onClick={async () => {
								// getContent(this.props.aiAssistantId, item.id);

								if (this.isScriptMode(this.state.selectedActivityOrFiles)) {
									await this.runScriptModeRequest(this.state.selectedActivityOrFiles);
								} else if (this.isDraftMode(this.state.selectedActivityOrFiles)) {
									await this.runDraftModeRequest(this.state.selectedActivityOrFiles);
								} else if (this.isBulkEditMode(this.state.selectedActivityOrFiles)) {
									await this.runBulkEditModeRequest();
								} else if (this.isStructureMode(this.state.selectedActivityOrFiles)) {
									await this.runStructureModeRequest();
								} else if (this.isActivityAnalysisMode(this.state.selectedActivityOrFiles)) {
									await this.runActivityAnalysisModeRequest();
								} else if (this.state.selectedActivityOrFiles === DRIVE_ASSET_ASSISTANT_MODE) {
									await this.runDriveAssetModeRequest();
								} else if (this.state.selectedActivityOrFiles === "authoring") {
									await this.runAuthoringModeRequest();
								} else if (this.state.selectedActivityOrFiles === "activity") {
								if (!availableModes.includes("activity") || currentActivityId === "") {
									this.appendAssistantErrorMessage("Activity context is not available on this screen.");
									return;
								}

									this.appendConversationHeader(this.state.inputAiMessage, "activity");
									this.startWaitingForResponse();
									getContentStreamed(smd, parser, null, this.props.aiAssistantId, this.state.threadId, this.state.inputAiMessage, state.get(["user", "identityId"]), currentActivityId);
								} else if (this.state.selectedActivityOrFiles === "files") {
								if (!availableModes.includes("files")) {
									this.appendAssistantErrorMessage("File-based assistant mode is only available while authoring an activity with AI enabled.");
									return;
								}

								if (!this.props.aiAssistantId || this.props.aiAssistantId === "") {
									this.appendAssistantErrorMessage("AI Assistant is not initialized for this activity. Toggle AI Assistant off/on in category properties and try again.");
									return;
								}

								let threadId = this.state.threadId;
								if (!threadId) {
									threadId = await this.createThreadIfNeeded();
								}
								if (!threadId) {
									this.appendAssistantErrorMessage("Unable to initialize assistant thread. Please try again.");
									return;
								}

									this.appendConversationHeader(this.state.inputAiMessage, "files");
									this.startWaitingForResponse();
									getContentStreamed(smd, parser, null, this.props.aiAssistantId, threadId, this.state.inputAiMessage);
								} else if (this.state.selectedActivityOrFiles === "org") {
									this.appendConversationHeader(this.state.inputAiMessage, "org");
									this.startWaitingForResponse();
									getContentStreamed(smd, parser, null, this.props.aiAssistantId, this.state.threadId, this.state.inputAiMessage, state.get(["user", "identityId"]), currentActivityId, getOrgId());
							}
						}}>
							{this.state.isWaitingForResponse ?
								<span><FontAwesomeIcon icon="spinner" spin />&nbsp;Working</span>
								: "Run"
							}
						</Button>
						{this.isDraftMode(this.state.selectedActivityOrFiles) &&
							<div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", justifyContent: "flex-end" }}>
								<Button
									style={{ ...responseActionButtonStyle, backgroundColor: "#274567", borderColor: "#365b87", whiteSpace: "nowrap" }}
									bsStyle="primary"
									bsSize="small"
									disabled={!canInsertPromptFromField}
									title="Insert focused field into prompt"
									onClick={() => this.insertPromptFromFocusedInput({ replace: false })}
								>
									Insert Field
								</Button>
								<Button
									style={{ ...responseActionButtonStyle, backgroundColor: "#1f3a58", borderColor: "#2f5178", whiteSpace: "nowrap" }}
									bsStyle="primary"
									bsSize="small"
									disabled={!canInsertPromptFromField}
									title="Replace prompt with focused field"
									onClick={() => this.insertPromptFromFocusedInput({ replace: true })}
								>
									Replace Field
								</Button>
							</div>
						}
					</div>

				</div>

			</div>
			// </div>
		);
	}
}

AiAssistant.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	user: ["user"],
	activityId: ["tree", "root", "id"],
	aiAssistantId: ["tree", "root", "entity", "aiAssistantId"],
	rootAssistantFiles: ["tree", "root", "entity", "aiAssistantFiles"],
	rootAssistantChecklistFiles: ["tree", "root", "entity", "aiAssistantChecklistFiles"],
	aiAssistantResponse: ["appState", "aiAssistantResponse"],
	aiAssistantResponseLast: ["appState", "aiAssistantResponseLast"],
	aiAssistantLaunchRequest: ["appState", "aiAssistantLaunchRequest"],
	aiAssistantFocusedTarget: ["appState", "aiAssistantFocusedTarget"],
	driveActiveCursor: ["drive", "hierarchyActiveCursor"],
	driveGuidToResource: ["drive", "guidToResource"]
	// newFiles: ['tree', 'root', 'entity', 'aiAssistantFiles']
}, AiAssistant);
